<template>
  <div 
    :style="fullscreen ? {
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      width: '100%',
      height: '100vh',
      zIndex: 9998,
      backgroundColor: '#fff',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    } : {
      width: '100%',
      height: '100%'
    }"
  >
    <!-- Overlay de carga mientras se guarda -->
    <v-overlay :value="saving" opacity="0.9" z-index="9999">
      <div style="display: flex; flex-direction: column; align-items: center; gap: 24px;">
        <v-progress-circular indeterminate size="80" color="white"></v-progress-circular>
      </div>
    </v-overlay>

    <div 
      ref="container" 
      style="z-index: 1; flex: 1; overflow-y: hidden;"
      class="d-flex flex-column"
    >
      <!-- INICIO PRIMER CARD POS (HEADER Y DATOS DE FACTURA) -->
      <v-card style="flex-shrink: 0; overflow: visible;">
        <!-- Cabecera Expandible -->
        <v-card-text class="px-4 py-4 white">
          <v-row no-gutters class="d-flex align-center justify-space-between">
            <!-- Sección Izquierda: "Nuevo DTE" + Cliente -->
            <v-col cols="12" sm="6" class="d-flex align-center ga-2 mb-2 mb-sm-0">
              <span class="flex-auto text-h6 font-weight-bold mr-1">
                {{ form.idinvoice && !form.idinvoice.includes('temp') ? 'Editar DTE' : 'Nuevo DTE' }}: 
              </span>
              <CustomAutoComplete
                :hide-details="true"
                style="flex: 1;"
                key="Customer"
                v-if="allCustomers.length > 0"
                :label="'Cliente'"
                v-model="form.idcustomer"
                :search="{ branch, business, enablenegativeitem: 0, pricelist: PriceListSelected, filteredFrom: 2 }"
                :items="allCustomers"
                :item-text="'itemText'"
                :filter-endpoint="$API.customers.filterCustomers"
                :item-value="'ID_Customer'"
                :customText="form.legalname || form.idcustomernombre"
                @select="
                  (e) => {
                    form.idcustomer = e;
                    customerSelected(allCustomers.find(c => c.ID_Customer === e));
                    updateTempInvoiceField();
                  }
                "
                @updateItems="updateCustomersList"
              />
            </v-col>

            <!-- Sección Derecha: Botones + Expandir/Contraer -->
            <v-col cols="12" sm="auto"
              class="customer-actions d-flex align-center flex-wrap justify-end">
              <InnovaButton
                :icon="fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'"
                @click.stop="toggleFullscreen()"
                color="primary"
                :title="fullscreen ? 'Salir de pantalla completa' : 'Pantalla completa'"
                rounded
              >
              </InnovaButton>

              <InnovaButton
                color="primary"
                @click="searchCustomerDialog = true"
                title="Buscar cliente"
                prependIcon="mdi-magnify"
              >
                Buscar
              </InnovaButton>

              <InnovaButton
                color="primary"
                @click="searchSeveralCustomer(); updateTempInvoiceField()"
                title="Cliente varios"
                prependIcon="mdi-account-multiple"
              >
                Varios
              </InnovaButton>

              <InnovaButton
                v-if="posrestaurant"
                color="primary"
                @click="searchDomicilioCustomer(); updateTempInvoiceField()"
                title="Cliente domicilio"
                prependIcon="mdi-truck-delivery"
              >
                Domicilio
              </InnovaButton>

              <InnovaButton
                color="primary"
                @click="showCustomer = true"
                title="Editar cliente"
                prependIcon="mdi-account-edit"
              >
                Editar
              </InnovaButton>

              <InnovaButton
                v-if="posrestaurant && !mype"
                color="primary"
                @click="showSearchCustomerTableDialog = true"
                title="Seleccionar mesa"
                prependIcon="mdi-table"
              >
                Mesas
              </InnovaButton>

              <InnovaButton
                icon="mdi-chevron-up"
                v-if="togglehide"
                @click.stop="togglehide = !togglehide"
                color="primary"
                class="ml-3"
                rounded
              >
              </InnovaButton>

              <InnovaButton
                icon="mdi-chevron-down"
                v-if="!togglehide"
                @click.stop="togglehide = !togglehide"
                color="primary"
                class="ml-3"
                rounded
              >
              </InnovaButton>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- Mensaje de campos faltantes cuando header plegado -->
        <v-card-text v-if="!togglehide && missingRequiredFieldsLabels.length > 0" class="pa-2" style="background-color: #fff9c4; cursor: pointer;"  @click.stop="togglehide = !togglehide">
          <v-row no-gutters class="d-flex align-center justify-center warning--text">
            <v-icon  small class="mr-2 warning--text">mdi-alert-circle-outline</v-icon>
            <span style="font-weight: bold;">Faltan campos requeridos: {{ missingRequiredFieldsLabels.join(', ') }}</span>
          </v-row>
        </v-card-text>

        <!-- Contenido Expandible -->
        <v-form ref="headerForm">
          <v-card-text v-show="togglehide" class="pt-6 white">
            <v-row>
              <!-- Fecha -->
              <v-col cols="12" lg="3" md="4" sm="6">
                <date-picker
                  label="Fecha"
                  v-model="form.invoicedate"
                  @dateSelected="(param) => {
                    form.invoicedate = param;
                    updateTempInvoiceField();
                  }"
                  dense
                  :rules="required"
                >
                </date-picker>
              </v-col>

            <!-- Tipo de Documento -->
            <v-col cols="12" lg="3" md="4" sm="6">
              <v-select
                outlined
                dense
                :menu-props="{ zIndex: 2000 }"
                v-model="form.invoicetype"
                @change="(value) => {
                  updateTempInvoiceField()
                }"
                :items="filterType"
                item-text="name"
                item-value="key"
                label="Tipo de Documento"
                class="fast-ease-in-transitioned-element"
                :rules="required"
              >
              </v-select>
            </v-col>

            <!-- Método de Pago -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.isquote == 0 && pospayments == 0">
              <v-select
                outlined
                dense
                v-model="form.invoicepaymenttype"
                @change="(value) => {
                  updateTempInvoiceField()
                }"
                :menu-props="{ zIndex: 2000 }"
                :items="paymentTypes"
                item-text="Valores"
                item-value="Valores"
                label="Método de pago"
                class="fast-ease-in-transitioned-element"
                :rules="required"
              >
              </v-select>
            </v-col>

            <!-- Estado de la Factura -->
            <v-col cols="12" lg="3" md="4" sm="6">
              <v-select
                outlined
                dense
                :menu-props="{ zIndex: 2000 }"
                v-model="form.invoicestatusdescription"
                :items="checkCountryInvoiceStatuses"
                label="Estado de la factura"
                :rules="invoiceStatusRules"
                @change="(value) => {
                  updateTempInvoiceField()
                }"
              >
              </v-select>
            </v-col>

            <!-- Días de Crédito (Condicional) -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicestatusdescription == 'Crédito'">
              <v-select
                outlined
                dense
                v-model="form.invoicecreditday"
                :menu-props="{ zIndex: 2000 }"
                :items="creditDays"
                label="Días de crédito"
                :readonly="readOnlyCreditDays()"
                :rules="required"
                @change="updateTempInvoiceField()"
              >
              </v-select>
            </v-col>

            <!-- Número de Referencia (Condicional) -->
            <v-col cols="12" lg="3" md="4" sm="6"
            v-if="
              form.invoicepaymenttype != 'Billetes y monedas' &&
              form.invoicepaymenttype != undefined &&
              form.invoicepaymenttype != '' &&
              form.invoicetype != 'DND' &&
              form.invoicetype != 'DNC'"
            >
              <v-text-field
                outlined
                dense
                v-model="form.invoicereference"
                @input="(value) => {
                  updateTempInvoiceField()
                }"
                label="N. Referencia"
              >
              </v-text-field>
            </v-col>

            <!-- CAMPOS DE COMPROBANTE DE DONACIÓN (CDD) -->
            <!-- Código de documento asociado (CDD) -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'CDD'">
              <v-select
                outlined
                dense
                v-model="form.codasociado"
                :menu-props="{ zIndex: 2000 }"
                :items="codigosAsociados"
                item-value="id"
                item-text="valor"
                label="Código de documento asociado"
                class="fast-ease-in-transitioned-element"
                :rules="required"
                @input="updateTempInvoiceField()"
              >
              </v-select>
            </v-col>

            <!-- CAMPOS DE EXPORTACIÓN (FEX) -->
            <!-- Código de documento asociado (FEX) -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX'">
              <v-select
                outlined
                dense
                v-model="form.codasociado"
                :menu-props="{ zIndex: 2000 }"
                :items="codigosAsociadosEx"
                item-value="id"
                item-text="valor"
                label="Código de documento asociado"
                class="fast-ease-in-transitioned-element"
                @input="updateTempInvoiceField()"
              >
              </v-select>
            </v-col>

            <!-- Documento asociado -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'CDD' || form.invoicetype == 'FEX'">
              <v-text-field
                v-model="form.docasociado"
                dense
                outlined
                label="Documento asociado"
                :rules="required"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- Detalle de documento asociado -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'CDD' || form.invoicetype == 'FEX'">
              <v-text-field
                v-model="form.detalleasociado"
                dense
                outlined
                label="Detalle de documento asociado"
                :rules="required"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- Modo de transporte -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && form.codasociado == 4">
              <v-select
                outlined
                dense
                v-model="form.modotransp"
                :menu-props="{ zIndex: 2000 }"
                :items="modoTransporte"
                item-value="id"
                item-text="valor"
                label="Modo de transporte"
                class="fast-ease-in-transitioned-element"
                @input="updateTempInvoiceField()"
              >
              </v-select>
            </v-col>

            <!-- N. identificación de conductor -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && form.codasociado == 4">
              <v-text-field
                v-model="form.numconductor"
                dense
                outlined
                label="N. identificación de conductor"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- Nombre del conductor -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && form.codasociado == 4">
              <v-text-field
                v-model="form.nombreconductor"
                dense
                outlined
                label="Nombre del conductor"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- Placa del transporte -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && form.codasociado == 4">
              <v-text-field
                v-model="form.placatrans"
                dense
                outlined
                label="Placa del transporte"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- Seguro -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX'">
              <v-text-field
                v-model="form.seguro"
                type="number"
                dense
                outlined
                label="Seguro"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- Flete -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX'">
              <v-text-field
                v-model="form.flete"
                type="number"
                dense
                outlined
                label="Flete"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- Bienes Remitidos a Títulos de (DNR) -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'DNR'">
              <v-select
                outlined
                dense
                v-model="form.bientitulo"
                :menu-props="{ zIndex: 2000 }"
                :items="bienTitulo"
                item-value="id"
                item-text="value"
                label="Bienes Remitidos a Títulos de"
                class="fast-ease-in-transitioned-element"
                :rules="required"
                @input="updateTempInvoiceField()"
              >
              </v-select>
            </v-col>

            <!-- CAMPOS ESPECIALES PARA KEYMASTER (Solo exportador específico) -->
            <!-- Puerto de salida -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'">
              <v-text-field
                v-model="form.portofdeparture"
                dense
                outlined
                label="PORT OF DEPARTURE / PUERTO DE SALIDA:"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- Shipment No -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'">
              <v-text-field
                v-model="form.shipmentno"
                dense
                outlined
                label="SHIPMENT No / EMBARQUE No:"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- Container No -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'">
              <v-text-field
                v-model="form.containerno"
                dense
                outlined
                label="CONTAINER No / CONTENEDOR No:"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- B/L No -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'">
              <v-text-field
                v-model="form.blno"
                dense
                outlined
                label="B/L No:"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- Vessel & Voyage -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'">
              <v-text-field
                v-model="form.vesselvoyage"
                dense
                outlined
                label="VESSEL & VOYAGE / BARCO Y VIAJE:"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- USA FDA -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'">
              <v-text-field
                v-model="form.usadfa"
                dense
                outlined
                label="USA FDA:"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- Terms of Payment -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'">
              <v-text-field
                v-model="form.termsofpayment"
                dense
                outlined
                label="TERMS OF PAYMENT / TERMINO DE PAGO:"
                @input="updateTempInvoiceField()"
              ></v-text-field>
            </v-col>

            <!-- Incoterms -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'FEX' && keyMaster == '5cab870c30545f69414b8f38e6c051ef'">
              <v-select
                outlined
                dense
                v-model="form.codincoterms"
                :menu-props="{ zIndex: 2000 }"
                :items="incoterms"
                item-value="id"
                item-text="valor"
                label="INCOTERMS:"
                class="fast-ease-in-transitioned-element"
                @change="updateTempInvoiceField()"
              >
              </v-select>
            </v-col>

            <!-- CAMPOS DE NOTAS DE CRÉDITO/DÉBITO (DNC/DND) -->
            <!-- Documento relacionado físico -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'DNC' || form.invoicetype == 'DND'">
              <v-text-field
                outlined
                dense
                v-model="form.nccodigorelacionado"
                label="Doc. relacionado fisico"
                :rules="required"
                @input="updateTempInvoiceField()"
              >
              </v-text-field>
            </v-col>

            <!-- Fecha documento relacionado -->
            <v-col cols="12" lg="3" md="4" sm="6" v-if="form.invoicetype == 'DNC' || form.invoicetype == 'DND'">
              <date-picker
                label="Fecha doc. relacionado"
                v-model="form.ncfecharelacionado"
                @dateSelected="(param) => {
                  form.ncfecharelacionado = param;
                  updateTempInvoiceField();
                }"
                dense
                class="fast-ease-in-transitioned-element"
              >
              </date-picker>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
      </v-card>
      <!-- FIN PRIMER CARD POS -->

      <!-- INICIO SEGUNDO CARD POS (PRODUCTOS/SERVICIOS) -->
      <v-card class="mb-4" style="flex: 1; overflow: hidden; display: flex; flex-direction: column;">
        <v-card-text class="px-4 py-4 white" style="height: 100%;">
          <v-row no-gutters class="d-flex" style="height: 100%;">
            <!-- Sección Izquierda: Productos/Servicios (Más Grande) -->
            <v-col cols="12" lg="7" md="8" sm="12" class="d-flex flex-column pr-4" 
              :style="gridContainerHeight"
              style="max-height: 100%;"
            >
              <!-- Búsqueda por Nombre -->
              <div class="mb-3 d-flex gap-2 align-center">
                <v-text-field
                  v-model="searchProductName"
                  outlined
                  dense
                  label="Buscar por nombre"
                  placeholder="Ingrese nombre del producto"
                  clearable
                  hide-details
                  style="flex: 1;"
                  @keyup.enter="searchProducts(true)"
                ></v-text-field>
                <InnovaButton
                  color="primary"
                  @click="searchProducts()"
                  rounded
                  prependIcon="mdi-magnify"
                >
                  Buscar
                </InnovaButton>
              </div>
              <div class="mb-3 d-flex align-center flex-wrap justify-end selector-actions">
               
                  <v-select
                    v-model="warehouseSelected"
                    :items="warehouses"
                    @change="getPriceListSelected()"
                    item-text="Warehouse"
                    item-value="ID_Warehouse"
                    outlined
                    dense
                    label="Seleccione almacén"
                    hide-details
                  ></v-select>
                  <v-select
                    v-model="PriceListSelected"
                    :items="priceListData"
                    item-text="id"
                    item-value="id"
                    @change="getPriceListSelected()"
                    outlined
                    dense
                    label="Seleccione lista de precios"
                    hide-details
                  ></v-select>
              </div>
              

              <!-- Grid de Productos/Servicios CON SCROLL -->
              <div 
                @scroll="onProductsScroll" 
                ref="productsContainer" 
                class="d-flex flex-column"
                style="flex: 1; overflow-y: auto; overflow-x: hidden; border: 1px solid #e0e0e0; border-radius: 4px; max-height: 100%; min-height: 0;"
              >
                <div class="text-subtitle2 font-weight-bold px-0 pt-1" style="position: sticky; top: 0; background: white; z-index: 1;">
                  <!-- Checkboxes: Productos y Servicios -->
                      <div class="d-flex align-center flex-wrap py-1">

                        <v-col cols="12" sm="3" class="py-0 align-center">
                          <v-switch
                            v-model="modeList"
                            @change="onModeListChange"
                            inset
                            dense
                            label="Categorías"
                            class="mt-0 mb-0"
                            hide-details
                          ></v-switch>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                          <v-checkbox
                            v-show="navigationLevel === 3 || !modeList"
                            v-model="showProducts"
                            label="Productos"
                            dense
                            hide-details
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                          <v-checkbox
                          v-show="navigationLevel === 3 || !modeList"
                            v-model="showServices"
                            label="Servicios"
                            dense
                            hide-details
                          ></v-checkbox>
                        </v-col>
                        
                        <!-- Breadcrumb row -->
                        <v-col v-if="modeList && navigationLevel > 0" cols="12" class="d-flex align-center py-0" style="gap: 8px;">
                          <!-- Breadcrumb -->
                          <div class="d-flex align-center" style="flex: 1; overflow-x: auto; overflow-y: hidden; gap: 4px;">
                            <v-btn
                              x-small
                              text
                              color="primary"
                              @click="navigateToBreadcrumbLevel(0, null)"
                              title="Volver a Familias"
                              style="padding: 0 4px; min-width: auto; flex-shrink: 0;"
                            >
                              <v-icon small left>mdi-home</v-icon>
                            </v-btn>
                            
                            <div v-for="(crumb, index) in navigationBreadcrumb" :key="crumb.level" class="d-flex align-center" style="gap: 4px; flex-shrink: 0;">
                              <v-btn
                                v-if="crumb.level > 0"
                                x-small
                                text
                                color="primary"
                                @click="navigateToBreadcrumbLevel(crumb.level, crumb.id)"
                                :title="`Ir a ${crumb.label}`"
                                style="padding: 0 4px; min-width: auto; white-space: nowrap;"
                              >
                                <span style="font-size: 1em;">{{ crumb.label?.toUpperCase() }}</span>
                              </v-btn>
                              <span v-if="index < navigationBreadcrumb.length - 1" style="color: #999; margin: 0; font-size: 0.9em; flex-shrink: 0;">/</span>
                            </div>
                          </div>
                          
                          <!-- Botón Atrás -->
                          <v-btn 
                            small
                            color="primary"
                            @click="goBack"
                            title="Volver atrás"
                            icon
                            style="flex-shrink: 0;"
                          >
                            <v-icon>mdi-arrow-left</v-icon>
                          </v-btn>
                        </v-col>
                        
                        <!-- Contador cuando no estamos en navegación -->
                        <v-col v-else cols="12" sm="3" class="d-flex align-center justify-end py-0">
                          <span>({{ displayedProductsAndServices.length }} de {{ filteredProductsAndServices.length }})</span>
                        </v-col>
                      </div>
                      
                </div>
                <v-row v-if="modeList" no-gutters class="d-flex pa-1" 
                  style="flex: 0;"
                >
                  <div v-for="(item) in displayedProductsAndServices" :key="modeList ? (item._isDirect ? `direct-${item.val}` : item.id) : item.val" 
                    :style="{
                      display: item._isDirect ? 'none' : 'contents',
                    }"
                  >                    
                    <v-col 
                      cols="12" 
                      sm="6" 
                      md="4" 
                      lg="3"
                      class="pa-2 d-flex flex-column"
                    >
                      <!-- Tarjeta de navegación (familia, categoría, subcategoría) -->
                      <div
                        v-if="modeList && (navigationLevel === 0 || navigationLevel === 1 || navigationLevel === 2) && !item._isDirect"
                        class="d-flex flex-column align-center justify-center pa-2 text-center font-weight-bold cursor-pointer"
                        :style="{
                          minHeight: '100px',
                          borderRadius: '8px',
                          userSelect: 'none',
                          backgroundColor: item._isSkeleton ? '#e0e0e0' : getProductColor(item.id).main,
                          color: item._isSkeleton ? '#666' : getProductColor(item.id).contrast,
                          border: item._isSkeleton ? '2px dashed #999' : '3px solid currentColor',
                          opacity: item._isSkeleton ? 0.6 : 1
                        }"
                        @click="!item._isSkeleton && (navigationLevel === 0 ? selectFamily(item.id) : (navigationLevel === 1 ? selectCategory(item.id) : selectSubcategory(item.id)))"
                      >
                        <div style="flex: 1; display: flex; align-items: center; justify-content: center; width: 100%; font-size: 1em; font-weight: 550; text-transform: uppercase;">
                          <span v-if="item._isSkeleton">Cargando...</span>
                          <span v-else>{{ item.name || 'Sin nombre' }}</span>
                        </div>
                      </div>
                    </v-col>
                  </div>
                </v-row>
                <v-row no-gutters class="d-flex pa-1" 
                  style="flex: 0;"
                >
                  <div v-for="(item) in displayedProductsAndServices" :key="modeList ? (item._isDirect ? `direct-${item.val}` : item.id) : item.val" 
                    :style="{
                      display: modeList && !item._isDirect ? 'none' : 'contents',
                    }"
                  >
                    <v-col 
                      cols="12" 
                      sm="6" 
                      md="4" 
                      lg="3"
                      class="pa-2 d-flex flex-column"
                    >
                      <!-- Tarjeta de producto/servicio directo o cuando no estamos navegando por categorías -->
                      <div
                        class="d-flex flex-column align-center justify-center pa-2 text-center font-weight-bold cursor-pointer"
                        :style="{
                          minHeight: '100px',
                          height: '100%',
                          borderRadius: '8px',
                          userSelect: 'none',
                          backgroundColor: item._isSkeleton ? '#e0e0e0' : getProductColor(item.val).main,
                          color: item._isSkeleton ? '#666' : getProductColor(item.val).contrast,
                          opacity: item._isSkeleton ? 0.6 : (item._isDirect ? 0.9 : 1),
                          border: item._isSkeleton ? '2px dashed #999' : (item._isDirect ? '2px dashed currentColor' : 'none')
                        }"
                        :title="item._isDirect ? 'Producto/Servicio directo' : (item._isSkeleton ? 'Cargando...' : '')"
                        @click="!item._isSkeleton && addItemToInvoice(item)"
                      >
                        <div style="flex: 1; display: flex; align-items: center; justify-content: center; width: 100%; font-size: 1em; font-weight: 550; text-transform: uppercase; margin-bottom: 8px;">
                          <span v-if="item._isSkeleton">Cargando...</span>
                          <span v-else>{{ item.ID && item.ID.trim() ? item.ID.split('|')[0].trim() : 'Sin nombre' }}</span>
                        </div>
                        <div v-if="!item._isSkeleton && item.prod?.type !== 'service'" style="font-size: 0.85em; color: currentColor; opacity: 0.8; width: 100%; padding: 4px 0; text-align: center;">
                          Disp: {{ item.prod?.ItemCurrentQuantity || 0 }}
                        </div>
                        <div v-if="!item._isSkeleton" style="font-size: 1.8em; font-weight: bold; border-top: 1px solid currentColor; width: 100%; padding-top: 8px;">
                          {{ item.prod?.ItemNewPrice ? `$${parseFloat(item.prod.ItemNewPrice).toFixed(2)}` : 'N/A' }}
                        </div>
                      </div>
                    </v-col>
                  </div>
                </v-row>
              </div>
            </v-col>

            <!-- Sección Derecha: Resumen (Más Pequeña) -->
            <v-col cols="12" lg="5" md="4" sm="12" class="d-flex flex-column" style="flex: 1; display: flex; min-height: 0; height: 100%;">
              <!-- Resumen de Totales (Arriba de los tabs) -->
              <v-card class="px-4 pb-2 mb-2 pos-summary-card" style="background-color: #f9f9f9; flex-shrink: 0; border: 1px solid #e0e0e0; border-top: 2px solid #ddd; display: flex; flex-direction: column;">
                <!-- Primera fila: Gravados, Exentos, No Sujetos -->
                <v-row no-gutters class="d-flex mb-1 align-center pos-summary-breakdown" style="flex: 0;">
                  <v-col cols="12" class="text-center p-2 mt-2" v-if="mype">
                    <b>
                      Totales
                  </b>
                  </v-col>
                  <!-- Gravados -->
                  <v-col :cols="mype? 4 : 3" class="text-center pos-summary-value" style="padding: 0 4px;">
                    <div style="padding: 0;">
                      <div class="font-weight-bold" style="font-size: 0.75em; margin-bottom: 2px; line-height: 1; opacity: 0.8;">
                        {{ form.invoicetype === 'FEX' ? 'Afectas' : 'Gravados' }}
                      </div>
                      <div style="font-weight: bold; font-size: 1.5em; color: #37474F; line-height: 1;">
                        ${{ taxableTotal.toFixed(2) }}
                      </div>
                    </div>
                  </v-col>

                  <!-- Exentos - No mostrar si FEX -->
                  <v-col v-if="form.invoicetype !== 'FEX'" :cols="mype? 4 : 3" class="text-center pos-summary-value" style="padding: 0 4px;">
                    <div style="padding: 0;">
                      <div class="font-weight-bold" style="font-size: 0.75em; margin-bottom: 2px; line-height: 1; opacity: 0.8;">
                        Exentos
                      </div>
                      <div style="font-weight: bold; font-size: 1.5em; color: #37474F; line-height: 1;">
                        ${{ exemptTotal.toFixed(2) }}
                      </div>
                    </div>
                  </v-col>

                  <!-- No Sujetos - No mostrar si FEX -->
                  <v-col v-if="form.invoicetype !== 'FEX'" :cols="mype? 4 : 3" class="text-center pos-summary-value" style="padding: 0 4px;">
                    <div style="padding: 0;">
                      <div class="font-weight-bold" style="font-size: 0.75em; margin-bottom: 2px; line-height: 1; opacity: 0.8;">
                        No Sujetos
                      </div>
                      <div style="font-weight: bold; font-size: 1.5em; color: #37474F; line-height: 1;">
                        ${{ nonSubjectTotal.toFixed(2) }}
                      </div>
                    </div>
                  </v-col>

                  <!-- Propinas -->
                  <v-col cols="3" class="text-center pos-summary-tip" style="padding: 0 4px;" 
                    v-if="!mype"
                    >
                    <div style="padding: 0;">
                      <div class="d-flex" style="font-size: 0.75em; margin-bottom: 2px; line-height: 1; opacity: 0.8;">
                        <div>
                          <v-checkbox v-model="activarPropinas" dense hide-details label="% Propinas" style="margin: 0;"></v-checkbox>
                        </div>
                      </div>
                      <div style="font-weight: bold; font-size: 0.95em; line-height: 1;">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <v-text-field 
                            v-model="porcentajePropinas" 
                            type="number" 
                            outlined 
                            dense 
                            hide-details 
                            min="0" 
                            max="100" 
                            @input="activarPropinas = porcentajePropinas > 0 ? 1 : 0" 
                            class="text-right-input mb-2" 
                            :disabled="!activarPropinas"
                            style="flex: 1;">
                          </v-text-field>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <!-- Segunda fila: Subtotal, IVA (si aplica), TOTAL -->
                <div class="pos-totals-row" style="display: flex; align-items: stretch; gap: 8px;">
                  <!-- Subtotal a la izquierda -->
                  <div class="pos-total-item" style="flex: 1; display: flex; flex-direction: column; justify-content: center; padding: 2px 16px; background-color: #f0f0f0; border-radius: 4px;">
                    <div style="font-size: 0.75em; font-weight: bold; opacity: 0.9; margin-bottom: 4px;">
                      SUBTOTAL
                    </div>
                    <div style="font-size: 1.8em; font-weight: bold; line-height: 1;">
                      ${{ invoiceSubtotal.toFixed(2) }}
                    </div>
                  </div>

                  <!-- IVA en el medio si aplica -->
                  <div v-if="form.invoicetype !== 'FCF' && form.invoicetype !== 'TCKS' && form.invoicetype !== 'DNR'" class="pos-total-item" style="flex: 1; display: flex; flex-direction: column; justify-content: center; padding: 2px 16px; background-color: #f0f0f0; border-radius: 4px;">
                    <div style="font-size: 0.75em; font-weight: bold; opacity: 0.9; margin-bottom: 4px;">
                      IVA (13%)
                    </div>
                    <div style="font-size: 1.8em; font-weight: bold; line-height: 1;">
                      ${{ ivaTotal.toFixed(2) }}
                    </div>
                  </div>

                  <!-- Propina si está activada -->
                  <div v-if="nogravadaTotal > 0" class="pos-total-item" style="flex: 1; display: flex; flex-direction: column; justify-content: center; padding: 2px 16px; background-color: #f0f0f0; border-radius: 4px;">
                    <div style="font-size: 0.75em; font-weight: bold; opacity: 0.9; margin-bottom: 4px;">
                      NO GRAVADAS
                    </div>
                    <div style="font-size: 1.8em; font-weight: bold; line-height: 1;">
                      ${{ nogravadaTotal.toFixed(2) }}
                    </div>
                  </div>

                  <!-- Propina si está activada -->
                  <div v-if="activarPropinas && (form.invoicetype === 'FCF' || form.invoicetype === 'CCF')" class="pos-total-item"
                    style="flex: 1; display: flex; flex-direction: column; justify-content: center; padding: 2px 16px; background-color: #f0f0f0; border-radius: 4px;">
                    <div style="font-size: 0.75em; font-weight: bold; opacity: 0.9; margin-bottom: 4px;">
                      PROPINA
                    </div>
                    <div style="font-size: 1.8em; font-weight: bold; line-height: 1;">
                      ${{ totalPropina.toFixed(2) }}
                    </div>
                  </div>

                  <!-- TOTAL a la derecha, ocupando toda la altura -->
                  <div class="pos-grand-total" style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 2px 16px; background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%); border-radius: 4px; color: white; min-width: 140px; flex-shrink: 0;">
                    <div style="font-size: 0.75em; font-weight: bold; opacity: 0.9; margin-bottom: 4px;">
                      TOTAL
                    </div>
                    <div style="font-size: 2.2em; font-weight: bold; line-height: 1;">
                      ${{ (invoiceTotal).toFixed(2) }}
                    </div>
                  </div>
                </div>

                <!-- IVA Rete / IVA Perce (mostrar si aplica) -->
                <div v-if="ivaRete > 0 || ivaPerce > 0" style="margin-top: 8px; width: 100%;">
                  <v-row no-gutters class="mb-1">
                    <v-col cols="8" class="text-right" style="padding-right: 8px;">
                      <div style="opacity: 0.85; font-weight: bold;">
                        IVA Retención (1%)
                      </div>
                    </v-col>
                    <v-col cols="4" class="text-right">
                      <div style="font-weight: bold;">
                        ${{ ivaRete.toFixed(2) }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-if="ivaPerce > 0" no-gutters>
                    <v-col cols="8" class="text-right" style="padding-right: 8px;">
                      <div style="opacity: 0.85; font-weight: bold;">
                        IVA Percepción (1%)
                      </div>
                    </v-col>
                    <v-col cols="4" class="text-right">
                      <div style="font-weight: bold;">
                        ${{ ivaPerce.toFixed(2) }}
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Botones de acción - Una sola línea -->
                <v-row class="mt-2 pos-action-row" no-gutters>
                  <v-col :cols="buttonCols" class="pa-1 pos-action-col">
                    <v-btn
                      block
                      color="warning"
                      dark
                      small
                      @click="clearInvoice()"
                      class="pos-action-btn"
                      style="font-size: 0.9em; font-weight: bold;"
                      prependIcon="mdi-trash-can"
                    >
                      Limpiar
                    </v-btn>
                  </v-col>
                  <v-col v-if="!form.idinvoice || !form.idinvoice.includes('RTB')" :cols="buttonCols" class="pa-1 pos-action-col">
                    <v-btn
                      block
                      color="primary"
                      dark
                      small
                      @click="createOrder(true)"
                      :title="!canSaveInvoice ? 'Complete los datos requeridos' : ''"
                      class="pos-action-btn"
                      style="font-size: 0.9em; font-weight: bold;"
                      prependIcon="mdi-content-save"
                    >
                      Crear factura
                    </v-btn>
                  </v-col>
                  <v-col v-if="form.idinvoice && !form.idinvoice.includes('temp')" :cols="buttonCols" class="pa-1 pos-action-col">
                    <v-btn
                      block
                      color="primary"
                      dark
                      small
                      @click="saveInvoice()"
                      :title="!canSaveInvoice ? 'Complete los datos requeridos' : ''"
                      class="pos-action-btn"
                      style="font-size: 0.9em; font-weight: bold;"
                      prependIcon="mdi-content-save"
                    >
                      Guardar
                    </v-btn>
                  </v-col>
                  <v-col v-if="showCreateOrderButton" :cols="buttonCols" class="pa-1 pos-action-col">
                    <v-btn
                      block
                      color="primary"
                      dark
                      small
                      @click="createOrder()"
                      :disabled="!canSaveInvoice"
                      :title="!canSaveInvoice ? 'Complete los datos requeridos' : ''"
                      class="pos-action-btn"
                      style="font-size: 0.9em; font-weight: bold;"
                      prependIcon="mdi-note-plus"
                    >
                      Crear comanda
                    </v-btn>
                  </v-col>
                  <v-col v-if="form.idinvoice && !form.idinvoice.includes('temp')" :cols="buttonCols" class="pa-1 pos-action-col">
                    <v-btn
                      block
                      color="primary"
                      dark
                      small
                      @click="openSplitInvoiceDialog()"
                      class="pos-action-btn"
                      style="font-size: 0.9em; font-weight: bold;"
                      prependIcon="mdi-note-plus"
                    >
                      Separar
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row class="pos-action-row" no-gutters>
                  <v-col cols="6" class="pa-1 pos-action-col">
                    <v-btn
                      block
                      color="primary"
                      dark
                      small
                      @click="preBill(form.idinvoice)"
                      :disabled="!form.idinvoice"
                      :title="!canSaveInvoice ? 'Complete los datos requeridos' : ''"
                      class="pos-action-btn"
                      style="font-size: 0.9em; font-weight: bold;"
                      prependIcon="mdi-content-save"
                    >
                      Prefacturar
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="pa-1 pos-action-col">
                    <v-btn
                      block
                      color="success"
                      dark
                      small
                      @click="invoiceAndEmit()"
                      :disabled="!canSaveInvoice"
                      :title="!canSaveInvoice ? 'Complete los datos requeridos' : ''"
                      class="pos-action-btn"
                      style="font-size: 0.9em; font-weight: bold;"
                      prepend-icon="mdi-receipt"
                    >
                      Facturar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>

              <!-- Tabs para Factura y Comandas Activas -->
              <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
                <v-tabs v-model="summaryTab" class="" background-color="transparent" style="flex: 0; flex-shrink: 0;">
                  <v-tab>
                    <v-icon left>mdi-invoice-text-edit</v-icon>
                    Cuenta
                  </v-tab>
                  <v-tab v-if="!mype">
                    <v-icon left>mdi-clipboard-list</v-icon>
                    Comandas
                  </v-tab>
                  <v-tab>
                    <v-icon left>mdi-invoice-check</v-icon>
                    Facturas
                  </v-tab>
                </v-tabs>
              </div>

              <!-- TAB 1: FACTURA -->
              <div v-if="summaryTab === 0" class="d-flex flex-1 flex-column" style="flex: 1; display: flex; flex-direction: column; min-height: 0; gap: 0;">
              
                <!-- Contenedor scrolleable de ítems - Igual al grid de productos -->
                <div 
                  ref="invoiceContainer"
                  class="d-flex flex-column"
                  :style="{
                    maxHeight: fullscreen
                      ? '100%'
                      : ($vuetify.breakpoint.smAndDown ? 'calc(100vh - 320px)' : '550px'),
                  }"
                  style="flex: 1; overflow-y: auto; overflow-x: hidden; border: 1px solid #e0e0e0; border-radius: 4px; min-height: 0;"
                >
                  <!-- Lista de Ítems Seleccionados -->
                  <v-card v-if="productsToShow.length > 0" class="ma-0" style="border-radius: 0; border: none; box-shadow: none;">
                    <v-card-text class="pa-2">
                      <div v-for="(item, index) in productsToShow" :key="item.uuid" class="mb-3 pb-3 invoice-item-row" style="display: flex; gap: 8px; align-items: stretch; border-bottom: 1px solid #CFD8DC;">
                      <!-- Botón eliminar a la izquierda (ocupa altura completa) -->
                      <div style="display: flex; flex-direction: column; justify-content: center; flex-shrink: 0;">
                        <v-btn
                          fab
                          x-small
                          color="error"
                          @click="removeRow({ data: item })"
                        >
                          <v-icon x-small>mdi-delete</v-icon>
                        </v-btn>
                      </div>

                      <!-- Contenido principal a la derecha -->
                      <div class="invoice-item-main" style="flex: 1; min-width: 0; display: flex; flex-direction: column; padding: 2px;">
                        <!-- Primera línea: Nombre (editable) | Botón comentarios + Controles de cantidad -->
                        <div class="invoice-item-topline" style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; gap: 8px; min-width: 0; flex-wrap: wrap;">
                          <div style="display: flex; align-items: center; gap: 8px; flex: 1; min-width: 0;">
                            <div v-if="editingNameIndex === index" style="display: flex; align-items: center; gap: 4px; flex: 1; min-width: 0;">
                              <input
                                type="text"
                                v-model="item.ItemName"
                                @blur="editingNameIndex = null"
                                @keyup.enter="editingNameIndex = null"
                                style="flex: 1; padding: 4px 8px; border: 2px solid #2196F3; border-radius: 4px; font-size: 1.35em; font-weight: bold; min-width: 0;"
                                autofocus
                              />
                            </div>
                            <span 
                              v-else 
                              @click="editingNameIndex = index" 
                              style="font-size: 1.35em; font-weight: bold; word-break: break-word; cursor: pointer; padding: 4px 8px; border-radius: 4px; transition: background-color 0.2s; flex: 1; min-width: 0;"
                              @mouseenter="$event.target.style.backgroundColor = '#e0e0e0'"
                              @mouseleave="$event.target.style.backgroundColor = 'transparent'"
                              :title="item.ItemName"
                            >
                              {{ item.ItemName?.substring(0, 25) }}
                            </span>
                          </div>
                          <div class="d-flex align-center gap-1 invoice-item-actions" style="flex-wrap: wrap; justify-content: flex-end;">
                            <v-btn
                              fab
                              x-small
                              color="primary"
                              @click="openItemComments(item)"
                              title="Agregar observaciones"
                              style="margin-right: 12px;"
                              :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
                            >
                              <v-icon>mdi-pencil-plus</v-icon>
                            </v-btn>
                            <v-btn
                              fab
                              x-small
                              color="info"
                              @click="openDiscountDialog(item, index)"
                              title="Editar descuento"
                              style="margin-right: 4px;"
                              :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
                            >
                              <v-icon>mdi-percent</v-icon>
                            </v-btn>
                            <v-btn
                              fab
                              x-small
                              color="warning"
                              @click="decrementQuantity(index)"
                              :disabled="item.qty <= 1"
                            >
                              <v-icon x-small>mdi-minus</v-icon>
                            </v-btn>
                            <input
                              type="number"
                              v-model.number="item.qty"
                              @change="updateQuantity(index, $event)"
                              style="width: 50px; text-align: center; padding: 4px; border: 1px solid #ccc; border-radius: 4px; font-size: 1em;"
                              min="1"
                              step="0.01"
                              class="mx-2"
                            />
                            <v-btn
                              fab
                              x-small
                              color="success"
                              @click="incrementQuantity(index)"
                            >
                              <v-icon x-small>mdi-plus</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        
                        <!-- Segunda línea: Precio unitario | Total + Checkbox exento -->
                        <div class="invoice-item-bottomline" style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; gap: 8px; border-top: 1px solid #e0e0e0; padding-top: 4px; flex-wrap: wrap;">
                          <div class="invoice-item-price-flags">
                            <div class="invoice-item-price">
                            <div v-if="editingPriceIndex === index" style="display: flex; align-items: center; gap: 4px;">
                              <input
                                type="number"
                                v-model.number="item.ItemNewPrice"
                                @blur="updateUnitPrice(index, item.ItemNewPrice); editingPriceIndex = null"
                                @keyup.enter="updateUnitPrice(index, item.ItemNewPrice); editingPriceIndex = null"
                                style="width: 80px; text-align: center; padding: 2px; border: 1px solid #2196F3; border-radius: 4px; font-size: 1.2em;"
                                autofocus
                                step="0.01"
                                min="0"
                                :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
                              />
                            </div>
                            <span 
                              v-else 
                              @click="$store.getters['rolesUser/getArrayCustomRole']([253]) && (editingPriceIndex = index)" 
                              style="font-size: 1.5em; color: #666; cursor: pointer; padding: 4px 8px; border-radius: 4px; transition: background-color 0.2s;"
                              @mouseenter="$event.target.style.backgroundColor = $store.getters['rolesUser/getArrayCustomRole']([253]) ? '#e0e0e0' : 'transparent'"
                              @mouseleave="$event.target.style.backgroundColor = 'transparent'"
                            >
                              ${{ getDisplayedUnitPrice(item).toFixed(2) }}
                            </span>
                            </div>
                            <div class="invoice-item-tax-flags">
                            <v-checkbox
                              v-model="item.nontaxable"
                              label="Exento"
                              dense
                              hide-details
                              class="invoice-item-tax-flag"
                              :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
                              @change="syncExclusiveTaxFlags(item, 'nontaxable')"
                            ></v-checkbox>
                            <v-checkbox
                              v-model="item.nonsuj"
                              label="No Sujeto"
                              dense
                              hide-details
                              class="invoice-item-tax-flag"
                              @change="syncExclusiveTaxFlags(item, 'nonsuj')"
                              :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
                            ></v-checkbox>
                            <v-checkbox
                              v-if="posrestaurant"
                              v-model="item.nogravada"
                              label="No Gravadas"
                              dense
                              hide-details
                              class="invoice-item-tax-flag"
                              @change="syncExclusiveTaxFlags(item, 'nogravada')"
                              :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
                            ></v-checkbox>
                            </div>
                          </div>
                          <span style="font-weight: bold; font-size: 1.5em;">
                            ${{ calculateItemTotal(item).toFixed(2) }}
                          </span>
                        </div>

                        <!-- Observaciones si existen -->
                        <div v-if="item.ItemComments" style="color: #d32f2f; font-size: 1.05em; padding-top: 6px; border-top: 1px solid #e0e0e0;">
                          <strong>Observaciones:</strong> {{ item.ItemComments }}
                        </div>

                        <!-- Descuentos si existen -->
                        <div v-if="item.ItemPriceDiscountPercent > 0 || item.ItemPriceDiscountAmount > 0" style="color: #f57c00; font-size: 1.05em; padding-top: 6px; border-top: 1px solid #e0e0e0;">
                          <strong>Descuento:</strong>
                          <span v-if="item.ItemPriceDiscountPercent > 0">{{ item.ItemPriceDiscountPercent.toFixed(2) }}%</span>
                          <span v-if="item.ItemPriceDiscountAmount > 0">${{ item.ItemPriceDiscountAmount.toFixed(2) }}</span>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                  <!-- Mensaje si no hay items -->
                  <v-card v-else class="ma-0" style="border-radius: 0; border: none; box-shadow: none; background-color: #f5f5f5;">
                    <v-card-text class="text-center pa-6">
                      <v-icon size="48" color="gray" class="mb-2">mdi-cart-off</v-icon>
                      <p class="text-subtitle2 gray--text">
                        Selecciona items del catálogo
                      </p>
                    </v-card-text>
                  </v-card>
                </div>

              </div>

              <!-- TAB 2: COMANDAS ACTIVAS -->
              <div v-if="summaryTab === 1" class="d-flex flex-column" style="flex: 1;">
                <v-progress-linear v-if="loadingCommands" indeterminate></v-progress-linear>
                
                <v-card v-if="!loadingCommands && activaCommands.length > 0" class="ma-0" style="border-radius: 0; border: none; box-shadow: none; overflow: hidden;">
                  <v-card-text class="pa-2" :style="{ ...invoiceSummaryHeight, overflowY: 'auto', display: 'block' }">
                    <div v-for="comanda in activaCommands" :key="comanda.ID_Invoice" class="mb-3 pb-3" style="border-bottom: 1px solid #e0e0e0; display: flex; align-items: center; padding: 12px; border-radius: 4px; transition: background-color 0.2s;">
                      <!-- Botón de impresión a la izquierda -->
                      <v-btn
                        icon
                        small
                        color="primary"
                        @click="printActiveCommand(comanda.ID_Invoice)"
                        style="margin-right: 12px;"
                        title="Imprimir ticket"
                      >
                        <v-icon>mdi-printer</v-icon>
                      </v-btn>
                      
                      <!-- Contenido de la comanda (clic para cargar) -->
                      <div
                        style="flex: 1; cursor: pointer;"
                        @click="loadComanda(comanda.ID_Invoice)"
                        @mouseenter="$event.currentTarget.style.backgroundColor = '#f5f5f5'"
                        @mouseleave="$event.currentTarget.style.backgroundColor = 'transparent'"
                      >
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                          <span style="font-size: 1.3em; font-weight: bold; color: #1976d2;">{{ comanda.ID_Invoice }}</span>
                          <span style="font-size: 0.9em; color: #666;">{{ comanda.InvoiceDate }}</span>
                        </div>
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                          <span style="font-size: 0.95em; color: #333;">{{ comanda.ComercialName || comanda.InvoiceName }}</span>
                          <span style="font-weight: bold; font-size: 1.1em; color: #2196f3;">${{ parseFloat(comanda.InvoiceTotalPagar || 0).toFixed(2) }}</span>
                        </div>
                      </div>

                      <v-btn
                        icon
                        small
                        color="error"
                        @click="delComanda = comanda; showDelAlert = true"
                        style="margin-left: 12px;"
                        title="Imprimir ticket"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
                
                <v-card v-if="!loadingCommands && activaCommands.length === 0" style="flex: 1; display: flex; align-items: center; justify-content: center;">
                  <v-card-text class="text-center pa-6">
                    <v-icon size="64" color="gray" class="mb-4">mdi-clipboard-list-outline</v-icon>
                    <p class="text-subtitle1 gray--text">
                      No hay comandas activas
                    </p>
                  </v-card-text>
                </v-card>
              </div>

              <!-- TAB 3: FACTURAS LISTAS -->
              <div v-if="summaryTab === 2" class="d-flex flex-column" style="flex: 1;">
                <v-progress-linear v-if="loadingReadyInvoices" indeterminate></v-progress-linear>
                
                <v-card v-if="!loadingReadyInvoices && readyInvoices.length > 0" class="ma-0" style="border-radius: 0; border: none; box-shadow: none; overflow: hidden;">
                  <v-card-text class="pa-2" :style="{ ...invoiceSummaryHeight, overflowY: 'auto', display: 'block' }">
                    <div v-for="invoice in readyInvoices" :key="invoice.ID_Invoice" class="mb-3 pb-3" style="border-bottom: 1px solid #e0e0e0; display: flex; align-items: center; padding: 12px; border-radius: 4px; transition: background-color 0.2s;">
                      <!-- Contenido de la factura (clic para cargar) -->
                      <div
                        style="flex: 1; cursor: pointer;"
                        @click="loadComanda(invoice.ID_Invoice)"
                        @mouseenter="$event.currentTarget.style.backgroundColor = '#f5f5f5'"
                        @mouseleave="$event.currentTarget.style.backgroundColor = 'transparent'"
                      >
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                          <span style="font-size: 1.3em; font-weight: bold; color: #1976d2;">{{ invoice.ID_Invoice }}</span>
                          <span style="font-size: 0.9em; color: #666;">{{ invoice.InvoiceDate }}</span>
                        </div>
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                          <span style="font-size: 0.95em; color: #333;">{{ invoice.ComercialName || invoice.InvoiceName }}</span>
                          <span style="font-weight: bold; font-size: 1.1em; color: #2196f3;">${{ parseFloat(invoice.InvoiceTotalPagar || 0).toFixed(2) }}</span>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
                
                <v-card v-if="!loadingReadyInvoices && readyInvoices.length === 0" style="flex: 1; display: flex; align-items: center; justify-content: center;">
                  <v-card-text class="text-center pa-6">
                    <v-icon size="64" color="gray" class="mb-4">mdi-invoice-check-outline</v-icon>
                    <p class="text-subtitle1 gray--text">
                      No hay facturas listas
                    </p>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- FIN SEGUNDO CARD POS -->

      <!-- Diálogo de búsqueda de cliente mejorado -->
      <SearchCustomer
        v-model="searchCustomerDialog"
        @customerSelected="customerSelected"
      ></SearchCustomer>

      <!-- Diálogo de búsqueda de mesas -->
      <SearchTable
        @customerSelected="customerSelected"
        v-model="showSearchCustomerTableDialog"
        :activaCommands="activaCommands"
      ></SearchTable>

      <!-- Diálogo de observaciones adicionales -->
      <v-dialog v-model="showItemComments" scrollable max-width="300">
        <v-card height="inherit" style="overflow: auto">
          <v-card-title class="text-h5">Observaciones adicionales</v-card-title>
          <v-card-text>
            <br/>
            <v-textarea
              label="Ingrese detalles del producto/servicio"
              outlined
              v-model="commentsObject.ItemComments"
              :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
            ></v-textarea>

            <v-btn
              color="primary"
              dark
              @click="showItemComments = false"
            >
              Continuar
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Diálogo de descuentos -->
      <v-dialog v-model="showDiscountDialog" scrollable max-width="500">
        <v-card height="inherit" style="overflow: auto" v-if="discountEditingItem">
          <v-card-title class="text-h5">Editar descuento</v-card-title>
          <v-card-text>
            <v-form ref="discountForm">
              <br/>
              
              <!-- Precio original -->
              <v-text-field
                outlined
                dense
                disabled
                label="Precio original"
                :value="discountEditingItem.ItemOriginalPrice?.toFixed(2)"
                prefix="$"
              ></v-text-field>

              <!-- Precio después de descuento -->
              <v-text-field
                outlined
                dense
                disabled
                label="Precio con descuento"
                :value="calculatePriceWithDiscount().toFixed(2)"
                prefix="$"
              ></v-text-field>

              <!-- % Descuento -->
              <v-text-field
                outlined
                dense
                v-model.number="discountEditingItem.ItemPriceDiscountPercent"
                label="Descuento %"
                type="number"
                min="0"
                max="100"
                step="0.01"
                @input="calculateFromPercent"
                hint="Porcentaje de descuento"
                :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
              ></v-text-field>

              <!-- Monto Descuento -->
              <v-text-field
                outlined
                dense
                v-model.number="discountEditingItem.ItemPriceDiscountAmount"
                label="Descuento (Monto fijo)"
                type="number"
                min="0"
                step="0.01"
                @input="calculateFromAmount"
                prefix="$"
                hint="Monto fijo de descuento"
                :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
              ></v-text-field>

              <!-- Total con descuento -->
              <v-text-field
                outlined
                dense
                disabled
                label="Total (con descuento)"
                :value="`$${((discountEditingItem.ItemOriginalPrice - (discountEditingItem.ItemPriceDiscountAmount || 0)) * (discountEditingItem.qty || 1)).toFixed(2)}`"
              ></v-text-field>

              <div class="d-flex gap-2 mt-4">
                <v-btn
                  color="primary"
                  dark
                  @click="saveDiscount"
                  :disabled="!$store.getters['rolesUser/getArrayCustomRole']([253])"
                >
                  Guardar
                </v-btn>
                <v-btn
                  color="gray"
                  dark
                  @click="showDiscountDialog = false"
                >
                  Cancelar
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Diálogo de alerta -->
      <v-dialog v-model="alert.show" max-width="400">
        <v-card>
          <v-card-title :class="`text-${(alert.type || 'danger').replace('Html', '')} text-h6`">
            {{ alert.header }}
          </v-card-title>
          <v-card-text class="pt-4">
            <div v-if="alert.type && alert.type.includes('Html')" v-html="alert.body"></div>
            <div v-else>{{ alert.body }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="handleAlertClose()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Payment Method Selection Dialog -->
      <v-dialog v-model="showReturnedAndPaymentModal" scrollable max-width="1000" :z-index="500">
        <v-card height="inherit" style="overflow: auto">
          <v-card-title class="text-h5"> Método de pago </v-card-title>
          <v-card-text>
            <v-row class="mt-2">
              <v-col class="text-right">
                <v-btn @click="addPaymentType" class="btn-save">
                  <v-icon>mdi-plus</v-icon>&nbsp;Agregar tipo de pago
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <DxDataGrid :data-source="paymentsData" :show-borders="true">
                <DxEditing
                  :allow-updating="true"
                  :select-text-on-edit-start="true"
                  start-edit-action="click"
                  mode="cell"
                />
                <DxColumn width="40" cell-template="select-type-payments" caption="" header-cell-template="headerSelect"/>
                  <template #headerSelect="{}">
                    <v-icon style="cursor: pointer;" v-if="paymentTypeSelect" @click="resetSelected" color="primary">mdi-refresh</v-icon>
                  </template>
                <template #select-type-payments="{ data }">
                  <div style="padding-top: 6px;">
                      <input :value="data.rowIndex"  type="radio" name="selectedPayment" v-model="selectedPayment" id="selectedPayment" @change="(e) => selectPayment(data, e)" />
                  </div>
                </template>
                <DxColumn cell-template="type-payments" caption="Tipo de pago" />
                <template #type-payments="{ data }">
                  <div>
                    <div style="width: 100%">
                      <select
                        style="width: calc(100% - 30px); padding: 5px"
                        v-model="data.data.typePayment"
                        @change="handleTypePaymentChange(data)"
                      >
                        <option
                          v-for="(paymentType, index) in paymentTypes"
                          :key="index"
                          :value="paymentType.Codigo"
                        >
                          {{ paymentType.Valores }}
                        </option>
                      </select>
                      <v-icon>mdi-arrow-down</v-icon>
                    </div>
                  </div>
                </template>
                <DxColumn cell-template="total-payment" caption="Total" />
                <template #total-payment="{ data }">
                  <div>
                    <v-text-field
                      class="mt-0 centered-input"
                      type="number"
                      v-model="data.data.totalPayment"
                      @blur="showPaymentWithDecimal(data.data)"
                      @input="handleRowChangedPayments()"
                      @focus="onTextFieldFocus"
                      :autofocus="data.rowIndex === 0"
                      hide-details
                      dense
                      :disabled="paymentTypeSelect"
                    />
                  </div>
                </template>
                <DxColumn
                  cell-template="reference-editing"
                  caption="N. Referencia"
                />
                <template #reference-editing="{ data }">
                  <template>
                    <input
                      v-model="data.data.reference"
                      style="width: 100% !important; text-align: center"
                      :disabled="data.data.typePayment == '01'"
                    />
                  </template>
                </template>

                <DxColumn :width="50" cell-template="delete-payment" caption="" />
                <template #delete-payment="{ data }">
                  <a href="#" class="mx-1" @click="deletePayment(data.data)">
                    <v-icon color="error"> mdi-delete </v-icon>
                  </a>
                </template>
              </DxDataGrid>
            </v-row>
            <v-row class="mb-2">
              <v-col class="mt-5">
                <v-row class="d-flex justify-center">
                  <span style="color: black">Total a pagar</span>
                </v-row>
                <v-row class="d-flex justify-center">
                  <input type="text" class="form-control" :value="parseFloat(sumPayments).toFixed(2)" />
                </v-row>
              </v-col>
              <v-col class="mt-5">
                <v-row class="d-flex justify-center">
                  <span style="color: black">Cambio</span>
                </v-row>
                <v-row class="d-flex justify-center">
                  <input type="text" class="form-control" :value="parseFloat(exchangePayments).toFixed(2)" />
                </v-row>
              </v-col>
              <v-col class="mt-5">
                <v-row class="d-flex justify-center">
                  <span style="color: black">Total a cancelar</span>
                </v-row>
                <v-row class="d-flex justify-center">
                  <input
                    type="text"
                    class="totalDesign form-control"
                    :value="parseFloat(invoiceTotal).toFixed(2)"
                  />
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-col class="text-left">
              <v-btn
                @click="showReturnedAndPaymentModal = false; resetSelected();"
                class="btndelete"
              >
                Cancelar
              </v-btn>
            </v-col>
            <v-col class="text-right">
              <v-btn
                :disabled="!paymentReadyToBill || loading"
                @click="processInvoiceWithPayments()"
                class="btn-save"
              >
                <v-icon>mdi-content-save</v-icon>&nbsp;Facturar
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Invoice Result Dialog (similar a Create.vue) -->
      <alert
        v-model="invoiceResult.show"
        :title="invoiceResult.title"
        :color="invoiceResult.color"
        :altColor="invoiceResult.colorBtn"
        :titleColor="invoiceResult.colorTitle"
      >
        <div :class="`mb-3 ${['RECHAZADO', 'CONTINGENCIA'].includes(invoiceResult.estado) ? 'black--text' : 'white--text'}`">{{ invoiceResult.message }}</div>
        <template v-if="!!invoiceResult.total">
          <div class="mb-1"><span :class="`'mb-1 text-h5' ${['RECHAZADO', 'CONTINGENCIA'].includes(invoiceResult.estado) ? 'black--text' : 'primary--text'}`">Total facturado:</span> ${{invoiceResult.total}}</div>
          <div class="text-h5"><span :class="`'text-h5' ${['RECHAZADO', 'CONTINGENCIA'].includes(invoiceResult.estado) ? 'black--text' : 'primary--text'}`">Total pagado:</span> ${{invoiceResult.pagoCon}}</div>
          <div class="mt-1 text-h5"><span :class="`'text-h5' ${['RECHAZADO', 'CONTINGENCIA'].includes(invoiceResult.estado) ? 'black--text' : 'primary--text'}`">Cambio:</span> ${{invoiceResult.cambio}}</div>
        </template>
        <div class="mt-3"><span :class="`${['RECHAZADO', 'CONTINGENCIA'].includes(invoiceResult.estado) ? 'black--text' : 'primary--text'}`">Estado: </span>{{invoiceResult.estado}}</div>
        <div :class="`${['RECHAZADO', 'CONTINGENCIA'].includes(invoiceResult.estado) ? 'black--text' : 'primary--text'}`">Mensaje del Ministerio de Hacienda:</div><span>{{invoiceResult.description}}</span>
        <div>
          <span :class="`${['RECHAZADO', 'CONTINGENCIA'].includes(invoiceResult.estado) ? 'black--text' : 'primary--text'}`">Observaciones DTE:</span>
          <template v-if="!!invoiceResult.observaciones.length">
            <div :key="index" v-for="(observacion, index) in invoiceResult.observaciones">- {{observacion}}</div>
          </template>
          <div v-else>- Ninguna observación</div>   
        </div>
      </alert>

      <!-- Componentes de impresión -->
      <print-pos-tk :dataProps="print2"></print-pos-tk>

      <!-- Diálogo de información del cliente -->
      <v-dialog v-model="showCustomer" scrollable max-width="1000">
        <v-card style="overflow: auto; max-height: 95vh;">
          <v-card-title
            style="display: flex; justify-content: space-between"
          >
            <div class="text-h5">Información del cliente</div>
          </v-card-title>
          <v-card-text>
            <form v-show="showCustomer">
            <v-row class="mt-2">
              <v-col cols="12" md="6">
                <v-text-field
                  v-if="
                    form.invoicetype == 'FCF' ||
                    form.invoicetype == 'CCF'
                  "
                  outlined
                  dense
                  v-model="form.legalname"
                  :label="$t('vwinvoices_clegalname')"
                  :rules="form.invoicetype == 'CCF' ? required : []"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.legalname"
                  :label="$t('vwinvoices_clegalname')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.legaladdress"
                  :label="$t('vwinvoices_clegaladdress')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6" v-if="['452476470895e11843a44d7053b6521e'].includes(keyMaster)">
                <v-text-field
                  outlined
                  dense
                  v-model="form.legaladdress2"
                  label="Dirección Complementaria"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" v-if="!form.isa_business">
                <v-text-field
                  v-if="
                    form.invoicetype == 'CCF' ||
                    (form.invoicetype == 'FCF' && invoiceTotalPagar > 25000.0)
                  "
                  outlined
                  dense
                  v-model="form.dui"
                  label="Documento identidad"
                  @input="getDuiMask"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.dui"
                  label="Documento identidad"
                  @input="getDuiMask"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" v-if="form.isa_business">
                <v-text-field
                  v-if="
                    form.invoicetype == 'FCF' &&
                    invoiceTotalPagar > 25000.0
                  "
                  outlined
                  dense
                  v-model="form.dui"
                  label="Documento identidad"
                  @input="getDuiMask"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.dui"
                  label="Documento identidad"
                  @input="getDuiMask"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" v-if="!form.isa_business">
                <v-text-field
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  v-model="form.phonenumber"
                  label="Número de teléfono:"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.phonenumber"
                  label="Número de teléfono:"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" v-if="form.isa_business">
                <v-text-field
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  v-model="form.businesscontactphone"
                  label="Número de teléfono:"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.businesscontactphone"
                  label="Número de teléfono:"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" v-if="!form.isa_business">
                <v-text-field
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  v-model="form.email"
                  label="Correo electrónico: "
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.email"
                  label="Correo electrónico: "
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" v-if="form.isa_business">
                <v-text-field
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  v-model="form.businesscontactemail"
                  label="Correo electrónico: "
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.businesscontactemail"
                  label="Correo electrónico: "
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  v-model="form.legalnit"
                  :label="$t('vwinvoices_clegalnit')"
                  @keyup="getNITMask"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.legalnit"
                  :label="$t('vwinvoices_clegalnit')"
                  @keyup="getNITMask"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  v-model="form.legalnrc"
                  :label="$t('vwinvoices_clegalnrc')"
                  @input="getNRCMask"
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  v-else
                  outlined
                  dense
                  v-model="form.legalnrc"
                  :label="$t('vwinvoices_clegalnrc')"
                  @input="getNRCMask"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.legalentity"
                  attach
                  :items="businessEntityOptions"
                  :label="$t('vwinvoices_clegalentity')"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  label="Actividad economica:*"
                  :items="activities"
                  @change="changueValueactivity"
                  attach
                  v-model="form.codactividad"
                  item-text="Valores"
                  item-value="Codigo"
                  :rules="required"
                ></v-autocomplete>
                <v-autocomplete
                  v-else
                  outlined
                  dense
                  label="Actividad economica:*"
                  :items="activities"
                  @change="changueValueactivity"
                  attach
                  v-model="form.codactividad"
                  item-text="Valores"
                  item-value="Codigo"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="3">
                <v-select
                  v-if="form.invoicetype == 'CCF'"
                  outlined
                  dense
                  :items="taxpayersize"
                  item-value="key"
                  attach
                  item-text="value"
                  v-model="form.legaltaxpayersize"
                  :label="$t('vwinvoices_clegaltaxpayersize')"
                  :rules="required"
                ></v-select>
                <v-select
                  v-else
                  outlined
                  dense
                  :items="taxpayersize"
                  item-value="key"
                  attach
                  item-text="value"
                  v-model="form.legaltaxpayersize"
                  :label="$t('vwinvoices_clegaltaxpayersize')"
                ></v-select>
              </v-col>

              <v-col class="align-self-center" cols="12" md="3">
                <v-checkbox
                  :value="form.legalisnontaxable"
                  v-model="form.legalisnontaxable"
                  :label="$t('vwinvoices_cclientisnontaxable')"
                ></v-checkbox>
              </v-col>

              <v-col cols="12">
                <v-combobox
                  v-model="BccEmails"
                  :items="BccEmails"
                  multiple
                  chips
                  outlined
                  attach
                  label="Enviar facturas a (como copias)"
                  clearable
                  @blur="validateEmails"
                ></v-combobox>
              </v-col>

              <v-col cols="12" mb="12" class="mb-4">
                <v-btn
                  class="btndisable float-right"
                  @click="showCustomer = !showCustomer"
                >Continuar</v-btn>
              </v-col>
            </v-row>
          </form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog
      v-model="showDelAlert"
      :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '500px'"
    >
      <v-card v-if="showDelAlert" class="text-center">
        <v-card-title class="text-h5">
          ¿Esta seguro de eliminar esta factura?
        </v-card-title>

        <v-btn class="ma-2" large color="info" @click="deleteInvoiceComanda(delComanda)">
          Si
        </v-btn>

        <v-btn class="ma-2" large color="error" @click="showDelAlert = false">
          No
        </v-btn>
      </v-card>
    </v-dialog>

    <!-- Split Invoice Modal -->
    <v-dialog
      v-model="showSplitInvoiceDialog"
      :max-width="$vuetify.breakpoint.smAndDown ? '95%' : '800px'"
      max-height="95vh"
    >
      <v-card v-if="showSplitInvoiceDialog" style="display: flex; flex-direction: column; max-height: 95vh;">
        <v-card-title class="text-h6" style="flex-shrink: 0;">Transferir Items a Otra Comanda</v-card-title>
        
        <v-card-text class="pa-4" style="flex: 1; overflow-y: auto;">
          <v-tabs v-model="splitInvoiceTab">
            <!-- TAB 1: Nueva Comanda -->
            <v-tab>Nuevo Pedido</v-tab>
            <v-tab>Comanda Existente</v-tab>

            <!-- Nueva Comanda -->
            <v-tab-item>
              <v-container class="mt-4">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="newCommandaData.customerName"
                      label="Cliente"
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <!-- Comanda Existente -->
            <v-tab-item>
              <v-container class="mt-4">
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="selectedExistingCommandaId"
                      :items="existingCommandasList.filter(i => i.ID_Invoice !== form.idinvoice)"
                      item-text="commandaDisplay"
                      item-value="ID_Invoice"
                      label="Seleccionar Comanda Existente"
                      outline
                      @change="loadExistingCommandaItems"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs>

          <!-- Items Selection -->
          <v-divider class="my-4"></v-divider>
          <v-row>
            <v-col cols="12">
              <h3 class="text-subtitle1">Seleccionar Items a Transferir</h3>
              <v-data-table
                v-model="selectedItemsForTransfer"
                :headers="itemTransferHeaders"
                :items="currentCommandaItemsForTransfer"
                item-key="index"
                show-select
                :height="$vuetify.breakpoint.smAndDown ? '200px' : '300px'"
                fixed-header
                disable-pagination
                hide-default-footer
              >
                <template v-slot:item.quantityToTransfer="{ item, index }">
                  <div style="display: flex; align-items: center; gap: 4px;">
                    <v-btn
                      fab
                      x-small
                      color="warning"
                      @click="decrementTransferQuantity(index)"
                      :disabled="!selectedItemsForTransfer.find(i => i.ID_Item === item.ID_Item) || currentCommandaItemsForTransfer[index].quantityToTransfer <= 0"
                    >
                      <v-icon x-small>mdi-minus</v-icon>
                    </v-btn>
                    <input
                      type="number"
                      v-model.number="currentCommandaItemsForTransfer[index].quantityToTransfer"
                      style="width: 50px; text-align: center; padding: 4px; border: 1px solid #ccc; border-radius: 4px; font-size: 0.9em;"
                      min="0"
                      :max="item.ItemQuantity"
                      @change="updateTransferQuantity(index, $event)"
                    />
                    <v-btn
                      fab
                      x-small
                      color="success"
                      @click="incrementTransferQuantity(index)"
                      :disabled="!selectedItemsForTransfer.find(i => i.ID_Item === item.ID_Item) || currentCommandaItemsForTransfer[index].quantityToTransfer >= item.ItemQuantity"
                    >
                      <v-icon x-small>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <!-- Totals Preview -->
          <v-divider class="my-4"></v-divider>
          <v-row>
            <!-- Current Invoice Totals -->
            <v-col cols="12" md="6">
              <v-card class="pa-3" outlined>
                <h4 class="text-body2 font-weight-bold mb-3">Comanda Actual (después)</h4>
                <v-simple-table dense class="text-caption" style="background: #f9f9f9;">
                  <tbody>
                    <tr>
                      <td style="text-align: left; padding: 4px 8px;">Subtotal:</td>
                      <td style="text-align: right; padding: 4px 8px;"><strong>${{ currentInvoiceTotalsAfterTransfer.subtotal.toFixed(2) }}</strong></td>
                    </tr>
                    <tr v-if="currentInvoiceTotalsAfterTransfer.gravados > 0" style="background: #f0f0f0;">
                      <td style="text-align: left; padding: 4px 8px; font-size: 0.85em;">- Gravados:</td>
                      <td style="text-align: right; padding: 4px 8px; font-size: 0.85em;">${{ currentInvoiceTotalsAfterTransfer.gravados.toFixed(2) }}</td>
                    </tr>
                    <tr v-if="currentInvoiceTotalsAfterTransfer.exentos > 0" style="background: #f0f0f0;">
                      <td style="text-align: left; padding: 4px 8px; font-size: 0.85em;">- Exentos:</td>
                      <td style="text-align: right; padding: 4px 8px; font-size: 0.85em;">${{ currentInvoiceTotalsAfterTransfer.exentos.toFixed(2) }}</td>
                    </tr>
                    <tr v-if="currentInvoiceTotalsAfterTransfer.noSujetos > 0" style="background: #f0f0f0;">
                      <td style="text-align: left; padding: 4px 8px; font-size: 0.85em;">- No Sujetos:</td>
                      <td style="text-align: right; padding: 4px 8px; font-size: 0.85em;">${{ currentInvoiceTotalsAfterTransfer.noSujetos.toFixed(2) }}</td>
                    </tr>
                    <tr>
                      <td style="text-align: left; padding: 4px 8px;">IVA (13%):</td>
                      <td style="text-align: right; padding: 4px 8px;">${{ currentInvoiceTotalsAfterTransfer.iva.toFixed(2) }}</td>
                    </tr>
                    <tr v-if="currentInvoiceTotalsAfterTransfer.propina > 0">
                      <td style="text-align: left; padding: 4px 8px; color: #ff9800; font-weight: bold;">Propina:</td>
                      <td style="text-align: right; padding: 4px 8px; color: #ff9800; font-weight: bold;">${{ currentInvoiceTotalsAfterTransfer.propina.toFixed(2) }}</td>
                    </tr>
                    <tr style="border-top: 2px solid #ddd;">
                      <td style="text-align: left; padding: 4px 8px; font-weight: bold;">TOTAL:</td>
                      <td style="text-align: right; padding: 4px 8px; font-weight: bold; color: #1976d2;">${{ currentInvoiceTotalsAfterTransfer.total.toFixed(2) }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>

            <!-- Destination Invoice Totals -->
            <v-col cols="12" md="6">
              <v-card class="pa-3" outlined>
                <h4 class="text-body2 font-weight-bold mb-3">
                  {{ splitInvoiceTab === 0 ? 'Nuevo Pedido' : 'Comanda Destino' }}
                </h4>
                <v-simple-table dense class="text-caption" style="background: #f9f9f9;">
                  <tbody>
                    <tr>
                      <td style="text-align: left; padding: 4px 8px;">Subtotal:</td>
                      <td style="text-align: right; padding: 4px 8px;"><strong>${{ destinationInvoiceTotalsAfterTransfer.subtotal.toFixed(2) }}</strong></td>
                    </tr>
                    <tr v-if="destinationInvoiceTotalsAfterTransfer.gravados > 0" style="background: #f0f0f0;">
                      <td style="text-align: left; padding: 4px 8px; font-size: 0.85em;">- Gravados:</td>
                      <td style="text-align: right; padding: 4px 8px; font-size: 0.85em;">${{ destinationInvoiceTotalsAfterTransfer.gravados.toFixed(2) }}</td>
                    </tr>
                    <tr v-if="destinationInvoiceTotalsAfterTransfer.exentos > 0" style="background: #f0f0f0;">
                      <td style="text-align: left; padding: 4px 8px; font-size: 0.85em;">- Exentos:</td>
                      <td style="text-align: right; padding: 4px 8px; font-size: 0.85em;">${{ destinationInvoiceTotalsAfterTransfer.exentos.toFixed(2) }}</td>
                    </tr>
                    <tr v-if="destinationInvoiceTotalsAfterTransfer.noSujetos > 0" style="background: #f0f0f0;">
                      <td style="text-align: left; padding: 4px 8px; font-size: 0.85em;">- No Sujetos:</td>
                      <td style="text-align: right; padding: 4px 8px; font-size: 0.85em;">${{ destinationInvoiceTotalsAfterTransfer.noSujetos.toFixed(2) }}</td>
                    </tr>
                    <tr>
                      <td style="text-align: left; padding: 4px 8px;">IVA (13%):</td>
                      <td style="text-align: right; padding: 4px 8px;">${{ destinationInvoiceTotalsAfterTransfer.iva.toFixed(2) }}</td>
                    </tr>
                    <tr v-if="destinationInvoiceTotalsAfterTransfer.propina > 0">
                      <td style="text-align: left; padding: 4px 8px; color: #ff9800; font-weight: bold;">Propina:</td>
                      <td style="text-align: right; padding: 4px 8px; color: #ff9800; font-weight: bold;">${{ destinationInvoiceTotalsAfterTransfer.propina.toFixed(2) }}</td>
                    </tr>
                    <tr style="border-top: 2px solid #ddd;">
                      <td style="text-align: left; padding: 4px 8px; font-weight: bold;">TOTAL:</td>
                      <td style="text-align: right; padding: 4px 8px; font-weight: bold; color: #1976d2;">${{ destinationInvoiceTotalsAfterTransfer.total.toFixed(2) }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pa-4" style="flex-shrink: 0;">
          <v-spacer></v-spacer>
          <v-btn color="default" @click="closeSplitInvoiceDialog">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="saving"
            @click="executeInvoiceSplit"
          >
            Transferir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
} from "devextreme-vue/data-grid";
import { mapState, mapGetters } from "vuex";
import SearchCustomer from "./SearchCustomer.vue";
import SearchTable from "../create/SearchTable.vue";
import DatePicker from "@/components/DatePicker.vue";
import InnovaButton from "@/components/Button.vue";
import PrintPosTk from "@/components/ReportsAndPrintings/PrintPosTk.vue";
import itemtypesAPI from "@/api/itemtypes";
import productsAPI from "@/api/products";
import { pickColorPairById } from "../ProductColorPicker";
import { generateUUID } from "@/helpers/misc";
import { imprimirFactura } from "@/utils/printInvoice";
import { createPaginatedLoader } from "./paginatedLoader";
import { numberToText } from "@/helpers/conveterNumberText";
import CustomAutoComplete from "@/components/CustomAutoComplete.vue";
import {
  dui as duiMask,
  nrc as nrcMask,
  applyDUIMaskOutOfInput,
  nitMaskHandlingHomologation,
  applyNitMaskHandlingHomologationOutOfInput,
} from "@/helpers/masks";
import Vue from "vue";

function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user")) || {};
  } catch (error) {
    return {};
  }
}

function isMypeEnabled(value) {
  if (value === undefined || value === null || value === "") {
    return false;
  }

  if (typeof value === "boolean") {
    return value;
  }

  return ["1", "true"].includes(String(value).trim().toLowerCase());
}

const EL_SALVADOR = "El Salvador";
const ENTITY_LABELS_FOR_EL_SALVADOR = new Set([
  "PERSONA NATURAL",
  "PERSONA JURIDICA",
]);

function normalizeEntityLabel(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase();
}

function filterEntityOptionsByCountry(options, country) {
  if (country !== EL_SALVADOR) {
    return options;
  }

  return options.filter((option) =>
    ENTITY_LABELS_FOR_EL_SALVADOR.has(normalizeEntityLabel(option))
  );
}

export default {
  name: "RestaurantPOS",
  components: {
    SearchCustomer,
    SearchTable,
    DatePicker,
    InnovaButton,
    DxDataGrid,
    DxColumn,
    DxEditing,
    "print-pos-tk": PrintPosTk,
    CustomAutoComplete,
  },
  props: ["win", "hasActiveCashOpening"],
  data() {
    const storedUser = getStoredUser();
    const isMype = isMypeEnabled(storedUser.ismype);

    return {
      posInvoiceAttemptKey: null,
      posInvoiceAttemptUncertain: false,
      posInvoiceRequestInFlight: false,
      delComanda: null,
      showDelAlert: false,
      headerHasErrors: false,
      togglehide: false,
      searchCustomerDialog: false,
      showSearchCustomerTableDialog: false,
      showCustomer: false,
      showItemComments: false,
      showDiscountDialog: false,
      summaryTab: 0,
      activaCommands: [],
      readyInvoices: [],
      loadingCommands: false,
      loadingReadyInvoices: false,
      loading: false,
      commentsObject: {},
      discountEditingItem: null,
      discountEditingIndex: null,
      editingPriceIndex: null,
      editingNameIndex: null,
      customersList: [],
      allCustomers: [],
      selectedCustomer: null,
      customerSearch: '',
      business: null,
      branch: null,
      required: [(v) => !!v || "Este campo es requerido"],
      taxpayersize: [
        { key: "MEDIANO", value: "MEDIANO" },
        { key: "PEQUEÑO", value: "PEQUEÑO" },
        { key: "GRANDE", value: "GRANDE" },
      ],
      businessEntity: [
        "PERSONA NATURAL",
        "PERSONA JURÍDICA",
        "SOCIEDAD ANÓNIMA",
        "CORPORACIÓN",
      ],
      // Customer dialog extras (Create.vue parity)
      BccEmails: [],
      propinasdefault: isMype ? 0 : storedUser.propinasdefault || 0,
      activarPropinas: isMype ? 0 : storedUser.propinasdefault || 0,
      porcentajePropinas: 10,
      // Familias, Categorías y Productos - Con Paginación
      familiesLoader: createPaginatedLoader(),
      categoriesLoader: createPaginatedLoader(),
      subcategoriesLoader: createPaginatedLoader(),
      productsServicesLoader: createPaginatedLoader(),
      families: [],
      categories: [],
      allCategories: [], // Guarda todas las categorías sin filtrar
      subcategories: [],
      allSubcategories: [], // Guarda todas las subcategorías sin filtrar
      productsAndServices: [],
      displayedItemsCount: 30, // Cantidad de items a renderizar (virtualization)
      productsToShow: [], // Items para mostrar en UI
      body: [], // Items para enviar al backend
      discountObject: [], // Descuentos por item
      tempId: null, // ID temporal para autosave
      tempDetails: [], // Detalles temporales para autosave
      invoiceAutoSave: 0, // Flag para activar autosave
      invoiceItems: [], // Alias para compatibilidad (usar productsToShow)
      selectedFamilyId: null,
      selectedCategoryId: null,
      selectedSubcategoryId: null,
      navigationLevel: 0, // 0=familias, 1=categorías, 2=subcategorías, 3=productos/servicios
      navigationStack: [], // Historial de navegación para retroceder
      searchProductName: null,
      expandFilters: false,
      // Campos adicionales para filtros
      selectedBarCode: null,
      warehouseSelected: null,
      PriceListSelected: null,
      warehouses: [],
      priceListData: [],
      filterWarehouses: {},
      showProducts: true,
      showServices: true,
      creditDays: [
        "1 días",
        "8 días",
        "15 días",
        "30 días",
        "45 días",
        "60 días",
        "90 días",
        "120 días",
        "180 días",
      ],
      paymentTypes: [],
      keyMaster: JSON.parse(localStorage.getItem("user"))?.keymaster || null,
      saving: false, // Flag para mostrar overlay de carga
      codigosAsociados: [
        { id: 1, valor: "Emisor" },
        { id: 2, valor: "Receptor" },
      ],
      codigosAsociadosEx: [
        {
          id: 4,
          valor: "Transporte",
        },
        {
          id: 1,
          valor: "Emisor",
        },
        {
          id: 2,
          valor: "Receptor",
        },
      ],
      modoTransporte: [
        { id: 1, valor: "Terrestre" },
        { id: 2, valor: "Marítimo" },
        { id: 3, valor: "Aéreo" },
        { id: 4, valor: "Multimodal, Terrestre-marítimo" },
        { id: 5, valor: "Multimodal, Terrestre-aéreo" },
        { id: 6, valor: "Multimodal, Marítimo- aéreo" },
        { id: 7, valor: "Multimodal, Terrestre-Marítimo- aéreo" },
      ],
      bienTitulo: [
        { id: "01", value: "Depósito" },
        { id: "02", value: "Propiedad" },
        { id: "03", value: "Consignación" },
        { id: "04", value: "Traslado" },
        { id: "05", value: "Otros" },
      ],
      incoterms: [
        { id: "01", valor: "EXW-En fabrica" },
        { id: "02", valor: "FCA-Libre transportista" },
        { id: "03", valor: "CPT-Transporte pagado hasta" },
        { id: "04", valor: "CIP-Transporte y seguro pagado hasta" },
        { id: "05", valor: "DAP-Entrega en el lugar" },
        { id: "06", valor: "DPU-Entregado en el lugar descargado" },
        { id: "07", valor: "DDP-Entrega con impuestos pagados" },
        { id: "08", valor: "FAS-Libre al costado del buque" },
        { id: "09", valor: "FOB-Libre a bordo" },
        { id: "10", valor: "CFR-Costo y flete" },
        { id: "11", valor: "CIF- Costo seguro y flete" },
        { id: "12", valor: "DAT-Entregado en terminal" },
        { id: "13", valor: "DAF-Entregada en frontera" },
        { id: "14", valor: "DES-Entregada sobre duque" },
        { id: "15", valor: "DEQ-Entregada en muelle" },
        { id: "16", valor: "DDU- Entregada derechos no pagados" }
      ],
      form: {
        idinvoice: null,
        idcustomer: null,
        invoicedate: null,
        invoicetype: "FCF",
        invoicepaymenttype: null,
        invoicestatusdescription: null,
        invoicereference: null,
        invoicecreditday: "30 días",
        invoiceinternalnote: "",
        isquote: 0,
        creditstatus: null,
        codasociado: null,
        docasociado: null,
        detalleasociado: null,
        modotransp: null,
        numconductor: null,
        nombreconductor: null,
        placatrans: null,
        seguro: 0,
        flete: 0,
        portofdeparture: null,
        shipmentno: null,
        containerno: null,
        blno: null,
        vesselvoyage: null,
        usadfa: null,
        termsofpayment: null,
        codincoterms: null,
        bientitulo: null,
        nccodigorelacionado: null,
        ncfecharelacionado: null,
        // Legal fields copied from Create.vue for parity
        legalname: null,
        legaladdress: null,
        legaladdress2: null,
        legalnit: null,
        legalnrc: null,
        legalentity: null,
        legalisnontaxable: false,
        legaltaxpayersize: null,
      },
      // Banderas para control de impresión y comanda
      orderAndPrint: false,
      hideQrInPrint: false,
      
      // Datos para impresión
      datatoprint: {
        branch: JSON.parse(localStorage.getItem("branch")),
        user: JSON.parse(localStorage.getItem("user")),
        header: null,
        body: null,
        dteJson: null,
      },
      print: {
        show: false,
        data: {},
      },
      print2: {
        show: false,
        data: {},
      },
      // Diálogo de alerta
      alert: {
        type: null,
        header: null,
        body: null,
        show: false,
        options: null,
      },
      invoiceResult: {
        show: false,
        title: "",
        message: "",
        color: "comment",
        colorBtn: "primary",
        colorTitle: "",
        estado: "",
        description: "",
        observaciones: [],
        total: 0,
        pagoCon: 0,
        cambio: 0,
      },
      modeList: true,
      fullscreen: false,
      // Guardar estado de navegación para restaurarlo
      savedNavigationState: null,
      // Diálogo de pagos (multipagos)
      showReturnedAndPaymentModal: false,
      isReadyToBill: false,
      paymentsData: [
        {
          typePayment: "01",
          descriptionPayment: "Billetes y monedas",
          totalPayment: 0.0,
          reference: null,
        },
        {
          typePayment: "02",
          descriptionPayment: "Tarjeta Débito",
          totalPayment: 0.0,
          reference: null,
        },
        {
          typePayment: "04",
          descriptionPayment: "Cheque",
          totalPayment: 0.0,
          reference: null,
        },
        {
          typePayment: "05",
          descriptionPayment: "Transferencia Depósito Bancario",
          totalPayment: 0.0,
          reference: null,
        },
        {
          typePayment: "13",
          descriptionPayment: "Cuentas por pagar del receptor",
          totalPayment: 0.0,
          reference: null,
        },
      ],
      selectedPayment: '',
      paymentTypeSelect: false,
      sumPayments: 0,
      exchangePayments: 0,
      paymentReadyToBill: false,
      enablenegativeitem: JSON.parse(localStorage.getItem("user"))?.enablenegativeitem,
      // Split Invoice Feature
      showSplitInvoiceDialog: false,
      splitInvoiceTab: 0,
      selectedItemsForTransfer: [],
      currentCommandaItemsForTransfer: [],
      existingCommandasList: [],
      selectedExistingCommandaId: null,
      selectedExistingComandaData: {
        header: null,
        items: [],
        totals: { subtotal: 0, gravados: 0, exentos: 0, noSujetos: 0, iva: 0, propina: 0, total: 0 }
      },
      newCommandaData: {
        invoiceType: 'FCF',
        invoiceDate: null,
        customerName: null,
      },
      itemTransferHeaders: [
        { text: 'Descripción', value: 'ItemDescription', width: '35%' },
        { text: 'Disponible', value: 'ItemQuantity', width: '12%' },
        { text: 'Transferir', value: 'quantityToTransfer', width: '12%' },
        { text: 'Precio Unit.', value: 'ItemUnitPrice', width: '15%' },
        { text: 'Total', value: 'itemTotal', width: '13%' }
      ],
    };
  },
  computed: {
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
    ...mapGetters(["getCatalogMH"]),
    currentInvoiceTotalsAfterTransfer() {
      if (!this.currentCommandaItemsForTransfer || this.currentCommandaItemsForTransfer.length === 0) {
        return { subtotal: 0, gravados: 0, exentos: 0, noSujetos: 0, iva: 0, propina: 0, total: 0 };
      }
      
      // Items que quedan en la comanda actual (no transferidos o parcialmente transferidos)
      const remainingItems = this.currentCommandaItemsForTransfer
        .map(item => {
          const isSelected = this.selectedItemsForTransfer.some(t => t.ID_Item === item.ID_Item);
          
          if (!isSelected) {
            // Item no seleccionado: mantener cantidad completa
            return item;
          } else {
            // Item seleccionado: reducir cantidad transferida
            const remainingQty = Math.max(0, (item.ItemQuantity || 0) - (item.quantityToTransfer || 0));
            if (remainingQty <= 0) return null; // Eliminar si se transfiere todo
            
            return {
              ...item,
              ItemQuantity: remainingQty,
              itemTotal: remainingQty * (item.ItemUnitPrice || 0)
            };
          }
        })
        .filter(item => item !== null);
      
      return this.calculateSplitInvoiceTotals(remainingItems);
    },
    destinationInvoiceTotalsAfterTransfer() {
      if (!this.currentCommandaItemsForTransfer || this.currentCommandaItemsForTransfer.length === 0) {
        return { subtotal: 0, gravados: 0, exentos: 0, noSujetos: 0, iva: 0, propina: 0, total: 0 };
      }

      // Items que se transfieren
      const transferItems = this.currentCommandaItemsForTransfer
        .map(item => {
          const isSelected = this.selectedItemsForTransfer.some(t => t.ID_Item === item.ID_Item);
          const qtyToTransfer = item.quantityToTransfer || 0;
          
          if (!isSelected || qtyToTransfer <= 0) return null;
          
          return {
            ...item,
            ItemQuantity: qtyToTransfer,
            itemTotal: qtyToTransfer * (item.ItemUnitPrice || 0)
          };
        })
        .filter(item => item !== null);
      
      // Si es EXISTING comanda, agregar items actuales de esa comanda
      if (this.splitInvoiceTab === 1 && this.selectedExistingComandaData.items && this.selectedExistingComandaData.items.length > 0) {
        // Items actuales de la comanda existente
        const existingItems = this.selectedExistingComandaData.items.map(item => ({
          ItemQuantity: item.ItemQuantity || item.qty,
          ItemUnitPrice: item.ItemUnitPrice || item.ItemNewPrice || item.itemunitcost,
          BloquearPropinas: item.BloquearPropinas || item.bloquearpropinas || item.prod?.BloquearPropinas || item.prod?.bloquearpropinas || 0,
          prod: item.prod || item
        }));
        
        // Combinar items existentes + items transferidos
        const allItems = [...existingItems, ...transferItems];
        const calculatedTotals = this.calculateSplitInvoiceTotals(allItems);
        
        // IMPORTANTE: Usar la propina original de la comanda existente, no la recalculada
        const existingPropina = this.selectedExistingComandaData.totals.propina || 0;
        
        // Recalcular el total con la propina original de la comanda existente
        const totalWithCorrectPropina = parseFloat((calculatedTotals.subtotal + existingPropina).toFixed(2));
        
        return {
          subtotal: calculatedTotals.subtotal,
          gravados: calculatedTotals.gravados,
          exentos: calculatedTotals.exentos,
          noSujetos: calculatedTotals.noSujetos,
          iva: calculatedTotals.iva,
          propina: existingPropina,  // Usar propina de la comanda existente
          total: totalWithCorrectPropina  // Total incluye propina de la comanda existente
        };
      }
      
      // Si es NEW comanda, solo usar items transferidos
      return this.calculateSplitInvoiceTotals(transferItems);
    },
    gridContainerHeight() {
      return this.fullscreen ? { flex: '1', height: 'auto' } : { height: '800px' };
    },
    invoiceListHeight() {
      return this.fullscreen ? { flex: '1', maxHeight: 'none' } : { maxHeight: '460px' };
    },
    invoiceSummaryHeight() {
      return this.fullscreen ? { flex: '1', maxHeight: 'none' } : { maxHeight: '750px' };
    },
    mype() {
      return isMypeEnabled(getStoredUser().ismype);
    },
    posrestaurant() {
      if (this.mype) 
        return 1;
      
      return JSON.parse(localStorage.getItem("user"))?.posrestaurant || 0;
    },
    pospayments() {
      return JSON.parse(localStorage.getItem("user"))?.pospayments || 0;
    },
    activities() {
      return this.getCatalogMH("ActividadEconomica");
    },
    // Expose invoice total for conditional validation in the customer dialog (mirrors Create.vue's sumObject.total)
    invoiceTotalPagar() {
      const totals = this.calculateInvoiceTotals();
      return totals?.invoicetotalpagar || 0;
    },
    filterType() {
      if (
        (JSON.parse(localStorage.getItem("branch")).ID_Business == "17" ||
          JSON.parse(localStorage.getItem("branch")).ID_Business == "41" ||
          JSON.parse(localStorage.getItem("user")).keymaster == "377be3042e446f9f8312a4ea699a4381" ||
          JSON.parse(localStorage.getItem("user")).keymaster == "689510125c294fa0c2b02d6200cceb7f" ||
          JSON.parse(localStorage.getItem("user")).keymaster == "0a9e451bcfa7e7db984f3e7f27e1bd56" ||
          JSON.parse(localStorage.getItem("user")).keymaster == "6e87d287a283098a118f6ba5526233b9") &&
        this.form.invoicetype != "DNC" &&
        this.form.invoicetype != "DND" &&
        this.form.invoicetype != "COT"
      ) {
        return [
          {
            name: "CONSUMIDOR FINAL",
            key: "FCF",
          },
          {
            name: "CRÉDITO FISCAL",
            key: "CCF",
          },
          /*{
            name: "SUJETO EXCLUIDO",
            key: "FNS",
          },
          {
            name: "EXPORTACIÓN",
            key: "FEX",
          },
          {
            name: "COMPROBANTE DE DONACIÓN",
            key: "CDD",
          },
          {
            name: "TICKETS",
            key: "TCKS",
          },
          {
            name: "NOTA DE REMISIÓN",
            key: "DNR",
          },
          {
            name: "NOTA DE CRÉDITO",
            key: "DNC",
          },
          {
            name: "NOTA DE DÉBITO",
            key: "DND",
          },*/
        ];
      } else {
        return [
          {
            name: "CONSUMIDOR FINAL",
            key: "FCF",
          },
          {
            name: "CRÉDITO FISCAL",
            key: "CCF",
          },
          /*{
            name: "SUJETO EXCLUIDO",
            key: "FNS",
          },
          {
            name: "EXPORTACIÓN",
            key: "FEX",
          },
          {
            name: "COMPROBANTE DE DONACIÓN",
            key: "CDD",
          },
          {
            name: "NOTA DE REMISIÓN",
            key: "DNR",
          },
          {
            name: "NOTA DE CRÉDITO",
            key: "DNC",
          },
          {
            name: "NOTA DE DÉBITO",
            key: "DND",
          },*/
        ];
      }
    },
    checkCountryInvoiceStatuses() {
      const country = JSON.parse(localStorage.getItem("branch")).Country;
      if (
        this.form.idcustomer &&
        country === "El Salvador" &&
        (this.form.creditstatus == "BLOQUEADO" ||
          this.form.creditstatus == "INACTIVO" ||
          this.form.creditstatus == "SUSPENDIDO")
      ) {
        return ["Cancelada"];
      } else if (country === "El Salvador") {
        return ["Cancelada", "Crédito"];
      } else {
        return ["Cancelada", "Pendiente de pago", "Crédito"];
      }
    },
    businessEntityOptions() {
      const branchCountry = JSON.parse(localStorage.getItem("branch"))?.Country || "";
      return filterEntityOptionsByCountry(this.businessEntity, branchCountry);
    },
    dateValidationRules() {
      return [
        v => !!v || 'Este campo es requerido',
        v => !v || this.isValidDate(v) || 'Formato de fecha inválido (DD/MM/YYYY)'
      ];
    },
    invoiceStatusRules() {
      return [
        v => !!v || 'Este campo es requerido',
        v => this.checkCountryInvoiceStatuses.includes(v) || 'Seleccione una opción válida'
      ];
    },
    filteredProductsAndServices() {
      // Si modeList está desactivado O estamos en modo de navegación de productos/servicios
      if (!this.modeList || this.navigationLevel === 3) {
        let filtered = [...this.productsAndServices];

        // Filtrar por tipo (producto o servicio)
        filtered = filtered.filter(item => {
          // Permitir siempre los skeletons (items de carga)
          if (item._isSkeleton) {
            return true;
          }
          const isService = item.prod?.type === 'service';
          const isProduct = item.prod?.type !== 'service';
          
          if (this.showProducts && this.showServices) {
            return true; // Mostrar ambos
          } else if (this.showProducts && isProduct) {
            return true; // Mostrar solo productos
          } else if (this.showServices && isService) {
            return true; // Mostrar solo servicios
          }
          return false;
        });

        // Ocultar el servicio SERVPROPINAS
        filtered = filtered.filter(item => {
          return item.val !== 'SERVPROPINAS';
        });
        
        // Aplicar filtros de categoría/subcategoría si estamos en navigationLevel === 3
        if (this.navigationLevel === 3) {
          filtered = filtered.filter(item => {
            // Permitir siempre los skeletons
            if (item._isSkeleton) {
              return true;
            }
            
            // Caso especial: Sin familia (selectedFamilyId === 0)
            if (this.selectedFamilyId === 0) {
              return !item.prod?.IdFamily && !item.prod?.family;
            }
            // Caso normal: Familia específica
            const itemHasFamily = item.prod?.IdFamily === this.selectedFamilyId || item.prod?.family === this.selectedFamilyId;
            const itemHasCategory = this.selectedCategoryId === null || item.prod?.IdCategory === this.selectedCategoryId || item.prod?.category === this.selectedCategoryId;
            const itemHasSubcategory = this.selectedSubcategoryId === null || item.prod?.IdSubCategory === this.selectedSubcategoryId | item.prod?.IdSubCategory === this.subcategory;
            
            return itemHasFamily && itemHasCategory && itemHasSubcategory;
          });
        }
        
        // Remover duplicados basándose en item.val (pero permitir skeletons)
        const seen = new Set();
        filtered = filtered.filter(item => {
          // Permitir siempre los skeletons
          if (item._isSkeleton) {
            return true;
          }
          
          if (seen.has(item.val)) {
            return false; // Ya lo hemos visto, ignorar
          }
          seen.add(item.val);
          return true;
        });
        
        // Si estamos en navegación por categorías (modeList = true) y en nivel 3 con sin familia,
        // marcar todos los items como directos para que se muestren correctamente en el template
        if (this.modeList && this.navigationLevel === 3) {
          filtered.forEach(item => {
            item._isDirect = true;
          });
        }
        return filtered.sort(this.sortByOrderItem);
      }
      
      // Si modeList está activado, mostrar elementos de navegación con paginación
      let result = [];
      if (this.navigationLevel === 0) {
        // Mostrar familias con paginación
        result = this.familiesLoader.getDisplayItems();
        
      } else if (this.navigationLevel === 1) {
        // Mostrar categorías con paginación
        result = this.categoriesLoader.getDisplayItems();
        
      } else if (this.navigationLevel === 2) {
        // Mostrar subcategorías con paginación
        result = this.subcategoriesLoader.getDisplayItems();
      }
      
      // Obtener items directos desde productsAndServices según el nivel
      let directItems = [];

      if (this.navigationLevel === 1) {
        // En nivel 1: items directos de familia (con IdFamily pero sin IdCategory)
        directItems = this.productsAndServices.filter(item => {
          // Permitir siempre los skeletons
          if (item._isSkeleton) return true;
          
          // Intentar con ambos campos: IdFamily/family
          const familyId = item.prod?.IdFamily || item.prod?.family;
          const categoryId = item.prod?.IdCategory || item.prod?.category;
          
          const isFromSelectedFamily = this.selectedFamilyId === 0 
            ? (!familyId || familyId === 0 || familyId === null)
            : familyId === this.selectedFamilyId;
          const hasNoCategory = !categoryId || categoryId === null;
          
          return isFromSelectedFamily && hasNoCategory;
        });
      } else if (this.navigationLevel === 2) {
        // En nivel 2: items directos de categoría (con IdFamily y IdCategory pero sin IdSubCategory)
        directItems = this.productsAndServices.filter(item => {
          // Permitir siempre los skeletons
          if (item._isSkeleton) return true;
          
          // Intentar con ambos campos: IdFamily/family, IdCategory/category, IdSubCategory/subcategory
          const familyId = item.prod?.IdFamily || item.prod?.family;
          const categoryId = item.prod?.IdCategory || item.prod?.category;
          const subcategoryId = item.prod?.IdSubCategory || item.prod?.subcategory;
          
          const isFromSelectedFamily = familyId === this.selectedFamilyId;
          const isFromSelectedCategory = categoryId === this.selectedCategoryId;
          const hasNoSubcategory = !subcategoryId || subcategoryId === null;
          
          return isFromSelectedFamily && isFromSelectedCategory && hasNoSubcategory;
        });
      } else if (this.navigationLevel === 3 && this.selectedFamilyId === 0) {
        // En nivel 3 con "Sin familia": todos los items son directos (sin familia)
        directItems = this.productsAndServices.filter(item => {
          // Permitir siempre los skeletons
          if (item._isSkeleton) return true;
          
          // Intentar con ambos campos: IdFamily/family
          const familyId = item.prod?.IdFamily || item.prod?.family;
          return !familyId || familyId === 0 || familyId === null;
        });
      }
      
      // Filtrar items directos por tipo (Productos/Servicios)
      // Siempre incluir skeletons para mostrar mientras se carga
      const filteredDirectItems = directItems.filter(item => {
        // Permitir siempre los skeletons
        if (item._isSkeleton) {
          return true;
        }
        
        const isService = item.prod?.type === 'service';
        const isProduct = item.prod?.type !== 'service';
        
        if (this.showProducts && this.showServices) {
          return true; // Mostrar ambos
        } else if (this.showProducts && isProduct) {
          return true; // Mostrar solo productos
        } else if (this.showServices && isService) {
          return true; // Mostrar solo servicios
        }
        return false;
      });
      
      // Marcar items directos para uso visual (pero no los skeletons)
      filteredDirectItems.forEach(item => {
        if (!item._isSkeleton) {
          item._isDirect = true;
        }
      });

      const resultList = [...result, ...filteredDirectItems].sort(this.sortByOrderItem)
      return resultList;
    },
    displayedProductsAndServices() {
      // Si estamos navegando por categorías (modeList = true), mostrar todas las categorías/subcategorías
      // con paginación (ya está manejada por el loader)
      if (this.modeList && (this.navigationLevel === 0 || this.navigationLevel === 1 || this.navigationLevel === 2)) {
        return this.filteredProductsAndServices;
      }
      
      // Para productos/servicios (navigationLevel === 3 o modeList = false), mostrar todos los productos filtrados
      // Cuando modeList = false, mostrar todos sin limitar por displayedItemsCount
      // Cuando navigationLevel === 3, mostrar con paginación
      if (!this.modeList) {
        // Cuando estamos en modo búsqueda (sin categorías), mostrar todos los items cargados
        return this.filteredProductsAndServices;
      }
      
      // Cuando navigationLevel === 3 (navegando por categorías), mostrar con paginación
      if (this.navigationLevel === 3) {
        return this.filteredProductsAndServices.slice(0, this.displayedItemsCount);
      }
      return this.filteredProductsAndServices;
    },
    invoiceSubtotal() {
      // Mostrar subtotal como suma de gravados + exentas + no sujetas (excluyendo propina)
      const val = this.taxableTotal + this.exemptTotal + this.nonSubjectTotal + this.nogravadaTotal;
      const subtotal = parseFloat((val || 0).toFixed(2));
      return isNaN(subtotal) ? 0 : subtotal;
    },
    exemptTotal() {
      const totals = this.calculateInvoiceTotals();
      return isNaN(totals.invoicetotalexenta) ? 0 : totals.invoicetotalexenta;
    },
    nonSubjectTotal() {
      const totals = this.calculateInvoiceTotals();
      // Excluir la propina del valor mostrado como "No Sujetas" para coincidir con Create.vue
      const val = (totals.invoicetotalnosuj || 0) - (totals.propina || 0);
      return isNaN(val) ? 0 : Math.max(0, parseFloat(val.toFixed(2)));
    },
    nogravadaTotal() {
      const totals = this.calculateInvoiceTotals();
      const val = (totals.invoicetotalnogravada || 0) - (totals.propina || 0);
      return isNaN(val) ? 0 : Math.max(0, parseFloat(val.toFixed(2)));
    },
    taxableTotal() {
      const totals = this.calculateInvoiceTotals();
      return isNaN(totals.invoicetotalgravada) ? 0 : totals.invoicetotalgravada;
    },
    ivaTotal() {
      const totals = this.calculateInvoiceTotals();
      const iva = parseFloat(totals.invoicetotaliva.toFixed(2));
      return isNaN(iva) ? 0 : iva;
    },
    invoiceTotal() {
      const totals = this.calculateInvoiceTotals();
      return isNaN(totals.invoicetotalpagar) ? 0 : totals.invoicetotalpagar;
    },
    ivaRete() {
      const totals = this.calculateInvoiceTotals();
      return isNaN(totals.invoiceivarete1) ? 0 : totals.invoiceivarete1;
    },
    ivaPerce() {
      const totals = this.calculateInvoiceTotals();
      return isNaN(totals.invoiceivaperce1) ? 0 : totals.invoiceivaperce1;
    },
    subtotalSinDescuento() {
      return this.productsToShow.reduce((total, item) => {
        return total + (item.qty * parseFloat(item.ItemNewPrice || 0));
      }, 0);
    },
    totalPropina() {
      // Usar la propina calculada por calculateInvoiceTotals() para mantener consistencia
      if (!this.activarPropinas || this.productsToShow.length === 0) return 0;
      const totals = this.calculateInvoiceTotals();
      const prop = parseFloat((totals.propina || 0));
      return isNaN(prop) ? 0 : parseFloat(prop.toFixed(2));
    },
    navigationBreadcrumb() {
      // Generar breadcrumb basado en el nivel de navegación actual
      if (!this.modeList || this.navigationLevel === 0) {
        return []; // No mostrar breadcrumb en el nivel raíz
      }
      
      const breadcrumbs = [];
      
      // Siempre agregar "Familias" como primer nivel
      breadcrumbs.push({
        level: 0,
        label: 'Familias',
        id: null,
      });
      
      if (this.navigationLevel >= 1 && (this.selectedFamilyId !== null && this.selectedFamilyId !== undefined)) {
        let familyName = 'Categorías';
        
        // Caso especial para "SIN FAMILIA"
        if (this.selectedFamilyId === 0) {
          familyName = 'SIN FAMILIA';
        } else {
          // Buscar en familiesLoader primero (datos paginados)
          const familyFromLoader = this.familiesLoader.items.find(f => f.id === this.selectedFamilyId);
          if (familyFromLoader) {
            familyName = familyFromLoader.name;
          }
        }
        
        breadcrumbs.push({
          level: 1,
          label: familyName,
          id: this.selectedFamilyId,
        });
      }
      
      if (this.navigationLevel >= 2 && this.selectedCategoryId) {
        let categoryName = 'Subcategorías';
        
        // Buscar en categoriesLoader (datos paginados)
        const categoryFromLoader = this.categoriesLoader.items.find(c => c.id === this.selectedCategoryId);
        if (categoryFromLoader) {
          categoryName = categoryFromLoader.name;
        }
        
        breadcrumbs.push({
          level: 2,
          label: categoryName,
          id: this.selectedCategoryId,
        });
      }
      
      if (this.navigationLevel >= 3 && this.selectedSubcategoryId) {
        let subcategoryName = 'Productos/Servicios';
        
        // Buscar en subcategoriesLoader (datos paginados)
        const subcategoryFromLoader = this.subcategoriesLoader.items.find(s => s.id === this.selectedSubcategoryId);
        if (subcategoryFromLoader) {
          subcategoryName = subcategoryFromLoader.name;
        }
        
        breadcrumbs.push({
          level: 3,
          label: subcategoryName,
          id: this.selectedSubcategoryId,
        });
      }
      
      return breadcrumbs;
    },
    canSaveInvoice() {
      // Validar que el cliente esté seleccionado
      if (!this.form.idcustomer) {
        return false;
      }
      
      // Validar que la fecha esté seleccionada
      if (!this.form.invoicedate) {
        return false;
      }
      
      // Validar que el tipo de documento esté seleccionado
      if (!this.form.invoicetype) {
        return false;
      }
      
      // Validar que el estado de la factura esté seleccionado
      if (!this.form.invoicestatusdescription) {
        return false;
      }
      
      // Validar método de pago (solo si es requerido)
      if (this.form.isquote == 0 && this.pospayments == 0) {
        if (!this.form.invoicepaymenttype) {
          return false;
        }
      }
      
      // Validar que haya al menos un producto
      /*if (this.productsToShow.length === 0) {
        return false;
      }*/
      
      return true;
    },
    showCreateOrderButton() {
      return (!this.form.idinvoice || !this.form.idinvoice?.startsWith('COM')) && !this.mype;
    },
    buttonCols() {
      const buttons = ['limpiar']; // Limpiar always shown
      if (!this.form.idinvoice || !this.form.idinvoice.includes('RTB')) buttons.push('crear factura');
      if (this.form.idinvoice && !this.form.idinvoice.includes('temp')) buttons.push('guardar');
      if (this.showCreateOrderButton) buttons.push('comanda');
      if (this.form.idinvoice && !this.form.idinvoice.includes('temp')) buttons.push('transferir')
      return Math.floor(12 / buttons.length);
    },
    missingRequiredFieldsLabels() {
      const missing = [];
      if (!this.form.invoicedate) missing.push('Fecha');
      if (!this.form.invoicetype) missing.push('Tipo de Documento');
      if (!this.form.invoicestatusdescription) missing.push('Estado de la factura');
      if (this.form.isquote == 0 && this.pospayments == 0 && !this.form.invoicepaymenttype) missing.push('Método de pago');
      if (this.form.invoicestatusdescription == 'Crédito' && !this.form.invoicecreditday) missing.push('Días de crédito');
      // Add more conditionals if needed
      return missing;
    },
    isCoffeBike(){
      return  ['2c451b9885da7d373da24547ba01c29a', '3616a6f4114dde41c65059e3a943e7ef'].includes(this.keyMaster);
    }
  },
  watch: {
    summaryTab(newVal) {
      // Si se cambia a la pestaña de Comandas activas (índice 1), cargar las comandas
      if (newVal === 1) {
        this.loadActiveCommands();
      }
      // Si se cambia a la pestaña de Facturas Listas (índice 2), cargar las facturas listas
      if (newVal === 2) {
        this.loadReadyInvoices();
      }
    },
    body: {
      handler(newVal) {
        // Actualizar el store cuando cambia cualquier propiedad del body
        this.$store.commit("posData/setBody", newVal);
      },
      deep: true
    },
    selectedItemsForTransfer(newVal) {
      // Cuando se deselecciona un item, reiniciar su quantityToTransfer a 0
      for (const item of this.currentCommandaItemsForTransfer) {
        const isSelected = newVal.some(s => s.ID_Item === item.ID_Item);
        if (!isSelected && item.quantityToTransfer > 0) {
          this.$set(item, 'quantityToTransfer', 0);
        }
      }
    },
    'form.invoicedate': function() {
      this.validateHeader();
    },
    'form.invoicetype': function() {
      this.validateHeader();
    },
    'form.invoicepaymenttype': function() {
      this.validateHeader();
    },
    'form.invoicestatusdescription': function() {
      this.validateHeader();
    },
    'form.invoicecreditday': function() {
      this.validateHeader();
    },
    'form.legalname': function(newVal) {
      if (newVal) {
        this.form.idcustomernombre = newVal;
        // Actualizar itemText en allCustomers si el cliente existe en la lista
        const customer = this.allCustomers.find(c => c.ID_Customer === this.form.idcustomer);
        if (customer) {
          customer.itemText = newVal;
        }
      }
    },
  },
  methods: {
    async submitPosInvoice(payload) {
      if (this.posInvoiceRequestInFlight || this.posInvoiceAttemptUncertain) {
        throw new Error('Hay un intento de facturación pendiente. Revise el historial antes de continuar.');
      }
      const key = this.posInvoiceAttemptKey || this.$API.invoices.newIdempotencyKey();
      this.posInvoiceAttemptKey = key;
      this.posInvoiceRequestInFlight = true;
      try {
        const response = await this.$API.invoices.createInvoice(payload, key, true);
        this.posInvoiceAttemptKey = null;
        return response;
      } catch (error) {
        this.posInvoiceAttemptUncertain = !!(error?.transportFailure || error?.status === 409 || error?.status === 503);
        if (!this.posInvoiceAttemptUncertain) this.posInvoiceAttemptKey = null;
        if (this.posInvoiceAttemptUncertain) {
          sessionStorage.setItem('lastUncertainRestaurantInvoiceAttempt', key);
          try {
            const status = await this.$API.invoices.getInvoiceAttemptStatus(key);
            const completed = status?.data?.state === 'COMPLETED';
            error.message = `El resultado no se confirmó. Revise el historial antes de facturar de nuevo.${status?.data?.ID_Invoice ? ` ID de factura: ${status.data.ID_Invoice}.` : ''}`;
            if (completed) error.message += ' El intento terminó; abra la factura desde el historial.';
          } catch (statusError) {
            error.message = 'El resultado no se confirmó. Revise el historial antes de facturar de nuevo.';
          }
        }
        throw error;
      } finally {
        this.posInvoiceRequestInFlight = false;
      }
    },
    sortByOrderItem(a, b) {
        const rawOrderA = a?.prod?.orderItem ?? a?.orderItem;
        const rawOrderB = b?.prod?.orderItem ?? b?.orderItem;
        const orderA = Number.isFinite(Number(rawOrderA)) ? Number(rawOrderA) : 999999;
        const orderB = Number.isFinite(Number(rawOrderB)) ? Number(rawOrderB) : 999999;
        if (orderA !== orderB) {
            return orderA - orderB;
        }
        const nameA = typeof a?.name === 'string' ? a.name.trim().toLowerCase() : '';
        const nameB = typeof b?.name === 'string' ? b.name.trim().toLowerCase() : '';

        if (!nameA && !nameB) {
            return 0;
        }

        if (!nameA) {
            return 1;
        }

        if (!nameB) {
            return -1;
        }

        return nameA.localeCompare(nameB);
    },
    async deleteInvoiceComanda(data) {
      this.loading = true;
      const response = await this.$API.invoices.getInvoiceIsNotBilled({
        ID_Branch: data.ID_Branch,
        ID_Business: data.ID_Business,
        ID_Invoice: data.ID_Invoice
      });
      
      if (!response.value) {
        this.loading = false;
        this.showDelAlert = false;
        this.showAlert(
          'warning', 
          'Advertencia',
          'La comanda seleccionada ya se encuentra procesada. Por favor recargue el POS para actualizar la información.',
        );
      }
      else {
        this.$API.invoices
          .deleteInvoice(data.ID_Invoice)
          .then(async () => {
            this.loading = false;
            this.showAlert(
              "success",
              "Comanda eliminada",
              "La comanda seleccionada se ha eliminado correctamente"
            );
            this.showDelAlert = false;
            await this.loadActiveCommands();
          })
          .catch(() => {
            this.loading = false;
            this.showAlert(
              "danger",
              "Error",
              "Ha ocurrido un error al eliminar la factura"
            );
            this.showDelAlert = false;
          });
      }
    },
    restoreNavigationData(savedState) {
      // Restaurar los datos en los loaders basándose en el nivel guardado
      if (savedState.navigationLevel === 0) {
        // Cargar familias si no están cargadas
        //console.log('Nivel 0 - cargando familias');
        if (this.familiesLoader.items.length === 0) {
          this.loadFamiliesPage(1, true);
        }
      } else if (savedState.navigationLevel === 1) {
        // Cargar familias y categorías
        // console.log('Nivel 1 - cargando categorías para familia:', savedState.selectedFamilyId);
        if (this.familiesLoader.items.length === 0) {
          this.loadFamiliesPage(1, true);
        }
        if (savedState.selectedFamilyId !== null) {
          this.categoriesLoader.reset();
          this.loadCategoriesPage(savedState.selectedFamilyId, 1, true);
          // También cargar productos/servicios directos de esta familia
          this.productsServicesLoader.reset();
          this.loadProductsServicesPage({
            familyId: savedState.selectedFamilyId === 0 ? 'null' : savedState.selectedFamilyId,
            warehouse: this.warehouseSelected,
            pricelist: this.PriceListSelected,
          }, 1, true);
        }
      } else if (savedState.navigationLevel === 2) {
        // Cargar categorías y subcategorías
        // console.log('Nivel 2 - cargando subcategorías para categoría:', savedState.selectedCategoryId);
        if (this.familiesLoader.items.length === 0) {
          this.loadFamiliesPage(1, true);
        }
        if (savedState.selectedFamilyId !== null) {
          this.categoriesLoader.reset();
          this.loadCategoriesPage(savedState.selectedFamilyId, 1, true);
        }
        if (savedState.selectedCategoryId !== null) {
          this.subcategoriesLoader.reset();
          this.loadSubcategoriesPage(savedState.selectedCategoryId, 1, true);
          // También cargar productos/servicios directos de esta categoría
          this.productsServicesLoader.reset();
          this.loadProductsServicesPage({
            familyId: savedState.selectedFamilyId === 0 ? 'null' : savedState.selectedFamilyId,
            categoryId: savedState.selectedCategoryId,
            warehouse: this.warehouseSelected,
            pricelist: this.PriceListSelected,
          }, 1, true);
        }
      } else if (savedState.navigationLevel === 3) {
        // Cargar subcategorías y productos
        // console.log('Nivel 3 - cargando productos para subcategoría:', savedState.selectedSubcategoryId);
        if (this.familiesLoader.items.length === 0) {
          this.loadFamiliesPage(1, true);
        }
        if (savedState.selectedFamilyId !== null && savedState.selectedFamilyId !== 0) {
          this.categoriesLoader.reset();
          this.loadCategoriesPage(savedState.selectedFamilyId, 1, true);
        }
        if (savedState.selectedCategoryId !== null) {
          this.subcategoriesLoader.reset();
          this.loadSubcategoriesPage(savedState.selectedCategoryId, 1, true);
        }
        // Cargar productos/servicios
        this.productsServicesLoader.reset();
        this.loadProductsServicesPage({
          familyId: savedState.selectedFamilyId === 0 ? 'null' : savedState.selectedFamilyId,
          categoryId: savedState.selectedCategoryId,
          subcategoryId: savedState.selectedSubcategoryId,
          warehouse: this.warehouseSelected,
          pricelist: this.PriceListSelected,
        }, 1, true);
      }
    },
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;
      // Expandir el panel cuando entra a fullscreen
      if (this.fullscreen) {
        this.togglehide = true;
      }
      // Cambiar showDrawer en el store
      this.$store.commit('setShowDrawer', !this.fullscreen);
      // Emitir evento para que App.vue oculte el drawer
      this.$emit('toggle-fullscreen', this.fullscreen);
      // Prevenir scroll del body cuando está en fullscreen
      if (this.fullscreen) {
        document.body.style.overflow = 'hidden';
        // Solicitar fullscreen del navegador
        document.documentElement.requestFullscreen?.() || 
        document.documentElement.webkitRequestFullscreen?.() ||
        document.documentElement.mozRequestFullScreen?.();
      } else {
        document.body.style.overflow = 'auto';
        // Salir de fullscreen del navegador
        document.exitFullscreen?.() ||
        document.webkitExitFullscreen?.() ||
        document.mozCancelFullScreen?.();
      }
    },
    openItemComments(item) {
      this.commentsObject = item;
      this.showItemComments = true;
    },
    openDiscountDialog(item, index) {
      // Crear una copia del item para editar en el diálogo
      // Usar ItemNewPrice (precio actual en UI) como base para descuentos, no el guardado
      this.discountEditingItem = {
        ...item,
        ItemPriceDiscountPercent: item.ItemPriceDiscountPercent || 0,
        ItemPriceDiscountAmount: item.ItemPriceDiscountAmount || 0,
        ItemOriginalPrice: item.ItemNewPrice || item.ItemOriginalPrice || 0, // Usar el precio ACTUAL
      };
      this.discountEditingIndex = index;
      this.showDiscountDialog = true;
    },
    calculatePriceWithDiscount() {
      if (!this.discountEditingItem) return 0;
      const originalPrice = this.discountEditingItem.ItemOriginalPrice || 0;
      const discountAmount = this.discountEditingItem.ItemPriceDiscountAmount || 0;
      const discountPercent = this.discountEditingItem.ItemPriceDiscountPercent || 0;
      
      let totalDiscount = discountAmount;
      if (discountPercent > 0) {
        totalDiscount = originalPrice * (discountPercent / 100);
      }
      
      return originalPrice - totalDiscount;
    },
    calculateItemTotal(item) {
      return this.getDisplayedLineTotal(item);
    },
    calculateFromPercent() {
      if (!this.discountEditingItem) return;
      const originalPrice = this.discountEditingItem.ItemOriginalPrice || 0;
      const discountPercent = parseFloat(this.discountEditingItem.ItemPriceDiscountPercent) || 0;
      
      // Calcular el monto basado en el porcentaje
      if (discountPercent > 0) {
        this.discountEditingItem.ItemPriceDiscountAmount = parseFloat(
          (originalPrice * (discountPercent / 100)).toFixed(2)
        );
      } else {
        this.discountEditingItem.ItemPriceDiscountAmount = 0;
      }
    },
    calculateFromAmount() {
      if (!this.discountEditingItem) return;
      const originalPrice = this.discountEditingItem.ItemOriginalPrice || 0;
      const discountAmount = parseFloat(this.discountEditingItem.ItemPriceDiscountAmount) || 0;
      
      // Calcular el porcentaje basado en el monto
      if (discountAmount > 0 && originalPrice > 0) {
        this.discountEditingItem.ItemPriceDiscountPercent = parseFloat(
          ((discountAmount / originalPrice) * 100).toFixed(2)
        );
      } else {
        this.discountEditingItem.ItemPriceDiscountPercent = 0;
      }
    },
    saveDiscount() {
      if (this.discountEditingIndex !== null && this.discountEditingItem) {
        // Calcular el precio final para validar
        const originalPrice = parseFloat(this.discountEditingItem.ItemOriginalPrice) || 0;
        const discountPercent = parseFloat(this.discountEditingItem.ItemPriceDiscountPercent) || 0;
        let discountAmount = parseFloat(this.discountEditingItem.ItemPriceDiscountAmount) || 0;

        // Si hay porcentaje, calcular el monto correspondiente
        if (discountPercent > 0) {
          discountAmount = originalPrice * (discountPercent / 100);
        }

        const finalPrice = originalPrice - discountAmount;
        if (finalPrice <= 0) {
          this.showAlert('danger', 'Descuento inválido', 'El descuento no puede hacer que el precio sea cero o negativo.');
          return;
        }

        const idx = this.discountEditingIndex;

        // Actualizar el item en el array con los nuevos valores de descuento
        this.$set(this.productsToShow[idx], 'ItemPriceDiscountPercent', 
          parseFloat(this.discountEditingItem.ItemPriceDiscountPercent) || 0);
        this.$set(this.productsToShow[idx], 'ItemPriceDiscountAmount', 
          discountAmount);

        // Recalcular ItemNewNewPrice (qty * (original - descuento)) para que totales se actualicen
        const item = this.productsToShow[idx];
        const qty = parseFloat(item.qty) || 1;
        const itemOriginal = parseFloat(item.ItemOriginalPrice || item.ItemNewPrice) || 0;
        const itemNewNew = parseFloat((qty * (itemOriginal - discountAmount))).toFixed(8);
        this.$set(item, 'ItemNewNewPrice', itemNewNew);

        // Actualizar también en el body (para enviar al backend)
        this.$set(this.body[idx], 'ItemPriceDiscountPercent', 
          parseFloat(this.discountEditingItem.ItemPriceDiscountPercent) || 0);
        this.$set(this.body[idx], 'ItemPriceDiscountAmount', 
          discountAmount);
        this.$set(this.body[idx], 'ItemNewNewPrice', itemNewNew);

        // Actualizar el store
        this.$store.commit("posData/setBody", this.body);

        // Actualizar discountObject para que los computed y buildItemsData usen los descuentos
        this.$set(this.discountObject, idx, {
          amount: discountAmount,
          percent: parseFloat(this.discountEditingItem.ItemPriceDiscountPercent) || 0
        });

        // Cerrar el diálogo
        this.showDiscountDialog = false;
        this.discountEditingItem = null;
        this.discountEditingIndex = null;
      }
    },
    onModeListChange(newVal) {
      if (newVal) {
        // Se activó el modo de categorías
        
        // Si hay estado guardado, restaurarlo
        if (this.savedNavigationState) {
          const savedState = this.savedNavigationState;
          this.navigationLevel = savedState.navigationLevel;
          this.selectedFamilyId = savedState.selectedFamilyId;
          this.selectedCategoryId = savedState.selectedCategoryId;
          this.selectedSubcategoryId = savedState.selectedSubcategoryId;
          this.navigationStack = savedState.navigationStack;
          this.displayedItemsCount = savedState.displayedItemsCount;
          this.savedNavigationState = null;
          
          // Recargar los datos en los loaders basándose en el nivel restaurado
          this.$nextTick(() => {
            this.restoreNavigationData(savedState);
          });
        } else if (this.familiesLoader.items.length === 0) {
          this.loadAllCategoryHierarchy();
        } else {
          console.log('Familias ya cargadas');
        }
      } else {
        // Se desactivó el modo de categorías
        
        // Guardar el estado actual
        this.savedNavigationState = {
          navigationLevel: this.navigationLevel,
          selectedFamilyId: this.selectedFamilyId,
          selectedCategoryId: this.selectedCategoryId,
          selectedSubcategoryId: this.selectedSubcategoryId,
          navigationStack: JSON.parse(JSON.stringify(this.navigationStack)), // Deep copy
          displayedItemsCount: this.displayedItemsCount,
        };
       // console.log('Estado guardado:', this.savedNavigationState);
        
        // Resetear los filtros de navegación para mostrar todos los productos
        this.navigationLevel = 0;
        this.selectedFamilyId = null;
        this.selectedCategoryId = null;
        this.selectedSubcategoryId = null;
        this.navigationStack = [];
        this.displayedItemsCount = 30;
        
        // Resetear loader y cargar todos los productos con warehouse y pricelist
        this.productsServicesLoader.reset();
        this.loadProductsServicesPage({
          warehouse: this.warehouseSelected,
          pricelist: this.PriceListSelected,
          filter: ''
        }, 1, true);
      }
    },
    getCustomerName() {
      const customer = this.customersList.find(
        (c) => c.ID_Customer === this.form.idcustomer
      );
      // Retornar LegalName si está disponible, si no itemText, si no el nombre guardado
      if (customer?.LegalName) {
        return customer.LegalName;
      }
      
      return customer ? customer.itemText : (this.form.idcustomernombre || "Sin cliente");
    },
    searchSeveralCustomer() {
      const foundCustomer = this.customersList.find(
        (current) => Number(current.IsSeveralCustomer) === 1 && Number(current.IsDomicilio) !== 1 && Number(current.Is_a_Table) !== 1
      );
      if (foundCustomer) {
        this.customerSelected(foundCustomer);
        this.form.invoicestatusdescription = "Cancelada";
        // Validar header después de cambios
        this.validateHeader();
      } else {
        this.showAlert("warning", "Información", "No hay clientes varios por defecto");
      }
    },
    async searchDomicilioCustomer() {
      let foundCustomer = null;
      try {
        foundCustomer = await this.$API.customers.getDomicilioCustomer({
          business: this.business,
          branch: this.branch,
        });
      } catch (error) {
        this.showAlert("error", "Error", "No fue posible buscar el cliente domicilio");
        return;
      }

      if (foundCustomer?.data) {
        foundCustomer = foundCustomer.data;
      }

      if (foundCustomer && Number(foundCustomer.IsSeveralCustomer) !== 1 && Number(foundCustomer.Is_a_Table) !== 1) {
        foundCustomer = this.assignCustomersList([foundCustomer])[0];
      } else {
        foundCustomer = null;
      }

      if (foundCustomer) {
        this.customerSelected(foundCustomer);
        this.form.invoicestatusdescription = "Cancelada";
        this.validateHeader();
      } else {
        this.showAlert("warning", "Información", "No hay cliente domicilio por defecto");
      }
    },
    updateTempInvoiceField() {
      // Placeholder - se implementará con el resto de PRIMER CARD
    },
    async getAllCustomers() {
      try {
        const params = {
          business: this.business,
          branch: this.branch,
        };

        const customers =
          await this.$API.customers.getCustomersPOSCreateInvoice(params);
        this.customersList = this.assignCustomersList(customers);
      } catch (error) {
        // Error al obtener clientes
      }
    },
    async loadAllCustomers() {
      try {
        const params = {
          business: this.business,
          branch: this.branch,
        };

        const customers =
          await this.$API.customers.getCustomersPOSCreateInvoice(params);
        this.allCustomers = this.assignCustomersList(customers);
      } catch (error) {
        // Error al obtener clientes
      }
    },
    updateCustomersList(payload) {
      this.allCustomers = this.assignCustomersList(payload);
    },
    assignCustomersList(customers) {
      return customers.map((current) => {
        if (current.Is_a_Business) {
          return {
            ...current,
            Is_a_Table: current.Is_a_Table,
            itemText: `${current.BusinessName || current.LegalName} (${current.ID_Customer})`,
          };
        } else {
          return {
            ...current,
            Is_a_Table: current.Is_a_Table,
            itemText: `${current.FirstName || ""} ${current.LastName || ""}`.trim(),
          };
        }
      });
    },
    customerSelected(customer) {
      // Guardar el cliente completo para acceder a su numDocumento
      this.selectedCustomer = customer;
      
      // Asignar cliente seleccionado
      this.form.idcustomer = customer.ID_Customer;
      
      // Mapear todos los campos del cliente al form
      Object.keys(customer).map((el) => {
        Vue.set(this.form, el.replace("_", "").toLowerCase(), customer[el]);
      });

      // Also map the legal* fields used by Create.vue to ensure header parity
      this.form.legalname = customer.LegalName || customer.BusinessName || this.form.legalname || "";
      this.form.legaladdress = customer.LegalAddress || this.form.legaladdress || "";
      this.form.legaladdress2 = customer.LegalAddress2 || this.form.legaladdress2 || "";
      this.form.legalnit = customer.LegalNIT || this.form.legalnit || "";
      this.form.legalnrc = customer.LegalNRC || this.form.legalnrc || "";
      this.form.legalentity = customer.LegalEntity || this.form.legalentity || "";
      this.form.legalisnontaxable = customer.LegalIsNonTaxable || this.form.legalisnontaxable || false;
      this.BccEmails = customer.BccEmailsCustomer || this.BccEmails || [];
      
      this.activarPropinas = this.propinasdefault ? this.form.nopropinas === 0 : 0;

      // Ensure selectedCustomer has the same fields for header building
      Vue.set(this.selectedCustomer, 'LegalName', this.form.legalname);
      Vue.set(this.selectedCustomer, 'LegalAddress', this.form.legaladdress);
      Vue.set(this.selectedCustomer, 'LegalAddress2', this.form.legaladdress2);
      Vue.set(this.selectedCustomer, 'LegalNIT', this.form.legalnit);
      Vue.set(this.selectedCustomer, 'LegalNRC', this.form.legalnrc);
      Vue.set(this.selectedCustomer, 'LegalEntity', this.form.legalentity);
      Vue.set(this.selectedCustomer, 'LegalIsNonTaxable', this.form.legalisnontaxable);
      Vue.set(this.selectedCustomer, 'BccEmailsCustomer', this.BccEmails);

      // Agregar el cliente/mesa a customersList si no existe
      if (
        !this.customersList.find(
          (current) => current.ID_Customer === customer.ID_Customer
        )
      ) {
        // Si es una mesa, establecer el nombre como "CLIENTES VARIOS"
        if (customer.Is_a_Table) {
          customer.itemText = "CLIENTES VARIOS";
        } else if (customer.BusinessName) {
          customer.itemText = customer.BusinessName;
        } else if (customer.LegalName) {
          customer.itemText = customer.LegalName;
        }
        this.customersList.push(customer);
      }
      
      // Si es una mesa, establecer el nombre del cliente como el nombre de la mesa
      if (customer.Is_a_Table) {
        this.form.idcustomernombre = `${customer.FirstName || ""} ${customer.LastName || ""}`.trim() || "CLIENTES VARIOS";
      } else if (customer.BusinessName) {
        this.form.idcustomernombre = customer.BusinessName;
      } else if (customer.LegalName) {
        this.form.idcustomernombre = customer.LegalName;
      }
      
      // Cargar datos detallados del cliente (mantener compatibilidad con campos existentes)
      this.form.invoicename = this.form.legalname || customer.LegalName || customer.BusinessName || "";
      this.form.invoiceaddress = this.form.legaladdress || customer.LegalAddress || "";
      this.form.invoicenit = this.form.legalnit || customer.LegalNIT || "";
      this.form.invoicenrc = this.form.legalnrc || customer.LegalNRC || "";
      this.form.codactividad = customer.codActividad || "";
      this.form.descactividad = customer.descActividad || "";
      this.form.isa_business = customer.Is_a_Business || false;
      
      if (this.form.codactividad) {
        const activity = this.activities.find(act => act.Codigo == this.form.codactividad);
        this.form.descactividad = activity ? activity.Valores : this.form.descactividad;
      }
      // Cargar documento de identidad desde posibles campos y aplicar máscara
      this.form.dui = applyDUIMaskOutOfInput(customer.dui) || "";

      this.form.phonenumber = customer.PhoneNumber || "";
      this.form.email = customer.Email || "";

      // Business / contact fields (parity with Create.vue)
      this.form.businessphone = customer.BusinessPhone || this.form.businessphone || "";
      this.form.businessmobilenumber = customer.BusinessMobilenumber || this.form.businessmobilenumber || "";
      this.form.businessemail = customer.BusinessEmail || this.form.businessemail || "";
      this.form.businesscontactname = customer.BusinessContactName || this.form.businesscontactname || "";
      this.form.businesscontactphone = customer.BusinessContactPhone || this.form.businesscontactphone || "";
      this.form.businesscontactmobile = customer.BusinessContactMobile || this.form.businesscontactmobile || "";
      this.form.businesscontactemail = customer.BusinessContactEmail || this.form.businesscontactemail || "";

      // Aplicar máscaras a otros campos (NIT/NRC) para mostrar formateado (igual que Create.vue)
      this.form.legalnrc && (this.form.legalnrc = applyDUIMaskOutOfInput(this.form.legalnrc));
      this.form.legalnit && (this.form.legalnit = applyNitMaskHandlingHomologationOutOfInput(this.form.legalnit));
      this.form.invoicenrc && (this.form.invoicenrc = applyDUIMaskOutOfInput(this.form.invoicenrc));
      this.form.invoicenit && (this.form.invoicenit = applyNitMaskHandlingHomologationOutOfInput(this.form.invoicenit));
      // Ensure selectedCustomer contains same business/legal fields used to build header
      Vue.set(this.selectedCustomer, 'DUI', this.form.dui);
      Vue.set(this.selectedCustomer, 'Address', this.form.legaladdress || this.selectedCustomer?.Address || "");
      Vue.set(this.selectedCustomer, 'LegalAddress', this.form.legaladdress || this.selectedCustomer?.LegalAddress || "");
      Vue.set(this.selectedCustomer, 'LegalAddress2', this.form.legaladdress2 || this.selectedCustomer?.LegalAddress2 || "");
      Vue.set(this.selectedCustomer, 'BusinessPhone', this.form.businessphone);
      Vue.set(this.selectedCustomer, 'BusinessMobileNumber', this.form.businessmobilenumber);
      Vue.set(this.selectedCustomer, 'BusinessEmail', this.form.businessemail);
      Vue.set(this.selectedCustomer, 'BusinessContactName', this.form.businesscontactname);
      Vue.set(this.selectedCustomer, 'BusinessContactPhone', this.form.businesscontactphone);
      Vue.set(this.selectedCustomer, 'BusinessContactMobile', this.form.businesscontactmobile);
      Vue.set(this.selectedCustomer, 'BusinessContactEmail', this.form.businesscontactemail);
      
      // Cargar datos del cliente (creditstatus, etc.)
      if (customer.creditstatus) {
        this.form.creditstatus = customer.creditstatus;
      }
      
      // Cargar valores por defecto del cliente
      if (customer.StatusInvoice != null && customer.StatusInvoice != "") {
        this.form.invoicestatusdescription = customer.StatusInvoice;
      }
      if (customer.TypeInvoice != null && customer.TypeInvoice != "") {
        this.form.invoicetype = customer.TypeInvoice;
      }
      if (customer.PaymentType != null && customer.PaymentType != "") {
        if (this.pospayments == 0) {
          this.form.invoicepaymenttype = customer.PaymentType;
        }
      }
      if (customer.ID_Seller != null && customer.ID_Seller != "") {
        this.form.ID_Seller = customer.ID_Seller;
      }
      
      this.updateTempInvoiceField();
      
      // Validar header después de seleccionar cliente
      this.validateHeader();
    },
    onCustomerChange(customer) {
      if (customer) {
        this.customerSelected(customer);
      } else {
        // Si se limpia, resetear cliente y campos relacionados
        this.form.idcustomer = null;
        this.selectedCustomer = null;
        this.customerSearch = '';
        
        // Limpiar campos del diálogo de editar cliente
        this.form.legalname = "";
        this.form.legaladdress = "";
        this.form.legaladdress2 = "";
        this.form.legalnit = "";
        this.form.legalnrc = "";
        this.form.legalentity = "";
        this.form.legalisnontaxable = false;
        this.form.dui = "";
        this.form.phonenumber = "";
        this.form.email = "";
        this.form.businessphone = "";
        this.form.businessmobilenumber = "";
        this.form.businessemail = "";
        this.form.businesscontactname = "";
        this.form.businesscontactphone = "";
        this.form.businesscontactmobile = "";
        this.form.businesscontactemail = "";
        this.BccEmails = [];
        
        this.validateHeader();
      }
    },
    // Email validation helpers (copied from Create.vue)
    isValidEmails(value) {
      if (!value) return true;
      const reg = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      return reg.test(value) || 'Correo electrónico inválido';
    },
    validateEmails() {
      this.BccEmails = this.BccEmails.filter((email) =>
        this.isValidEmails(email)
      );
    },
    async getPaymentTypesValues() {
      try {
        let formaPagoCatalogo = await this.getCatalogMH("FormaPago");
        if (this.keyMaster === "47770e9a83f6f46af2a3d2b93fff710a") {
          formaPagoCatalogo = formaPagoCatalogo.map(x => x.Codigo === '02'
            ? { ...x, Valores: "POS DAVIVIENDA" } 
            : (x.Codigo === '03' ? { ...x, Valores: "POS CREDOMATIC" } : x )
          );
        }else if(this.keyMaster === '2c451b9885da7d373da24547ba01c29a'){
          // Mostrar solo Forma de pagos: o1 Billetes y monedad, 02 Tarjetas, 05 QR. (Coffe Bike)
          formaPagoCatalogo = formaPagoCatalogo
                              .filter(x => x.Codigo === '01' || x.Codigo === '02' || x.Codigo === '05' || x.Codigo === '03')
                              .map(x => x.Codigo === '03'? { ...x, Valores: "QR" }: x); 
        }
        
        this.paymentTypes = formaPagoCatalogo

        this.paymentsData = []
        if (!this.header || !this.header?.payments || this.header?.payments.length == 0) {
          for (let i = 0; i < 5; i++) {
            let item = this.paymentTypes[i]

            this.paymentsData.push(
              {
                typePayment: item.Codigo,
                typePaymentAlt: item.Codigo_Alt,
                descriptionPayment: item.Valores,
                totalPayment: 0.0,
                reference: null,
              }
            )
          }
        }
      } catch (error) {
        // Error al cargar tipos de pago
        console.error("Error cargando métodos de pago:", error);
      }
    },
    readOnlyCreditDays() {
      if (
        this.keyMaster === "d6d47d6edfc3812b5c68c16a07d51d8b" ||
        this.keyMaster === "f33722a12f5e692b30374bbcf86011db"
      ) {
        return !(this.form.creditstatus == "DISPONIBLE" && this.form.creditstatus == 0);
      } else {
        return !(this.form.creditstatus == "DISPONIBLE");
      }
    },

    // Validación previa a enviar (facturar) una factura
    validateInvoiceRequiredFields() {
      // Tipo de pago: si está en 'Crédito' debe tener Días de crédito seleccionados
      if (this.form.invoicestatusdescription == "Crédito") {
        if (!this.form.invoicecreditday || this.form.invoicecreditday === "") {
          this.showAlert(
            "warning",
            "Advertencia",
            "Para facturas a crédito, seleccione los 'Días de crédito'."
          );
          return false;
        }
      }

      // Para facturas de Crédito Fiscal (CCF) validar campos obligatorios
      if (this.form.invoicetype == "CCF") {
        if (!this.form.legalnit || this.form.legalnit === "") {
          this.showAlert("warning", "Advertencia", "Para facturas de crédito fiscal, es requerido el NIT del cliente.");
          return false;
        }
        if (!this.form.legalnrc || this.form.legalnrc === "") {
          this.showAlert("warning", "Advertencia", "Para facturas de crédito fiscal, es requerido el NRC del cliente.");
          return false;
        }
        if (!this.form.department || this.form.department === "") {
          this.showAlert("warning", "Advertencia", "Para facturas de crédito fiscal, es requerido el departamento del cliente.");
          return false;
        }
        if (!this.form.municipality || this.form.municipality === "") {
          this.showAlert("warning", "Advertencia", "Para facturas de crédito fiscal, es requerido el municipio del cliente.");
          return false;
        }
        if (!this.form.legaladdress || this.form.legaladdress === "") {
          this.showAlert("warning", "Advertencia", "Para facturas de crédito fiscal, es requerida la dirección del cliente.");
          return false;
        }
      }

      // Si todas las validaciones pasan, retornar verdadero
      return true;
    },
    async loadFamilies() {
      try {
        const response = await itemtypesAPI.getFamilies();
        this.families = response;
      } catch (error) {
        // Error al cargar familias
      }
    },
    async loadAllCategoryHierarchy() {
      // Carga todas las familias, categorías y subcategorías de una vez
      try {
        //console.log('loadAllCategoryHierarchy iniciado');
        this.saving = true;
        
        // Cargar todas las familias (primera página)
        //console.log('Llamando a loadFamiliesPage');
        await this.loadFamiliesPage(1, true);
        
        this.saving = false;
      } catch (error) {
        console.log('Error al cargar la jerarquía de categorías:', error);
        this.saving = false;
      }
    },
    async loadFamiliesPage(page = 1, reset = false) {
      try {
        this.familiesLoader.prepareForLoading();
        
        const response = await itemtypesAPI.findAllFamiliesPaginated({
          page,
          limit: this.familiesLoader.pageSize,
        });

        //console.log('Respuesta de familias:', response);

        if (reset) {
          this.familiesLoader.updateWithResponse(response, false);
          // Agregar familia "SIN FAMILIA" al inicio de la lista si es la primera página
          if (page === 1) {
            const sinFamiliaItem = {
              id: 0,
              name: 'SIN FAMILIA',
              _isSinFamilia: true
            };
            this.familiesLoader.items.unshift(sinFamiliaItem);
          }
        } else {
          this.familiesLoader.updateWithResponse(response, true);
        }
        
        //console.log('Familias en loader:', this.familiesLoader.items);
        
        // Verificar si hay scroll disponible, si no, cargar siguiente página
        await this.$nextTick();
        this.checkAndLoadNextPage('families');
      } catch (error) {
        console.log('Error al cargar familias:', error);
        this.familiesLoader.isLoading = false;
        this.familiesLoader.loadingItems = [];
      }
    },
    async loadCategoriesPage(familyId, page = 1, reset = false) {
      try {
        this.categoriesLoader.prepareForLoading();
        
        //console.log('loadCategoriesPage iniciado - familyId:', familyId, 'page:', page);
        const response = await itemtypesAPI.findCategoriesByFamilyPaginated(familyId, {
          page,
          limit: this.categoriesLoader.pageSize,
        });

        //console.log('Respuesta de categorías:', response);

        if (reset) {
          this.categoriesLoader.updateWithResponse(response, false);
        } else {
          this.categoriesLoader.updateWithResponse(response, true);
        }
        
        console.log('Categorías en loader:', this.categoriesLoader.items);
        
        // Verificar si hay scroll disponible, si no, cargar siguiente página
        await this.$nextTick();
        this.checkAndLoadNextPage('categories');
      } catch (error) {
        console.log('Error al cargar categorías:', error);
        this.categoriesLoader.isLoading = false;
        this.categoriesLoader.loadingItems = [];
      }
    },
    async loadSubcategoriesPage(categoryId, page = 1, reset = false) {
      try {
        this.subcategoriesLoader.prepareForLoading();
        
        //console.log('loadSubcategoriesPage iniciado - categoryId:', categoryId, 'page:', page);
        const response = await itemtypesAPI.findSubcategoriesByCategoryPaginated(categoryId, {
          page,
          limit: this.subcategoriesLoader.pageSize,
        });

       // console.log('Respuesta de subcategorías:', response);

        if (reset) {
          this.subcategoriesLoader.updateWithResponse(response, false);
        } else {
          this.subcategoriesLoader.updateWithResponse(response, true);
        }
        
       // console.log('Subcategorías en loader:', this.subcategoriesLoader.items);
        
        // Verificar si hay scroll disponible, si no, cargar siguiente página
        await this.$nextTick();
        this.checkAndLoadNextPage('subcategories');
      } catch (error) {
        console.log('Error al cargar subcategorías:', error);
        this.subcategoriesLoader.isLoading = false;
        this.subcategoriesLoader.loadingItems = [];
      }
    },
    async loadProductsServicesPage(filters, page = 1, reset = false) {
      console.log('loadProductsServicesPage called:', { filters, page, reset, modeList: this.modeList });
      try {
        const businessId = JSON.parse(localStorage.getItem("branch"))?.ID_Business;
        const branchId = JSON.parse(localStorage.getItem("user"))?.branch;
        
        this.productsServicesLoader.prepareForLoading();
        // Mostrar los skeletons inmediatamente mientras se cargan los datos
        this.productsAndServices = this.productsServicesLoader.getDisplayItems();
        /*
        console.log('=== loadProductsServicesPage - Skeletons preparados ===');
        console.log('Filter familyId:', filters.familyId);
        console.log('NavigationLevel:', this.navigationLevel);
        console.log('SelectedFamilyId:', this.selectedFamilyId);
        console.log('productsAndServices:', this.productsAndServices);
        console.log('Skeletons count:', this.productsAndServices.filter(i => i._isSkeleton).length);
        console.log('=== FIN ===');
        */
        // Esperar a que Vue renderee los skeletons antes de hacer la llamada al API
        await this.$nextTick();
        
        const params = {
          business: businessId,
          branch: branchId,
          page,
          limit: this.productsServicesLoader.pageSize,
          ...filters
        };

        //console.log('loadProductsServicesPage iniciado - params:', params);
        //console.log('loadProductsServicesPage - filters:', filters);
        
        let response = await productsAPI.getAllWithServicesFilteredPaginated(params);

        console.log('loadProductsServicesPage response:', { dataLength: response?.data?.length, pagination: response?.pagination });

        /*
        console.log('=== RESPUESTA COMPLETA DE PRODUCTOS/SERVICIOS ===');
        console.log('Response completo:', response);
        console.log('Response.data:', response?.data);
        console.log('Response.pagination:', response?.pagination);
        console.log('Cantidad de items:', response?.data?.length);
        console.log('=== FIN RESPUESTA ===');
        */
        // Filtrar productos por familia/categoría/subcategoría en el frontend
        // (en caso de que el backend no lo haga)
        if (response?.data && this.navigationLevel === 3) {
          //const originalLength = response.data.length;
          
          //console.log('=== INICIO FILTRADO FRONTEND ===');
          //console.log('Filters:', filters);
          
          response.data = response.data.filter((item) => {
            // Caso especial: Sin familia (familyId === 'null')
            if (filters.familyId === 'null' || filters.familyId === null) {
              const pass = !item.prod?.IdFamily || item.prod?.family === null;
              return pass;
            }
            
            // Caso normal: filtrar por familia/categoría/subcategoría
            const itemHasFamily = filters.familyId  === undefined || item.prod?.IdFamily === filters.familyId || item.prod?.family === filters.familyId;
            const itemHasCategory = filters.categoryId === undefined || item.prod?.IdCategory === filters.categoryId || item.prod?.category === filters.categoryId;
            // Si no hay filtro de subcategoría, o el item no tiene subcategoría, o la subcategoría coincide, incluir el item
            const itemHasSubcategory = filters.subcategoryId === undefined || !item.prod?.IdSubCategory || item.prod?.IdSubCategory === filters.subcategoryId || item.prod?.subcategory === filters.subcategoryId;

            const pass = itemHasFamily && itemHasCategory && itemHasSubcategory;

            return pass;
          });

          //console.log(`Filtrado frontend: ${originalLength} → ${response.data.length} items`);
          //console.log('=== FIN FILTRADO FRONTEND ===');
        }

        if (reset) {
          this.productsServicesLoader.updateWithResponse(response, false);
          this.productsAndServices = this.productsServicesLoader.getDisplayItems();
        } else {
          this.productsServicesLoader.updateWithResponse(response, true);
          this.productsAndServices = this.productsServicesLoader.getDisplayItems();
        }
        
        //console.log('Productos/servicios en loader:', this.productsServicesLoader.items);
        //console.log('Productos/servicios para mostrar:', this.productsAndServices);
        // Verificar si hay scroll disponible, si no, cargar siguiente página
        await this.$nextTick();
        this.checkAndLoadNextPage('products');
      } catch (error) {
        console.log('Error al cargar productos/servicios:', error);
        this.productsServicesLoader.isLoading = false;
        this.productsServicesLoader.loadingItems = [];
      }
    },
    async loadCategories() {
      try {
        const response = await itemtypesAPI.getCategories();
        this.categories = response;
      } catch (error) {
        // Error al cargar categorías
      }
    },
    async getCategoriesByFamily(familyId) {
      try {
        const response = await itemtypesAPI.getCategoriesByFamily({
          id_family: familyId,
        });
        this.categories = response;
      } catch (error) {
        // Error al cargar categorías por familia
      }
    },
    async loadProductsAndServices() {
      try {
        this.saving = true;  // Mostrar overlay de carga
        const businessId = JSON.parse(localStorage.getItem("branch"))?.ID_Business;
        const branchId = JSON.parse(localStorage.getItem("user"))?.branch;
        
        const params = {
          business: businessId,
          branch: branchId,
          filter: '', // Parámetro de búsqueda vacío para traer todos
          enablenegativeitem: this.enablenegativeitem,
        };

        const response = await productsAPI.getAllWithServicesFiltered(params);
        this.productsAndServices = response;
        this.saving = false;  // Ocultar overlay de carga
      } catch (error) {
        // Error al cargar productos y servicios
        this.saving = false;  // Ocultar overlay en caso de error
      }
    },
    async searchProducts(autoAddSingleResult = false) {
      try {
        const businessId = JSON.parse(localStorage.getItem("branch"))?.ID_Business;
        const branchId = JSON.parse(localStorage.getItem("user"))?.branch;
        
        // Si estamos en modo categorías, guardar el estado antes de desactivar
        if (this.modeList) {
          this.savedNavigationState = {
            navigationLevel: this.navigationLevel,
            selectedFamilyId: this.selectedFamilyId,
            selectedCategoryId: this.selectedCategoryId,
            selectedSubcategoryId: this.selectedSubcategoryId,
            navigationStack: JSON.parse(JSON.stringify(this.navigationStack)), // Deep copy
            displayedItemsCount: this.displayedItemsCount,
          };
          //console.log('Estado guardado antes de buscar:', this.savedNavigationState);
        }
        
        // Desactivar el switch de categorías al buscar por nombre
        this.modeList = false;
        
        // Resetear los filtros de familia y categoría al hacer una búsqueda
        this.selectedFamilyId = null;
        this.selectedCategoryId = null;
        this.displayedItemsCount = 20; // Resetear la paginación
        const params = {
          business: businessId,
          branch: branchId,
          filter: this.searchProductName || '', // Usar el valor del textfield de búsqueda
          barcode: this.selectedBarCode || '',
          warehouse: this.warehouseSelected || '',
          pricelist: this.PriceListSelected || '',
          enablenegativeitem: this.enablenegativeitem,
        };

        const response = await productsAPI.getAllWithServicesFiltered(params);
        this.productsAndServices = response;
        if (autoAddSingleResult && Array.isArray(response) && response.length === 1) {
          this.addItemToInvoice(response[0]);
          this.searchProductName = ''
        }
        return response;
      } catch (error) {
        // Error al buscar productos y servicios
        return [];
      }
    },
    onProductsScroll(event) {
      const container = event.target;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
            
      // Cargar 50px antes de llegar al final
      if (distanceFromBottom < 50) {
        this.handleScrollReachEnd();
      }
    },
    checkAndLoadNextPage(level) {
      // Verificar si hay scroll disponible
      // Si no hay scroll (el contenido cabe completamente en la pantalla),
      // cargar la siguiente página automáticamente
      const container = this.$refs.productsContainer;
      
      if (!container) {
        return;
      }
      
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      const hasScroll = scrollHeight > clientHeight;
      
      console.log(`checkAndLoadNextPage (${level}): scrollHeight=${scrollHeight}, clientHeight=${clientHeight}, hasScroll=${hasScroll}`);
      
      // Si no hay scroll y aún hay más datos disponibles, cargar siguiente página
      if (!hasScroll) {
        console.log(`checkAndLoadNextPage (${level}): Sin scroll detectado, cargando siguiente página...`);
        
        if (level === 'families' && this.modeList) {
          const nextPage = this.familiesLoader.nextPage();
          if (nextPage) {
            console.log(`checkAndLoadNextPage: Cargando página ${nextPage} de familias`);
            this.loadFamiliesPage(nextPage, false);
          } else {
            console.log(`checkAndLoadNextPage: No hay más páginas de familias`);
          }
        } else if (level === 'categories' && this.modeList && this.navigationLevel === 1) {
          const nextPage = this.categoriesLoader.nextPage();
          if (nextPage) {
            console.log(`checkAndLoadNextPage: Cargando página ${nextPage} de categorías`);
            this.loadCategoriesPage(this.selectedFamilyId, nextPage, false);
          } else {
            console.log(`checkAndLoadNextPage: No hay más páginas de categorías`);
          }
        } else if (level === 'subcategories' && this.modeList && this.navigationLevel === 2) {
          const nextPage = this.subcategoriesLoader.nextPage();
          if (nextPage) {
            this.loadSubcategoriesPage(this.selectedCategoryId, nextPage, false);
          }
        } else if (level === 'products') {
          if (this.modeList && this.navigationLevel === 3) {
            const nextPage = this.productsServicesLoader.nextPage();
            if (nextPage) {
              this.loadProductsServicesPage({
                familyId: this.selectedFamilyId,
                categoryId: this.selectedCategoryId,
                subcategoryId: this.selectedSubcategoryId,
                warehouse: this.warehouseSelected,
                pricelist: this.PriceListSelected,
              }, nextPage, false);
            }
          } else if (!this.modeList) {
            const nextPage = this.productsServicesLoader.nextPage();
            if (nextPage) {
              this.loadProductsServicesPage({
                filter: this.searchProductName || ''
              }, nextPage, false);
            }
          }
        }
      }
    },
    handleScrollReachEnd() {
      // Determinar qué nivel está activo y cargar más datos
      if (this.modeList) {
        if (this.navigationLevel === 0) {
          // Cargar más familias
          const nextPage = this.familiesLoader.nextPage();
          if (nextPage) {
            this.loadFamiliesPage(nextPage, false);
          }
        } else if (this.navigationLevel === 1) {
          // Cargar más categorías
          const nextPage = this.categoriesLoader.nextPage();
          if (nextPage) {
            this.loadCategoriesPage(this.selectedFamilyId, nextPage, false);
          }
        } else if (this.navigationLevel === 2) {
          // Cargar más subcategorías
          const nextPage = this.subcategoriesLoader.nextPage();
          if (nextPage) {
            this.loadSubcategoriesPage(this.selectedCategoryId, nextPage, false);
          }
        } else if (this.navigationLevel === 3) {
          // Cargar más productos/servicios
          const nextPage = this.productsServicesLoader.nextPage();
          if (nextPage) {
            // Incrementar displayedItemsCount para mostrar los nuevos items
            this.displayedItemsCount += this.productsServicesLoader.pageSize;
            this.loadProductsServicesPage({
              familyId: this.selectedFamilyId === 0 ? 'null' : this.selectedFamilyId,
              categoryId: this.selectedCategoryId,
              subcategoryId: this.selectedSubcategoryId,
              warehouse: this.warehouseSelected,
              pricelist: this.PriceListSelected,
            }, nextPage, false);
          }
        }
      } else {
        // Cargar más productos/servicios cuando switch está off
        const nextPage = this.productsServicesLoader.nextPage();
        if (nextPage) {
          this.loadProductsServicesPage({
            filter: this.searchProductName || ''
          }, nextPage, false);
        }
      }
    },

    selectFamily(familyId) {
      // Guardar estado actual en el stack de navegación
      this.navigationStack.push({
        level: this.navigationLevel,
        familyId: this.selectedFamilyId,
        categoryId: this.selectedCategoryId,
        subcategoryId: this.selectedSubcategoryId,
      });
      
      this.selectedFamilyId = familyId;
      this.selectedCategoryId = null;
      this.selectedSubcategoryId = null;
      this.displayedItemsCount = 20; // Resetear la paginación
      
      // Si se selecciona "SIN FAMILIA", cargar directamente productos/servicios sin familia
      if (familyId === 0) {
        this.navigationLevel = 3; // Pasar directamente al nivel de productos/servicios
        this.productsServicesLoader.reset();
        this.loadProductsServicesPage({
          familyId: 'null', // Sin familia - string para filtrar items sin familia
        }, 1, true);
      } else {
        this.navigationLevel = 1; // Pasar al nivel de categorías
        
        // Cargar categorías paginadas
        this.categoriesLoader.reset();
        this.loadCategoriesPage(familyId, 1, true);
        
        // También cargar productos/servicios directos de esta familia (sin categoría ni subcategoría)
        this.productsServicesLoader.reset();
        this.loadProductsServicesPage({
          familyId: familyId,
          warehouse: this.warehouseSelected,
          pricelist: this.PriceListSelected,
        }, 1, true);
      }
    },
    selectCategory(categoryId) {
      // Guardar estado actual en el stack de navegación
      this.navigationStack.push({
        level: this.navigationLevel,
        familyId: this.selectedFamilyId,
        categoryId: this.selectedCategoryId,
        subcategoryId: this.selectedSubcategoryId,
      });
      
      this.selectedCategoryId = categoryId;
      this.selectedSubcategoryId = null;
      this.navigationLevel = 2; // Pasar al nivel de subcategorías
      this.displayedItemsCount = 20; // Resetear la paginación
      
      // Cargar subcategorías paginadas
      this.subcategoriesLoader.reset();
      this.loadSubcategoriesPage(categoryId, 1, true);
      
      // También cargar productos/servicios directos de esta categoría (sin subcategoría)
      this.productsServicesLoader.reset();
      this.loadProductsServicesPage({
        familyId: this.selectedFamilyId,
        categoryId: categoryId,
        warehouse: this.warehouseSelected,
        pricelist: this.PriceListSelected,
      }, 1, true);
    },
    selectSubcategory(subcategoryId) {
      // Guardar estado actual en el stack de navegación
      this.navigationStack.push({
        level: this.navigationLevel,
        familyId: this.selectedFamilyId,
        categoryId: this.selectedCategoryId,
        subcategoryId: this.selectedSubcategoryId,
      });
      
      this.selectedSubcategoryId = subcategoryId;
      this.navigationLevel = 3; // Pasar al nivel de productos/servicios
      this.displayedItemsCount = 20; // Resetear la paginación
      
      // Cargar productos/servicios paginados
      this.productsServicesLoader.reset();
      this.loadProductsServicesPage({
        familyId: this.selectedFamilyId,
        categoryId: this.selectedCategoryId,
        subcategoryId: subcategoryId,
        warehouse: this.warehouseSelected,
        pricelist: this.PriceListSelected,
      }, 1, true);
    },
    goBack() {
      if (this.navigationStack.length === 0) {
        // Si el stack está vacío, volver al nivel 0 (familias)
        this.navigationLevel = 0;
        this.selectedFamilyId = null;
        this.selectedCategoryId = null;
        this.selectedSubcategoryId = null;
        this.displayedItemsCount = 20;
        this.familiesLoader.reset();
        this.productsServicesLoader.reset();
        this.loadFamiliesPage(1, true);
      } else {
        // Restaurar el estado anterior del stack
        const previousState = this.navigationStack.pop();
        if (previousState) {
          this.navigationLevel = previousState.level;
          this.selectedFamilyId = previousState.familyId;
          this.selectedCategoryId = previousState.categoryId;
          this.selectedSubcategoryId = previousState.subcategoryId;
          this.displayedItemsCount = 20;
          
          // Cargar datos paginados según el nivel
          if (previousState.level === 0) {
            this.familiesLoader.reset();
            this.productsServicesLoader.reset();
            this.loadFamiliesPage(1, true);
          } else if (previousState.level === 1 && previousState.familyId) {
            this.categoriesLoader.reset();
            this.loadCategoriesPage(previousState.familyId, 1, true);
            // También cargar productos/servicios directos de esta familia
            this.productsServicesLoader.reset();
            this.loadProductsServicesPage({
              familyId: previousState.familyId,
              warehouse: this.warehouseSelected,
              pricelist: this.PriceListSelected,
            }, 1, true);
          } else if (previousState.level === 2 && previousState.categoryId) {
            this.subcategoriesLoader.reset();
            this.loadSubcategoriesPage(previousState.categoryId, 1, true);
            // También cargar productos/servicios directos de esta categoría
            this.productsServicesLoader.reset();
            this.loadProductsServicesPage({
              familyId: previousState.familyId,
              categoryId: previousState.categoryId,
              warehouse: this.warehouseSelected,
              pricelist: this.PriceListSelected,
            }, 1, true);
          } else if (previousState.level === 3) {
            this.productsServicesLoader.reset();
            this.loadProductsServicesPage({
              familyId: previousState.familyId,
              categoryId: previousState.categoryId,
              subcategoryId: previousState.subcategoryId,
              warehouse: this.warehouseSelected,
              pricelist: this.PriceListSelected,
            }, 1, true);
          }
        } else {
          // Si el stack está vacío pero llegamos aquí, ir al nivel 0
          this.navigationLevel = 0;
          this.selectedFamilyId = null;
          this.selectedCategoryId = null;
          this.selectedSubcategoryId = null;
          this.displayedItemsCount = 20;
          this.familiesLoader.reset();
          this.productsServicesLoader.reset();
          this.loadFamiliesPage(1, true);
        }
      }
    },
    navigateToBreadcrumbLevel(level, id) {
      // Navegar a un nivel específico desde el breadcrumb
      if (level === 0) {
        // Volver a familias
        this.navigationLevel = 0;
        this.selectedFamilyId = null;
        this.selectedCategoryId = null;
        this.selectedSubcategoryId = null;
        this.navigationStack = [];
        this.displayedItemsCount = 20;
        this.familiesLoader.reset();
        this.productsServicesLoader.reset();
        this.loadFamiliesPage(1, true);
      } else if (level === 1 && id === 0) {
        // Ir a "SIN FAMILIA" - carga productos directamente
        this.navigationLevel = 3;
        this.selectedFamilyId = 0;
        this.selectedCategoryId = null;
        this.selectedSubcategoryId = null;
        this.navigationStack = [];
        this.displayedItemsCount = 20;
        this.productsServicesLoader.reset();
        this.loadProductsServicesPage({
          familyId: 'null', // Sin familia - string para filtrar items sin familia
          warehouse: this.warehouseSelected,
          pricelist: this.PriceListSelected,
        }, 1, true);
      } else if (level === 1 && id) {
        // Ir a una familia específica
        this.navigationLevel = 1;
        this.selectedFamilyId = id;
        this.selectedCategoryId = null;
        this.selectedSubcategoryId = null;
        this.navigationStack = [];
        this.displayedItemsCount = 20;
        this.categoriesLoader.reset();
        this.loadCategoriesPage(id, 1, true);
        // También cargar productos/servicios directos de esta familia
        this.productsServicesLoader.reset();
        this.loadProductsServicesPage({
          familyId: id,
          warehouse: this.warehouseSelected,
          pricelist: this.PriceListSelected,
        }, 1, true);
      } else if (level === 2 && id && typeof id !== 'undefined') {
        // Ir a una categoría específica
        this.navigationLevel = 2;
        this.selectedCategoryId = id;
        this.selectedSubcategoryId = null;
        this.navigationStack = [];
        this.displayedItemsCount = 20;
        this.subcategoriesLoader.reset();
        this.loadSubcategoriesPage(id, 1, true);
        // También cargar productos/servicios directos de esta categoría
        this.productsServicesLoader.reset();
        this.loadProductsServicesPage({
          familyId: this.selectedFamilyId,
          categoryId: id,
          warehouse: this.warehouseSelected,
          pricelist: this.PriceListSelected,
        }, 1, true);
      } else if (level === 3 && id) {
        // Ir a una subcategoría específica
        this.navigationLevel = 3;
        this.selectedSubcategoryId = id;
        this.navigationStack = [];
        this.displayedItemsCount = 20;
        this.productsServicesLoader.reset();
        this.loadProductsServicesPage({
          familyId: this.selectedFamilyId,
          categoryId: this.selectedCategoryId,
          subcategoryId: id,
          warehouse: this.warehouseSelected,
          pricelist: this.PriceListSelected,
        }, 1, true);
      }
    },
    getWarehouse() {
      let idbusiness = JSON.parse(localStorage.getItem("user")).businessid || "";
      let idbranch = JSON.parse(localStorage.getItem("user")).branch || "";
      this.filterWarehouses.branch = idbranch;
      this.filterWarehouses.business = idbusiness;
      this.$API.warehouse
        .getWarehouses({...this.filterWarehouses, notShowReserve: 1 })
        .then((response) => {
          this.warehouses = response;
          const found = this.warehouses.find(
            (wh) => wh.Active == true && wh.ID_Branch == idbranch
          );
          if (found) {
            this.warehouseSelected = found.ID_Warehouse;
          } else if (this.warehouses.length > 0) {
            this.warehouseSelected = this.warehouses[0].ID_Warehouse;
          }
        })
        .catch(() => {});
    },
    async getAllPriceList() {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        let response = [];
        if (this.$store.getters['rolesUser/getCustomRole']('admin')){
          response = await this.$API.priceList.priceListNoData();
        } else {
          response = await this.$API.priceList.priceListNotAdmin();
        }
        this.priceListData = response;
        let found = this.priceListData.find(
          (pl) =>
            pl.Active == true &&
            pl.ID_Branch == user?.branch
        );
        if (found) {
          this.PriceListSelected = found.id;
        } else if (this.priceListData.length > 0) {
          this.PriceListSelected = this.priceListData[0].id;
        }
      } catch (error) {
        // Error al cargar lista de precios
      }
    },
    async getPriceListSelected() {
      // Método para cuando se selecciona una lista de precios o warehouse
      // Mostrar loader mientras se cargan los datos
      this.saving = true;
      try {
        await this.searchProducts();
      } catch (error) {
        console.error('Error al recargar productos:', error);
      } finally {
        this.saving = false;
      }
    },
    getProductColor(id) {
      return pickColorPairById(String(id));
    },
    getFamilyName(item) {
      return item.prod?.NameFamily || 'N/A';
    },
    getCategoryName(item) {
      return item.prod?.NameCategory || 'N/A';
    },
    getSubcategoryName(item) {
      return item.prod?.NameSubCategory || 'N/A';
    },
    toNumber(value) {
      const parsed = parseFloat(value);
      return isNaN(parsed) ? 0 : parsed;
    },
    toBooleanFlag(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },
    getCatalogTaxFlags(data) {
      const isExempt =
        this.toBooleanFlag(data?.IsExempt) ||
        this.toBooleanFlag(data?.IsExento) ||
        this.toBooleanFlag(data?.isexempt) ||
        this.toBooleanFlag(data?.isexento);

      const isNoSujeto =
        this.toBooleanFlag(data?.IsNoSujeto) ||
        this.toBooleanFlag(data?.isnosujeto);

      const isNoAfecto =
        this.toBooleanFlag(data?.IsNoAfecto) ||
        this.toBooleanFlag(data?.isnoafecto) ||
        this.toBooleanFlag(data?.ItemNoGravada) ||
        this.toBooleanFlag(data?.ItemNogravada) ||
        this.toBooleanFlag(data?.itemnogravada);

      return {
        nontaxable: isExempt,
        nonsuj: isNoSujeto,
        nogravada: isNoAfecto,
      };
    },
    isTaxFreeItem(item) {
      return (
        this.toBooleanFlag(item?.nontaxable) ||
        this.toBooleanFlag(item?.nonsuj) ||
        this.toBooleanFlag(item?.nogravada) ||
        this.toBooleanFlag(item?.nontaxable2) ||
        this.toBooleanFlag(item?.nonsuj2) ||
        this.toBooleanFlag(item?.nogravada2)
      );
    },
    shouldUseNetTaxFreePrice(item) {
      return this.isTaxFreeItem(item) && item?.sourcePriceIncludesIva !== false && !this.noaddivainpos;
    },
    getTaxFreeConversionFactor(item) {
      return this.addimpturismo && item?.TurismoPorAlojamiento ? 1.18 : 1.13;
    },
    getDisplayedUnitPrice(item) {
      const unitPrice = this.toNumber(item?.ItemNewPrice ?? item?.ItemOriginalPrice ?? 0);
      if (!this.shouldUseNetTaxFreePrice(item)) {
        return unitPrice;
      }

      return parseFloat((unitPrice / this.getTaxFreeConversionFactor(item)).toFixed(8));
    },
    getDisplayedLineTotal(item) {
      const qty = this.toNumber(item?.qty || 0);
      const unitPrice = this.toNumber(item?.ItemNewPrice ?? 0);
      const discountAmount = this.toNumber(item?.ItemPriceDiscountAmount || 0);
      const discountPercent = this.toNumber(item?.ItemPriceDiscountPercent || 0);

      let subtotal = qty * unitPrice;
      let totalDiscount = discountAmount * qty;

      if (discountPercent > 0) {
        totalDiscount = subtotal * (discountPercent / 100);
      }

      let total = Math.max(0, subtotal - totalDiscount);

      if (this.shouldUseNetTaxFreePrice(item)) {
        total = total / this.getTaxFreeConversionFactor(item);
      }

      return parseFloat(total.toFixed(8));
    },
    syncExclusiveTaxFlags(item, activeFlag) {
      if (!item) return;

      if (activeFlag === "nontaxable" && item.nontaxable) {
        item.nonsuj = false;
        item.nogravada = false;
      }

      if (activeFlag === "nonsuj" && item.nonsuj) {
        item.nontaxable = false;
        item.nogravada = false;
      }

      if (activeFlag === "nogravada" && item.nogravada) {
        item.nontaxable = false;
        item.nonsuj = false;
      }
    },
    hasBlockedTipItem(item) {
      const catalogItem = this.resolveCatalogItemForTipFlag(item);
      return (
        this.toBooleanFlag(item?.BloquearPropinas) ||
        this.toBooleanFlag(item?.bloquearpropinas) ||
        this.toBooleanFlag(item?.prod?.BloquearPropinas) ||
        this.toBooleanFlag(item?.prod?.bloquearpropinas) ||
        this.toBooleanFlag(catalogItem?.BloquearPropinas) ||
        this.toBooleanFlag(catalogItem?.bloquearpropinas) ||
        this.toBooleanFlag(catalogItem?.prod?.BloquearPropinas) ||
        this.toBooleanFlag(catalogItem?.prod?.bloquearpropinas)
      );
    },
    resolveCatalogItemForTipFlag(item) {
      const itemId = item?.ID_Item || item?.iditem || item?.val || item?.CodeService || item?.id;
      if (!itemId) {
        return null;
      }

      const candidates = [
        ...(Array.isArray(this.productsToShow) ? this.productsToShow : []),
        ...(Array.isArray(this.productsAndServices) ? this.productsAndServices : []),
        ...(Array.isArray(this.productsServicesLoader?.items) ? this.productsServicesLoader.items : []),
        ...(Array.isArray(this.body) ? this.body : []),
      ];

      return candidates.find((candidate) => {
        const candidateId =
          candidate?.ID_Item ||
          candidate?.iditem ||
          candidate?.val ||
          candidate?.CodeService ||
          candidate?.id;

        return candidateId === itemId;
      }) || null;
    },
    async hydrateBlockedTipFlags(items) {
      const sourceItems = Array.isArray(items) ? items : [];
      const itemIds = [...new Set(sourceItems.map((item) => item?.ID_Item || item?.iditem || item?.val || item?.CodeService).filter(Boolean))];
      const arrayBarcodes = [...new Set(sourceItems.map((item) => item?.BarCode || item?.PrincipalBarCode || item?.principalbarcode).filter(Boolean))];

      if (!itemIds.length && !arrayBarcodes.length) {
        return sourceItems;
      }

      try {
        const response = await this.$API.products.getProductsByArrayID({ arrayID: itemIds, arrayBarcodes });
        const catalogItems = Array.isArray(response?.data) ? response.data : (Array.isArray(response) ? response : []);

        return sourceItems.map((item) => {
          const itemId = item?.ID_Item || item?.iditem || item?.val || item?.CodeService;
          const barcode = item?.BarCode || item?.PrincipalBarCode || item?.principalbarcode;
          const catalogItem = catalogItems.find((candidate) => {
            return (
              candidate?.ID_Item === itemId ||
              candidate?.CodeService === itemId ||
              (barcode && candidate?.BarCode === barcode)
            );
          });

          return {
            ...item,
            BloquearPropinas: item?.BloquearPropinas || item?.bloquearpropinas || item?.prod?.BloquearPropinas || item?.prod?.bloquearpropinas || catalogItem?.BloquearPropinas || catalogItem?.bloquearpropinas || catalogItem?.prod?.BloquearPropinas || catalogItem?.prod?.bloquearpropinas || 0,
            prod: item?.prod || catalogItem || item,
          };
        });
      } catch (error) {
        return sourceItems;
      }
    },
    addItemToInvoice(item) {
      const val = item.val;

      const isService = item.prod?.type === 'service';

      // Buscar disponibilidad en ambos lugares posibles
      const availableQuantity = item.ItemCurrentQuantity !== undefined ? item.ItemCurrentQuantity : (item.prod?.ItemCurrentQuantity || 0);

      // Validar que tenga disponibilidad (solo para productos, no para servicios)
      if (!isService && availableQuantity <= 0) {
        this.showAlert(
          "warning",
          "Sin disponibilidad",
          `Este producto no tiene disponibilidad en stock.`
        );
        return;
      }

      const existingItemIndex = this.productsToShow.findIndex((invoiceItem) => invoiceItem.ID_Item === val);

      if (existingItemIndex !== -1) {
        // Si el item ya existe, usar la función centralizada para incrementar
        this.incrementQuantity(existingItemIndex);
        return;
      }

      // Si no existe, agregarlo con estructura compatible con Create.vue
      const catalogTaxFlags = this.getCatalogTaxFlags(item.prod || item);
      const newItem = {
        uuid: generateUUID(),
        ID_Item: val,
        ID_Business: item.prod?.ID_Business || this.business,
        ItemName: item.ID && item.ID.trim() ? item.ID.split('|')[0].trim() : (item.prod?.NameService || 'Sin nombre'),
        ItemOriginalPrice: item.prod?.ItemOriginalPrice || 0,
        ItemNewPrice: item.prod?.ItemNewPrice || 0,
        qty: 1,
        type: item.prod?.type || 'product',
        Warehouse: item.prod?.Warehouse || "",
        PriceListName: item.prod?.PriceListName || "",
        ItemCurrentQuantity: item.prod?.ItemCurrentQuantity || 0,
        IsExempt: this.toBooleanFlag(item.prod?.IsExempt || item.IsExempt || catalogTaxFlags.nontaxable) ? 1 : 0,
        ...catalogTaxFlags,
        Pk_billing_invoices_details: null,
        ItemComments: '',
        nontaxable: catalogTaxFlags.nontaxable,
        nonsuj: catalogTaxFlags.nonsuj,
        nogravada: catalogTaxFlags.nogravada,
        sourcePriceIncludesIva: !this.noaddivainpos,
        TmpItemNewPrice: item.prod?.ItemNewPrice || 0,
        TmpCounter: 0,
        ItemPriceDiscountPercent: 0,
        ItemPriceDiscountAmount: 0,
        prod: item.prod,
      };

      // Re-check quickly in case another insertion happened between the earlier check and now
      const existingNow = this.productsToShow.findIndex((invoiceItem) => invoiceItem.ID_Item === val);
      if (existingNow !== -1) {
        this.incrementQuantity(existingNow);
      } else {
        this.productsToShow.push(newItem);

        this.discountObject.push({});

        // Actualizar el store
        this.$store.commit("posData/setBody", this.body);
      }
    },
    incrementQuantity(index) {
      // Prevent accidental double increments by ignoring rapid successive calls per item
      this._lastQtyChangeAt = this._lastQtyChangeAt || {};
      const now = Date.now();
      if (this._lastQtyChangeAt[index] && (now - this._lastQtyChangeAt[index]) < 25) return;
      this._lastQtyChangeAt[index] = now;

      if (index >= 0 && index < this.productsToShow.length) {
        const item = this.productsToShow[index];
        // Normalizar tipo de item para validación (SVCS, SERVICE, service → 'service')
        const rawType = item.type || item.ItemType || 'product';
        const isService = ['service', 'svcs', 'svc'].includes(rawType.toLowerCase());
        const availableQuantity = item.ItemCurrentQuantity || 0;
        const currentQty = parseFloat(item.qty) || 1;
        const newQty = currentQty + 1;

        // Validar que no exceda la disponibilidad (solo para productos, no para servicios)
        if (!isService && newQty > availableQuantity) {
          this.showAlert(
            "warning",
            "Advertencia",
            `No hay suficiente disponibilidad. Máximo: ${availableQuantity}`
          );
          return;
        }

        // Setear explícitamente al nuevo valor (evita sumar dos veces si la función es llamada dos veces)
        this.$set(this.productsToShow[index], 'qty', newQty);
        if (this.body[index]) {
          this.$set(this.body[index], 'qty', newQty);
        }
        this.$store.commit("posData/setBody", this.body);
      }
    },
    decrementQuantity(index) {
      // Prevent accidental double decrements by ignoring rapid successive calls per item
      this._lastQtyChangeAt = this._lastQtyChangeAt || {};
      const now = Date.now();
      if (this._lastQtyChangeAt[index] && (now - this._lastQtyChangeAt[index]) < 250) return;
      this._lastQtyChangeAt[index] = now;

      if (index >= 0 && index < this.productsToShow.length) {
        const current = parseInt(this.productsToShow[index].qty) || 1;
        const newQty = current - 1;
        if (newQty >= 1) {
          this.$set(this.productsToShow[index], 'qty', newQty);
          if (this.body[index]) {
            this.$set(this.body[index], 'qty', newQty);
          }
          this.$store.commit("posData/setBody", this.body);
        }
      }
    },


    updateQuantity(index, event) {
      if (index >= 0 && index < this.productsToShow.length) {
        const item = this.productsToShow[index];
        // Normalizar tipo de item para validación (SVCS, SERVICE, service → 'service')
        const rawType = item.type || item.ItemType || 'product';
        const isService = ['service', 'svcs', 'svc'].includes(rawType.toLowerCase());
        const availableQuantity = item.ItemCurrentQuantity || 0;
        let newQty = parseFloat(event.target.value) || 1;
        const qty = newQty < 1 ? 1 : newQty;
        
        // Validar que no exceda la disponibilidad (solo para productos, no para servicios)
        if (!isService && qty > availableQuantity) {
          this.showAlert(
            "warning",
            "Advertencia",
            `No hay suficiente disponibilidad. Máximo: ${availableQuantity}`
          );
          event.target.value = availableQuantity;
          return;
        }
        
        this.$set(this.productsToShow[index], 'qty', qty);
        this.$set(this.body[index], 'qty', qty);
        this.$store.commit("posData/setBody", this.body);
      }
    },
    updateUnitPrice(index, newPrice) {
      const price = parseFloat(newPrice) || 0;
      if (index < 0 || index >= this.productsToShow.length) return;
      const item = this.productsToShow[index];

      // Actualizar precios reactivamente
      this.$set(item, 'ItemNewPrice', price);
      this.$set(item, 'ItemOriginalPrice', price);

      // Calcular descuento efectivo si existe porcentaje
      const percent = parseFloat(item.ItemPriceDiscountPercent || 0);
      let discountAmount = parseFloat(item.ItemPriceDiscountAmount || 0);
      if (percent > 0) {
        discountAmount = parseFloat((price * (percent / 100)).toFixed(8));
      }
      this.$set(item, 'ItemPriceDiscountAmount', discountAmount);

      // Recalcular ItemNewNewPrice (qty * (original - descuento))
      const qty = parseFloat(item.qty) || 1;
      const itemNewNew = parseFloat((qty * (price - discountAmount))).toFixed(8);
      this.$set(item, 'ItemNewNewPrice', itemNewNew);

      // Sincronizar body
      if (this.body[index]) {
        this.$set(this.body[index], 'ItemNewPrice', price);
        this.$set(this.body[index], 'ItemOriginalPrice', price);
        this.$set(this.body[index], 'ItemPriceDiscountAmount', discountAmount);
        this.$set(this.body[index], 'ItemNewNewPrice', itemNewNew);
      }

      // Actualizar objeto de descuentos
      this.$set(this.discountObject, index, { amount: discountAmount, percent: percent });

      // Actualizar store
      this.$store.commit('posData/setBody', this.body);
    },
    async removeRow(data) {
      if(this.invoiceAutoSave) {
        // Si la factura ya existe (autosave activado), eliminar en backend primero
        let responseDeleteDetails = await this.$API.invoices.deleteDestailsInvoice({ 
          item: data.data || data, 
          items2: this.tempDetails, 
          ID_Invoice: this.tempId 
        });

        if (responseDeleteDetails.success) {
          // Si la eliminación en backend fue exitosa, elimina localmente
          //const indexToSplice = this.productsToShow.findIndex( current => 
          //  current.uuid === (data.data?.uuid || data.uuid)
          //);

          this.productsToShow = this.productsToShow.filter(
            item => item.uuid !== (data.data?.uuid || data.uuid)
          )

          this.body = this.body.filter(
            item => item.uuid !== (data.data?.uuid || data.uuid)
          )

          this.discountObject = this.discountObject.filter(
            item => item.uuid !== (data.data?.uuid || data.uuid)
          )

          this.$store.commit("posData/setBody", this.body);

          /*if (indexToSplice !== -1) {
            this.productsToShow.splice(indexToSplice, 1);
            this.body.splice(indexToSplice, 1);
            if (this.discountObject[indexToSplice]) {
              this.discountObject.splice(indexToSplice, 1);
            }
            // Actualizar store
            this.$store.commit("posData/setBody", this.body);
          }*/
        }
        else {
          this.$store.commit("setAlert", { 
            type: "error", 
            message: "Error al eliminar el item: " + (responseDeleteDetails.message || 'Error desconocido') 
          });
        }
      }
      else {
        // Si no hay autosave (factura nueva), solo elimina localmente
        const indexToSplice = this.productsToShow.findIndex( current => 
          current.uuid === (data.data?.uuid || data.uuid)
        );
        if (indexToSplice !== -1) {
          this.productsToShow.splice(indexToSplice, 1);
          console.log(this.productsToShow)
          // this.body.splice(indexToSplice, 1);
          console.log(this.body)
          if (this.discountObject[indexToSplice]) {
            this.discountObject.splice(indexToSplice, 1);
          }
          // Actualizar store
          this.$store.commit("posData/setBody", this.body);
        }
      }
    },
    removeItem(index) {
      // Mantener para compatibilidad, delega a removeRow
      if (index >= 0 && index < this.productsToShow.length) {
        this.removeRow({ data: this.productsToShow[index] });
      }
    },
    async saveInvoice() {
      try {
        this.saving = true; // Mostrar overlay de carga
        
        const header = this.buildHeaderData();
        const items = this.buildItemsData();
        const user = JSON.parse(localStorage.getItem("user")).id;

        // Si existe un ID_Invoice, es actualización; si no, es creación
        const isEdit = this.form.idinvoice && !this.form.idinvoice.includes('temp');

        if (isEdit) {
          // Actualizar factura existente - usar createInvoice con oldIdInvoice
          header.oldIdInvoice = this.form.idinvoice;  // Pasar ID de factura existente
          header.invoicestatus = 0;

          if (this.form.idinvoice?.startsWith("COM")) {
            header.posrestaurant = 1;
          } else {
            header.posrestaurant = 0;
          }

          
          let invalidData = this.invalid != null ? this.invalid : null;
          let ndorncData = this.ndornc != null ? this.ndornc : null;
          if (ndorncData == null && (this.form.invoicetype == 'DNC' || this.form.invoicetype == 'DND')) {
            ndorncData = {
              FechaEmisionRelacionado: this.form.ncfecharelacionado,
              NumeroDocumentoRelacionado: this.form.nccodigorelacionado,
              TipoDocumentoRelacionado: "03",
              TipoGeneracionRelacionado: 1,
              Type: "DNC",
            };
          }
          let contingencyData = this.contingency != null ? this.contingency : null;

          const response = await this.submitPosInvoice({
            header,
            items,
            user,
            invalid: invalidData,
            ndornc: ndorncData,
            contingency: contingencyData,
            UseReserveWarehouse: JSON.parse(localStorage.getItem("user")).usereservewarehouse || 0,
            ShowCorrelativeControl: this.ShowCorrelativeControl || JSON.parse(localStorage.getItem("user")).showcorrelativecontrol || 0,
            UseNewSpNumControl: this.UseNewSpNumControl || JSON.parse(localStorage.getItem("user")).usenewspnumcontrol || 0,
            ServicioDeProPinas: this.servicioDeProPinas || header.ServicioDeProPinas || null
          });

          // Procesar respuesta del backend
          if (response?.success) {
            const idInvoice = response?.createdInvoice?.ID_Invoice || response?.ID_Invoice || this.form.idinvoice;
            const invoiceData = await this.$API.invoices.getInvoice(idInvoice);
            const invoiceItems = await this.$API.invoices.getAllInvoiceItems(idInvoice);
            
            const customerObj = {
              ID_Customer: header.idcustomer,
              LegalName: header.invoicename,
              BusinessName: header.invoicename,
              Is_a_Business: header.isa_business,
              itemText: header.invoicename,
            };
            
            this.$store.commit("posData/setHeader", invoiceData);
            this.$store.commit("posData/setBody", invoiceItems);
            this.$store.commit("posData/setCustomer", customerObj);
            
            // Limpiar la factura después de crear comanda exitosa
            this.clearInvoice();
            
            // Recargar lista de comandas activas
            await this.loadActiveCommands();
          }
        }
      } catch (error) {
        // Error al guardar factura
      } finally {
        this.saving = false; // Ocultar overlay de carga
      }
    },
    async createOrder(rtb = false) {
      let header, items;
      try {
        this.saving = true; // Mostrar overlay de carga
        header = this.buildHeaderData();
        items = this.buildItemsData();

        const user = JSON.parse(localStorage.getItem("user")).id;

        // Marcar que es comanda para imprimir
        this.orderAndPrint = true;
        this.hideQrInPrint = true;

        header.posrestaurant = rtb ? 0 : 1;
        header.invoicestatus = 0;

        let invalidData = this.invalid != null ? this.invalid : null;
        let ndorncData = this.ndornc != null ? this.ndornc : null;
        if (ndorncData == null && (this.form.invoicetype == 'DNC' || this.form.invoicetype == 'DND')) {
          ndorncData = {
            FechaEmisionRelacionado: this.form.ncfecharelacionado,
            NumeroDocumentoRelacionado: this.form.nccodigorelacionado,
            TipoDocumentoRelacionado: "03",
            TipoGeneracionRelacionado: 1,
            Type: "DNC",
          };
        }
        let contingencyData = this.contingency != null ? this.contingency : null;

        const response = await this.submitPosInvoice({
          header,
          items,
          user,
          invalid: invalidData,
          ndornc: ndorncData,
          contingency: contingencyData,
          UseReserveWarehouse: JSON.parse(localStorage.getItem("user")).usereservewarehouse || 0,
          ShowCorrelativeControl: this.ShowCorrelativeControl || JSON.parse(localStorage.getItem("user")).showcorrelativecontrol || 0,
          UseNewSpNumControl: this.UseNewSpNumControl || JSON.parse(localStorage.getItem("user")).usenewspnumcontrol || 0,
          ServicioDeProPinas: this.servicioDeProPinas || header.ServicioDeProPinas || null
        });

        // Procesar respuesta del backend
        if (response?.success) {
          // Obtener datos de la comanda creada para impresión
          // La respuesta tiene estructura: response.data.createdInvoice.ID_Invoice
          const idInvoice = response?.data?.createdInvoice?.ID_Invoice;

          if (idInvoice) {
            if (rtb) {
              this.showAlert(
                  "success",
                  `${rtb ? "Factura" : "Comanda"} creada`,
                  `La ${rtb ? "Factura" : "Comanda"} ha sido creada exitosamente`,
                  "clearInvoice"
                );
            } else {
              try {
                // Cargar datos de la comanda para impresión
                const invoiceHeader = await this.$API.invoices.getInvoice(idInvoice);
                const invoiceBody = await this.$API.invoices.getAllInvoiceItems(idInvoice);
                
                // Validar que los datos se cargaron correctamente
                if (invoiceHeader && invoiceBody) {
                  this.datatoprint.header = invoiceHeader;
                  this.datatoprint.body = invoiceBody;
                  
                  // Intentar cargar el dteJson, pero no es crítico si falla
                  try {
                    this.datatoprint.dteJson = await this.$API.invoices.getDteJsonHeaderByInvoice(idInvoice);
                  } catch (dteError) {
                    console.warn("Advertencia: No se pudo cargar dteJson, continuando sin él", dteError);
                    this.datatoprint.dteJson = null;
                  }
                  
                  this.$store.commit("posData/setHeader", this.datatoprint.header);
                  this.$store.commit("posData/setBody", this.datatoprint.body);
  
                  // Guardar cliente en store para que la edición/carga de la comanda incluya NIT/DUI/direcciones
                  const invoiceHeader2 = this.datatoprint.header || {};
                  const customerObj = {
                    ID_Customer: invoiceHeader2.ID_Customer || invoiceHeader2.idcustomer || header.idcustomer || null,
                    LegalName: invoiceHeader2.InvoiceName || invoiceHeader2.invoicename || header.invoicename || "",
                    BusinessName: invoiceHeader2.InvoiceName || invoiceHeader2.invoicename || header.invoicename || "",
                    Is_a_Business: invoiceHeader2.Is_a_Business || header.isa_business || true,
                    itemText: invoiceHeader2.InvoiceName || invoiceHeader2.invoicename || header.invoicename || "",
                    LegalNIT: invoiceHeader2.InvoiceNIT || invoiceHeader2.invoicenit || header.invoicenit || "",
                    LegalNRC: invoiceHeader2.InvoiceNRC || invoiceHeader2.invoicenrc || header.invoicenrc || "",
                    Legaltaxpayersize: invoiceHeader2.LegalTaxPayerSize || invoiceHeader2.legaltaxpayersize || header.legaltaxpayersize || null,
                    LegalAddress: invoiceHeader2.InvoiceAddress || invoiceHeader2.invoiceaddress || header.invoiceaddress || "",
                    DUI: invoiceHeader2.DUI || invoiceHeader2.dui || header.dui || "",
                    PhoneNumber: invoiceHeader2.PhoneNumber || header.PhoneNumber || this.form.phonenumber || "",
                    Email: invoiceHeader2.Email || header.Email || this.form.email || "",
                    BusinessPhone: invoiceHeader2.BusinessPhone || header.BusinessPhone || "",
                    BusinessEmail: invoiceHeader2.BusinessEmail || header.BusinessEmail || "",
                    codActividad: invoiceHeader2.CodActividad || invoiceHeader2.codactividad || header.codactividad || null,
                    descActividad: invoiceHeader2.DescActividad || invoiceHeader2.descactividad || header.descactividad || null,
                  };
                  this.$store.commit("posData/setCustomer", customerObj);
  
                  console.log("Comanda creada correctamente - Datos cargados para impresión");
                  
                  // Mostrar alerta de éxito
                  console.log("Llamando showAlert...");
                  this.showAlert(
                    "success",
                    `${rtb ? "Factura" : "Comanda"} creada`,
                    `La ${rtb ? "Factura" : "Comanda"} ha sido creada exitosamente`,
                    "updateFinishAndPrintInvoice"
                  );
                } else {
                  console.error("Datos incompletos al cargar - header:", !!invoiceHeader, "body:", !!invoiceBody);
                  // Si falta header o body, mostrar error pero no mostrar impresión
                  this.$store.commit("posData/setHeader", header);
                  this.$store.commit("posData/setBody", this.body);
                  
                  this.showAlert(
                    "danger",
                    "Error al cargar datos",
                    "La comanda se creó pero no se pudieron cargar los datos para imprimir.",
                    null
                  );
                }
              } catch (printError) {
                console.error("Error al cargar datos para impresión:", printError);
                // Mostrar error al usuario
                this.$store.commit("posData/setHeader", header);
                this.$store.commit("posData/setBody", this.body);
                
                this.showAlert(
                  "danger",
                  "Error al cargar datos",
                  "La comanda se creó pero hubo un error al cargar los datos para imprimir: " + (printError?.message || printError),
                  null
                );
              }
            }
          } else {
            console.log("No se encontró idInvoice en response");
            this.$store.commit("posData/setHeader", header);
            this.$store.commit("posData/setBody", this.body);
            
            this.showAlert(
              "danger",
              "Error al crear comanda",
              "La comanda se creó pero no se pudo obtener su ID para imprimir.",
              null
            );
          }
        } else {
          console.log("Error en response.success:", response);
          this.$store.commit("posData/setHeader", header);
          this.$store.commit("posData/setBody", this.body);
          
          this.showAlert(
            "error",
            "Error al crear comanda",
            response?.message || "No se pudo crear la comanda. Intente de nuevo.",
            null
          );
        }
        
        // Reiniciar banderas después de imprimir
        setTimeout(() => {
          this.orderAndPrint = false;
          this.hideQrInPrint = false;
        }, 1000);
        
        // Recargar lista de comandas activas
        await this.loadActiveCommands();
      } catch (error) {
        console.error("Error al crear comanda:", error);
        if (header) {
          this.$store.commit("posData/setHeader", header);
          this.$store.commit("posData/setBody", this.invoiceItems);
        }
        this.orderAndPrint = false;
        this.hideQrInPrint = false;
        
        this.showAlert(
          "danger",
          "Error al crear comanda",
          error?.message || "Ocurrió un error al crear la comanda. Intente de nuevo.",
          null
        );
      } finally {
        this.saving = false; // Ocultar overlay de carga
      }
    },
    async processInvoiceWithPayments() {
      // Procesar facturación después de confirmar pagos en el diálogo
      try {
        this.saving = true;
        this.showReturnedAndPaymentModal = false;
        
        // Construir datos de la factura
        const header = this.buildHeaderData();
        const items = this.buildItemsData();
        const user = JSON.parse(localStorage.getItem("user")).id;

        // Agregar pagos al header si multipagos está activo
        if (this.pospayments && Array.isArray(this.paymentsData) && this.paymentsData.length > 0) {
          // Ajustar pagos para que sumen al totalPagar
          let cash = this.paymentsData.reduce((sum, p) => {
            if (p.typePayment == "01") {
              sum + parseFloat(p.totalPayment || 0)
            }
            return sum
          }, 0);

          let sumOtherPay = this.paymentsData.reduce((sum, p) => {
            if (p.typePayment != "01") {
              sum + parseFloat(p.totalPayment || 0)
            }
            return sum
          }, 0);

          let currentSum = this.paymentsData.reduce((sum, p) => sum + parseFloat(p.totalPayment || 0), 0);
          
          let totalPagar = parseFloat(header.invoicetotalpagar || 0);

          if (sumOtherPay > totalPagar && cash >= 0) {
            this.showAlert(
              "dangerHtml",
              "Advertencia",
              `No es posible dar cambio en la operación actual pagos en Billetes y Monedas
            insuficientes.<br/><br/>
            Total a pagar en efectivo insuficiente: $${cash.toFixed(2)} <br><br>
            Total a pagar (otro tipo de pago): $${sumOtherPay.toFixed(2)} <br><br>
            Total DTE: $${totalPagar}`
            );
            this.saving = false
            return;
          }

          if (currentSum < totalPagar) {
            this.showAlert(
                "dangerHtml",
                "Advertencia",
                `El total a pagar difiere con el total del DTE.<br><br>
              Total a pagar en efectivo: $${cash.toFixed(2)} <br><br>
              Total a pagar (otro tipo de pago): $${sumOtherPay.toFixed(2)} <br><br>
              Total DTE: $${totalPagar}`
            );
            this.saving = false
            return;
          }

          header.payments = this.paymentsData.filter(p => parseFloat(p.totalPayment || 0) > 0);
          header.pospayments = 1;  
          
          let difference = totalPagar - currentSum;
          if (difference !== 0 && this.paymentsData.length > 0) {
            this.paymentsData[0].totalPayment = parseFloat(this.paymentsData[0].totalPayment || 0) + difference;
          }
          header.payments = this.paymentsData.filter(p => parseFloat(p.totalPayment || 0) > 0);
          header.pospayments = 1;
        }
        
        // Enviar con status = 1 para indicar que se está facturando (emitiendo)
        header.invoicestatus = 1;
        
        let invalidData = this.invalid != null ? this.invalid : null;
        let ndorncData = this.ndornc != null ? this.ndornc : null;
        if (ndorncData == null && (this.form.invoicetype == 'DNC' || this.form.invoicetype == 'DND')) {
          ndorncData = {
            FechaEmisionRelacionado: this.form.ncfecharelacionado,
            NumeroDocumentoRelacionado: this.form.nccodigorelacionado,
            TipoDocumentoRelacionado: "03",
            TipoGeneracionRelacionado: 1,
            Type: "DNC",
          };
        }
        let contingencyData = this.contingency != null ? this.contingency : null;

        // Validar campos requeridos para el tipo de factura antes de continuar
        if (!this.validateInvoiceRequiredFields()) {
          this.saving = false;
          return;
        }

        const response = await this.submitPosInvoice({
          header,
          items,
          user,
          invalid: invalidData,
          ndornc: ndorncData,
          contingency: contingencyData,
          UseReserveWarehouse: JSON.parse(localStorage.getItem("user")).usereservewarehouse || 0,
          ShowCorrelativeControl: this.ShowCorrelativeControl || JSON.parse(localStorage.getItem("user")).showcorrelativecontrol || 0,
          UseNewSpNumControl: this.UseNewSpNumControl || JSON.parse(localStorage.getItem("user")).usenewspnumcontrol || 0,
          ServicioDeProPinas: this.servicioDeProPinas || header.ServicioDeProPinas || null
        });
        
        // Procesar respuesta del backend
        const mhResponse = response?.data || response;
        const estado = mhResponse?.estado || "DESCONOCIDO";

        const idInvoice = response?.createdInvoice?.ID_Invoice || response?.ID_Invoice || mhResponse?.billingDteJsonHeader?.ID_Invoice;

        this.invoiceResult = {
          show: true,
          estado: estado,
          color: "comment",
          colorBtn: "primary",
          colorTitle: "primary--text font-weight-bold",
          description: mhResponse?.descripcionMsg || response?.descripcionMsg || "",
          observaciones: Array.isArray(mhResponse?.observaciones) ? mhResponse.observaciones : [],
          total: this.invoiceTotal || 0,
          pagoCon: this.sumPayments || 0,
          cambio: this.exchangePayments || 0,
        };

        // Asignar title y message según el estado
        if (estado === "PROCESADO") {
          this.invoiceResult.title = "DTE GENERADA";
          this.invoiceResult.color = "comment";
          this.invoiceResult.colorTitle = "primary--text font-weight-bold";
          this.invoiceResult.colorBtn = "primary";
          this.invoiceResult.message = "Se ha realizado y procesado la factura.";
        } else if (estado === "CONTINGENCIA") {
          this.invoiceResult.title = "DTE EN CONTINGENCIA";
          this.invoiceResult.color = "warning";
          this.invoiceResult.colorTitle = "black--text font-weight-bold";
          this.invoiceResult.colorBtn = "comment";
          this.invoiceResult.message = "El DTE se ha guardado en estado de contingencia.";
        } else if (estado === "FIRMADOR") {
          this.invoiceResult.title = "ERROR DE FIRMADOR";
          this.invoiceResult.color = "error";
          this.invoiceResult.colorTitle = "black--text font-weight-bold";
          this.invoiceResult.colorBtn = "comment";
          this.invoiceResult.message = "Se ha rechazado el DTE, tomar en cuenta las observaciones del firmador y realizarla de nuevo.";
        } else if (estado === "RECHAZADO") {
          this.invoiceResult.title = "DTE RECHAZADO";
          this.invoiceResult.color = "error";
          this.invoiceResult.colorTitle = "black--text font-weight-bold";
          this.invoiceResult.colorBtn = "comment";
          this.invoiceResult.message = "Se ha rechazado el DTE, tomar en cuenta las observaciones del Ministerio de Hacienda y realizarla de nuevo.";
        } else {
          this.invoiceResult.title = "ESTADO DESCONOCIDO";
          this.invoiceResult.color = "warning";
          this.invoiceResult.colorTitle = "black--text font-weight-bold";
          this.invoiceResult.colorBtn = "comment";
          this.invoiceResult.message = "Se recibió una respuesta inesperada del servidor.";
        }

        // Cerrar diálogo de pagos
        this.showReturnedAndPaymentModal = false;

        await this.printInvoiceProcessOrContingency(idInvoice)

        if (estado === "PROCESADO" || estado === "CONTINGENCIA") {
          this.clearInvoice()
          
          // Recargar lista de comandas activas
          await this.loadActiveCommands();
        }
      } catch (error) {
        console.error("Error en processInvoiceWithPayments:", error);
        this.showAlert("danger", "Error", `Error al procesar la factura: ${error.message}`);
      } finally {
        this.saving = false;
      }
    },
    async invoiceAndEmit() {
      try {
        // Si multipagos está activo, mostrar diálogo de selección de pagos
        if (this.pospayments) {
          // Resetear los pagos y mostrar el diálogo
          this.resetSelected();
          this.showReturnedAndPaymentModal = true;
          this.isReadyToBill = true;
          return; // No continuar hasta que el usuario confirme los pagos
        }
        
        this.saving = true;
        
        // VALIDACIÓN: Total debe ser mayor a 0
        if (this.form.invoicestatusdescription == 'Crédito' && !this.form.invoicecreditday) {
          this.showAlert(
            "warning", 
            "Advertencia", 
            "No se puede facturar una factura a crédito si no se ha especificado los dias del crédito"
          )
          this.saving = false;
          return;
        }

        if (this.invoiceTotal <= 0) {
          this.showAlert(
            "warning",
            "Advertencia",
            "No se puede facturar si el monto total de la factura es igual a $0"
          );
          this.saving = false;
          return;
        }
        
        // VALIDACIÓN: Cliente debe estar seleccionado
        if (!this.form.idcustomer) {
          this.showAlert(
            "warning",
            "Advertencia",
            "Debe seleccionar un cliente para facturar"
          );
          this.saving = false;
          return;
        }
        
        // VALIDACIÓN: Validar existencias antes de facturar (solo productos, no servicios)
        const onlyProductsArray = this.productsToShow.filter(current => current.type !== 'service');
        if (onlyProductsArray.length > 0) {
          const productsToSendForValidation = onlyProductsArray.map(({ ID_Item, Warehouse, qty }) => {
            return {
              ID_Item,
              Warehouse,
              requestedQuantity: qty
            };
          });
          
          try {
            const resultFromValidation = await this.$API.products.getInvoiceProductsQuantity({
              StockProductsInReserve: 0,
              items: productsToSendForValidation
            });
            
            if (!resultFromValidation.success) {
              const alertArray = resultFromValidation.data.map(current => {
                const { ID_Item, Warehouse, found } = current;
                if (found) {
                  const { notEnoughStock } = current;
                  if (notEnoughStock) {
                    const { ItemCurrentQuantity } = current;
                    return `- ID PROD.: ${ID_Item} | ALM: ${Warehouse}: Existencia insuficiente. Disponible: ${ItemCurrentQuantity}`;
                  }
                } else {
                  return `- ID PROD.: ${ID_Item} | ALM: ${Warehouse}: Producto no encontrado`;
                }
              });
              
              let alertBody = `No hay suficiente stock para completar la factura: ${alertArray.join(' * ')}`;
              this.showAlert("dangerHtml", "Advertencia", alertBody);
              this.saving = false;
              return;
            }
          } catch (stockError) {
            // Continuar si hay error en validación de stock
          }
        }
        
        // Construir datos de la factura
        const header = this.buildHeaderData();
        const items = this.buildItemsData();
        const user = JSON.parse(localStorage.getItem("user")).id;
        
        // Enviar con status = 1 para indicar que se está facturando (emitiendo)
        // Validar campos requeridos para el tipo de factura antes de continuar
        if (!this.validateInvoiceRequiredFields()) {
          this.saving = false;
          return;
        }

        header.invoicestatus = 1;
        
        let invalidData = this.invalid != null ? this.invalid : null;
        let ndorncData = this.ndornc != null ? this.ndornc : null;
        if (ndorncData == null && (this.form.invoicetype == 'DNC' || this.form.invoicetype == 'DND')) {
          ndorncData = {
            FechaEmisionRelacionado: this.form.ncfecharelacionado,
            NumeroDocumentoRelacionado: this.form.nccodigorelacionado,
            TipoDocumentoRelacionado: "03",
            TipoGeneracionRelacionado: 1,
            Type: "DNC",
          };
        }
        let contingencyData = this.contingency != null ? this.contingency : null;

        const response = await this.submitPosInvoice({
          header,
          items,
          user,
          invalid: invalidData,
          ndornc: ndorncData,
          contingency: contingencyData,
          UseReserveWarehouse: JSON.parse(localStorage.getItem("user")).usereservewarehouse || 0,
          ShowCorrelativeControl: this.ShowCorrelativeControl || JSON.parse(localStorage.getItem("user")).showcorrelativecontrol || 0,
          UseNewSpNumControl: this.UseNewSpNumControl || JSON.parse(localStorage.getItem("user")).usenewspnumcontrol || 0,
          ServicioDeProPinas: this.servicioDeProPinas || header.ServicioDeProPinas || null
        });
        
        // Procesar respuesta del backend - Mostrar diálogo con resultados
        const mhResponse = response?.data || response;
        const estado = mhResponse?.estado || "DESCONOCIDO";
        
        // Preparar datos del resultado
        this.invoiceResult = {
          show: true,
          estado: estado,
          color: "comment",
          colorBtn: "primary",
          colorTitle: "primary--text font-weight-bold",
          description: mhResponse?.descripcionMsg || response?.descripcionMsg || "",
          observaciones: Array.isArray(mhResponse?.observaciones) ? mhResponse.observaciones : [],
          total: this.invoiceTotal || 0,
          pagoCon: this.invoiceTotal || 0,
          cambio: 0,
        };

        if (estado === "PROCESADO") {
          this.invoiceResult.title = "DTE GENERADA";
          this.invoiceResult.color = "comment";
          this.invoiceResult.colorTitle = "primary--text font-weight-bold";
          this.invoiceResult.colorBtn = "primary";
          this.invoiceResult.message = "Se ha realizado y procesado la factura.";
          
          // Obtener datos de la factura creada
          const idInvoice = response?.createdInvoice?.ID_Invoice || response?.ID_Invoice || mhResponse?.billingDteJsonHeader?.ID_Invoice;
          if (idInvoice) {
            await this.printInvoiceProcessOrContingency(idInvoice)

            const invoiceData = await this.$API.invoices.getInvoice(idInvoice);
            const invoiceItems = await this.$API.invoices.getAllInvoiceItems(idInvoice);
            this.$store.commit("posData/setHeader", invoiceData);
            this.$store.commit("posData/setBody", invoiceItems);
          } else {
            this.$store.commit("posData/setHeader", header);
            this.$store.commit("posData/setBody", items);
          }
          
          // Limpiar factura después de facturar
          this.clearInvoice();
          
          // Recargar lista de comandas activas
          await this.loadActiveCommands();
        } else if (estado === "CONTINGENCIA") {
          this.invoiceResult.title = "DTE EN CONTINGENCIA";
          this.invoiceResult.color = "warning";
          this.invoiceResult.colorTitle = "black--text font-weight-bold";
          this.invoiceResult.colorBtn = "comment";
          this.invoiceResult.message = "El DTE se ha guardado en estado de contingencia.";
          
          // Obtener datos para referencia
          const idInvoice = response?.createdInvoice?.ID_Invoice || response?.ID_Invoice || mhResponse?.billingDteJsonHeader?.ID_Invoice;
          if (idInvoice) {
            await this.printInvoiceProcessOrContingency(idInvoice)

            const invoiceData = await this.$API.invoices.getInvoice(idInvoice);
            const invoiceItems = await this.$API.invoices.getAllInvoiceItems(idInvoice);
            this.$store.commit("posData/setHeader", invoiceData);
            this.$store.commit("posData/setBody", invoiceItems);
          }

          this.clearInvoice();
        } else if (estado === "FIRMADOR") {
          this.invoiceResult.title = "ERROR DE FIRMADOR";
          this.invoiceResult.color = "error";
          this.invoiceResult.colorTitle = "black--text font-weight-bold";
          this.invoiceResult.colorBtn = "comment";
          this.invoiceResult.message = "Se ha rechazado el DTE, tomar en cuenta las observaciones del firmador y realizarla de nuevo.";
          this.$store.commit("posData/setHeader", header);
          this.$store.commit("posData/setBody", items);
        } else if (estado === "RECHAZADO") {
          this.invoiceResult.title = "DTE RECHAZADO";
          this.invoiceResult.color = "error";
          this.invoiceResult.colorTitle = "black--text font-weight-bold";
          this.invoiceResult.colorBtn = "comment";
          this.invoiceResult.message = "Se ha rechazado el DTE, tomar en cuenta las observaciones del Ministerio de Hacienda y realizarla de nuevo.";
          this.$store.commit("posData/setHeader", header);
          this.$store.commit("posData/setBody", items);
        } else {
          // Estado desconocido
          this.invoiceResult.title = "ESTADO DESCONOCIDO";
          this.invoiceResult.color = "warning";
          this.invoiceResult.colorTitle = "black--text font-weight-bold";
          this.invoiceResult.colorBtn = "comment";
          this.invoiceResult.message = "Se recibió una respuesta inesperada del servidor.";
        }
      } catch (error) {
        // Mostrar error en diálogo de resultados
        const errorData = error?.response?.data || {};
        this.invoiceResult = {
          show: true,
          title: "ERROR AL FACTURAR",
          color: "error",
          colorTitle: "black--text font-weight-bold",
          colorBtn: "comment",
          message: errorData?.message || error.message || "Ocurrió un error al procesar la factura.",
          estado: "ERROR",
          description: errorData?.descripcionMsg || "",
          observaciones: Array.isArray(errorData?.observaciones) ? errorData.observaciones : [],
          total: this.invoiceTotal || 0,
          pagoCon: this.invoiceTotal || 0,
          cambio: 0,
        };
        // NO limpiar en error - permitir reintentos
      } finally {
        this.saving = false;
      }
    },
    clearInvoice() {
      this.posInvoiceAttemptKey = null;
      this.posInvoiceAttemptUncertain = false;
      // Limpiar completamente para crear una nueva factura
      this.invoiceItems = [];
      this.productsToShow = [];  // Limpiar lista de items agregados
      this.body = [];  // Limpiar body para backend
      this.discountObject = [];  // Limpiar descuentos
      this.form = {
        idinvoice: null,
        idcustomer: null,
        idcustomernombre: null,
        legalname: "",
        legaladdress: "",
        legaladdress2: "",
        legalnit: "",
        legalnrc: "",
        legalentity: "",
        legaltaxpayersize: null,
        invoicedate: this.form.invoicedate,
        invoicetype: "FCF",
        invoicepaymenttype: null,
        invoicestatusdescription: null,
        invoicereference: null,
        invoicecreditday: "30 días",
        invoiceinternalnote: "",
        isquote: 0,
        creditstatus: null,
        codasociado: null,
        docasociado: null,
        detalleasociado: null,
        modotransp: null,
        numconductor: null,
        nombreconductor: null,
        placatrans: null,
        seguro: 0,
        flete: 0,
        portofdeparture: null,
        shipmentno: null,
        containerno: null,
        blno: null,
        vesselvoyage: null,
        usadfa: null,
        termsofpayment: null,
        codincoterms: null,
        bientitulo: null,
        nccodigorelacionado: null,
        ncfecharelacionado: null,
      };
      this.editingPriceIndex = null;
      this.showItemComments = false;
      this.commentsObject = {};
      
      // Reinicializar propinas con 10% por defecto (siempre activas)
      this.activarPropinas = this.propinasdefault;
      this.porcentajePropinas = 10;
      
      this.sumPayments = 0;
      this.exchangePayments = 0;
      this.paymentReadyToBill = false
      
      // Limpiar store
      this.$store.commit("posData/setHeader", null);
      this.$store.commit("posData/setBody", null);
      this.$store.commit("posData/setCustomer", null);
      
      // Resetear navegador de categorías a familias
      this.navigationLevel = 0;
      this.selectedFamilyId = null;
      this.selectedCategoryId = null;
      this.selectedSubcategoryId = null;
      
      // Resetear checkboxes de productos y servicios, y switch de categorías
      this.showProducts = true;
      this.showServices = true;
      this.modeList = true;
      if(this.isCoffeBike)
        this.searchSeveralCustomer();
      // Validar header después de limpiar
      this.$nextTick(() => {
        this.validateHeader();
      });
    },
    buildHeaderData() {
      // Asegurar que business y branch estén inicializados
      if (!this.business || !this.branch) {
        this.initializeBusinessAndBranch();
      }
      
      // Normalizar la fecha al formato que espera la API: DD/MM/YYYY
      let invoiceDateFormatted = this.form.invoicedate;
      if (invoiceDateFormatted && typeof invoiceDateFormatted === 'string') {
        // Si está en formato YYYY-MM-DD (ISO), convertir a DD/MM/YYYY
        if (invoiceDateFormatted.includes('-')) {
          const [year, month, day] = invoiceDateFormatted.split('-');
          invoiceDateFormatted = `${day}/${month}/${year}`;
        }
        // Si ya está en DD/MM/YYYY, mantenerlo como está
      } else if (!this.form.oldIdInvoice) {
        // IMPORTANTE: Solo usar la fecha actual si es una factura NUEVA (sin oldIdInvoice)
        // Si es una factura existente que se está editando, NUNCA cambiar su fecha original
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        invoiceDateFormatted = `${day}/${month}/${year}`;
      }
      // Si es una factura existente (oldIdInvoice) y no hay fecha cargada, el backend rechazará la factura
      // esto es intencionado para forzar el error y evitar enviar facturas con fecha incorrecta

      // Obtener numDocumento del cliente seleccionado (o cadena vacía si es CLIENTE VARIOS/mesa)
      // Para MH, cuando es CLIENTE VARIOS (consumidor final), enviar cadena vacía "" en lugar de null
      let customerDocId = null;
      if (this.selectedCustomer) {
        // Preferir DUI o DocumentId como número de documento
        customerDocId = this.selectedCustomer.DUI || null;
      }

      // Si no hay documento del cliente (CLIENTE VARIOS), usar cadena vacía para MH
      if (!customerDocId && this.form.idcustomernombre === "CLIENTES VARIOS") {
        customerDocId = "";  // Usar cadena vacía para Consumidor Final
      }

      // Obtener ID del vendedor desde localStorage o usar valor por defecto
      const sellerData = JSON.parse(localStorage.getItem("user")) || {};
      const sellerID = sellerData?.id || "USR2023080002";
      
      // CRÍTICO: Cuando se factura desde comanda:
      // - idinvoice debe estar VACÍO para que el backend genere un nuevo ID de factura
      // - oldIdInvoice debe contener el ID de la comanda (para mantener referencia)
      // - El ID de comanda (this.form.idinvoice) se pasa en oldIdInvoice cuando se factura
      const isIssuingFromCommand = this.form.idinvoice && this.form.idinvoice?.startsWith('COM');

      // Precompute total discount from items (category breakdown isn't used here — match Create.vue behavior)
      const itemsForHeader = this.buildItemsData();
      let invoicetotaldescu = 0;

      itemsForHeader.forEach((it) => {
        const disc = parseFloat(it.itemdiscount || 0);
        if (!disc || disc === 0) return;
        invoicetotaldescu += disc;
      });

      invoicetotaldescu = parseFloat(invoicetotaldescu.toFixed(2));

      // Use calculateInvoiceTotals() to get authoritative totals including IVA Rete/Perce adjustments
      const totals = this.calculateInvoiceTotals();

      const invoicesubtotalventas = totals.invoicesubtotalventas;
      const invoicesubtotal = totals.invoicesubtotal;

      // Calculate invoice percentage discount the same way Create.vue does (when applicable)
      let invoiceporcentajedescuento = 0;
      if (this.form.invoicetype == "CCF" || this.form.invoicetype == "DND" || this.form.invoicetype == "DNC") {
        const originalSubtotal100Percent = invoicetotaldescu + invoicesubtotal;
        invoiceporcentajedescuento = parseFloat(parseFloat(((invoicetotaldescu * 100) / (originalSubtotal100Percent || 1)).toFixed(2)));
      }

      const header = {
        // Campos de identificación del invoice
        // IMPORTANTE: Si viene de una comanda, idinvoice debe estar vacío para facturación
        idinvoice: isIssuingFromCommand ? "" : (this.form.idinvoice || ""),
        invoiceidinvoice: this.form.invoiceidinvoice || "",
        // Si viene de una comanda, pasar el ID de comanda en oldIdInvoice
        oldIdInvoice: isIssuingFromCommand ? this.form.idinvoice : (this.form.oldIdInvoice || ""),
        
        // Campos de cliente
        idcustomer: this.form.idcustomer || "VARIOS",
        invoicename: this.form.legalname || this.form.idcustomernombre || "CLIENTES VARIOS",
        iddocumenttype: this.selectedCustomer?.ID_DocumentType || 0,
        dui: this.form.dui || customerDocId || "",
        
        // Información del cliente (required by MH schema)
        firstname: this.form.firstname || "CLIENTE",
        lastname: this.form.lastname || "VARIOS",
        email: this.form.email || null,
        phonenumber: this.form.phonenumber || "",
        mobilenumber: this.form.businessmobilenumber || "00000000",
        
        city: this.form.city || "San Salvador Centro",
        country: this.form.country || "El Salvador",
        status: "1",
        
        // Información de negocio del cliente
        isa_business: this.selectedCustomer?.Is_a_Business || false,
        businessname: this.selectedCustomer?.businessname || null,
        businessphone: this.form.businessphone || this.selectedCustomer?.BusinessPhone || null,
        businessmobilenumber: this.form.businessmobilenumber || this.selectedCustomer?.BusinessMobileNumber || null,
        businessemail: this.form.businessemail || this.selectedCustomer?.BusinessEmail || null,
        businesscontactname: this.form.businesscontactname || this.selectedCustomer?.BusinessContactName || null,
        businesscontactphone: this.form.businesscontactphone || this.selectedCustomer?.BusinessContactPhone || null,
        businesscontactmobile: this.form.businesscontactmobile || this.selectedCustomer?.BusinessContactMobile || null,
        businesscontactemail: this.form.businesscontactemail || this.selectedCustomer?.BusinessContactEmail || null,
        sendemailbusinessemail: this.selectedCustomer?.SendEmail_BusinessEmail || 0,
        sendsmsbusinessmobile: this.selectedCustomer?.Sendsmsbusinessmobile || 0,
        sendwhatsappbusinessmobile: this.selectedCustomer?.Sendwhatsappbusinessmobile || 0,
        
        // Copiar Bcc emails para que Create.vue y backend reciban el mismo field
        BccEmailsCustomer: (this.BccEmails && this.BccEmails.length) ? this.BccEmails.join(', ') : null,
        
        // Vendedor
        ID_Seller: this.form.ID_Seller || sellerID,
        iduser_insert: sellerID,
        iduser_update: sellerID,
        
        // Información de factura
        invoicedate: invoiceDateFormatted,
        invoicetype: this.form.invoicetype || "FCF",
        // CRÍTICO: Si pospayments=1, invoicepaymenttype debe ser null (no un código)
        // porque los pagos se especifican en el array 'payments'
        invoicepaymenttype: this.pospayments ? null : (this.form.invoicepaymenttype || "Billetes y monedas"),
        paymenttype: "Billetes y monedas",
        invoicestatusdescription: this.form.invoicestatusdescription || "Cancelada",
        invoicestatus: 1,  // CRÍTICO: 1 para facturación, 0 para borrador
        invoicereference: this.form.invoicereference || null,
        invoicecreditday: this.form.invoicecreditday || null,
        invoiceinternalnote: this.form.invoiceinternalnote || "",
        
        // Flags de tipo de invoice
        isquote: this.form.isquote || 0,
        istemplate: this.form.istemplate || 0,
        isfinance: this.form.isfinance || 0,
        invoiceisnontaxable: this.form.invoiceisnontaxable || 0,
        invoiceisnonsuj: this.form.invoiceisnonsuj || 0,
        timesexecute: this.form.timesexecute || 0,
        
        // Información de negocio
        idbusiness: this.business,
        idbranch: this.branch,
        isseveralcustomer: 1,  // RestaurantPOS siempre es consumidor final
        isglobalbranch: 0,  // CRÍTICO: Campo requerido por backend/MH
        
        // Departamento y Municipio (CRÍTICO para receptor en MH)
        department: this.form.department || "06",  // San Salvador por defecto
        municipality: this.form.municipality || "23",  // San Salvador Centro por defecto
        
        // Códigos de actividad y NIT/NRC del receptor (para CCF)
        codactividad: this.form.codactividad || "",
        descactividad: this.form.descactividad || "",
        invoicenrc: this.form.legalnrc || this.form.invoicenrc || "",
        invoicenit: this.form.legalnit || this.form.invoicenit || "",
        // Entidad legal del receptor (PERSONA NATURAL / PERSONA JURÍDICA / SOCIEDAD ANÓNIMA)
        invoiceentity: this.form.legalentity || "",
        // Dirección complementaria del receptor (si existe)
        invoiceaddress2: this.form.legaladdress2 || "",
        
        // Punto de venta
        codpointsale: parseInt(localStorage.getItem("codPointSale")) || 1,
        // CRÍTICO: posrestaurant=0 cuando se factura (es una factura, no una comanda)
        posrestaurant: 0,
        
        // Campos de documento relacionado (para DNC/DND)
        codasociado: this.form.codasociado || null,
        docasociado: this.form.docasociado || null,
        detalleasociado: this.form.detalleasociado || null,
        
        // Campos de transporte
        modotransp: this.form.modotransp || null,
        numconductor: this.form.numconductor || null,
        nombreconductor: this.form.nombreconductor || null,
        placatrans: this.form.placatrans || null,
        
        // Subtotales y totales - REDONDEADOS A 2 DECIMALES para cumplir con MH
        invoicesubtotalventas: invoicesubtotalventas,
        invoicesubtotal: invoicesubtotal,
        invoicemontototaloperacion: totals.invoicemontototaloperacion,
        invoicetotalexenta: totals.invoicetotalexenta,
        invoicetotalnosuj: totals.invoicetotalnosuj,
        invoicetotalnogravada: totals.invoicetotalnogravada,
        invoicetotalgravada: totals.invoicetotalgravada,
        invoicetotaliva: totals.invoicetotaliva,
        invoicetotalpagar: totals.invoicetotalpagar,
        // Follow Create.vue: keep category-specific discount fields at 0 (Create sets these to 0) and set invoice percentage discount same way
        invoicedescunosuj: 0,
        invoicedescuexenta: 0,
        invoicedescugravada: 0,
        invoiceporcentajedescuento: invoiceporcentajedescuento,
        invoicetotaldescu: invoicetotaldescu,
        // IVA Rete and IVA Percepción
        invoiceivarete1: totals.invoiceivarete1 || 0,
        invoiceivaperce1: totals.invoiceivaperce1 || 0,
        
        // Costos adicionales
        seguro: parseFloat(this.form.seguro) || 0,
        flete: parseFloat(this.form.flete) || 0,
        
        // Campos de puerto y envío
        portofdeparture: this.form.portofdeparture || null,
        shipmentno: this.form.shipmentno || null,
        containerno: this.form.containerno || null,
        blno: this.form.blno || null,
        vesselvoyage: this.form.vesselvoyage || null,
        
        // Otros campos
        invoicetotalletras: numberToText(parseFloat(parseFloat(this.invoiceTotal).toFixed(2))),
        invoicedui: customerDocId || "",
        invoicereterenta: 0,
        invoiceagentretain: this.form.invoiceagentretain || 0,
        fovial: 0,
        cotrans: 0,
        turismoporalojamiento: 0,
        isisss: 0,
        stockproductsinreserve: 0,
        usadfa: this.form.usadfa || null,
        termsofpayment: this.form.termsofpayment || null,
        codincoterms: this.form.codincoterms || null,
        bientitulo: this.form.bientitulo || null,
        nccodigorelacionado: this.form.nccodigorelacionado || null,
        ncfecharelacionado: this.form.ncfecharelacionado || null,
        fexzona: this.form.fexzona || null,
        
        // Campos adicionales del cliente que pueden requerirse
        invoiceaddress: this.form.legaladdress || "-",
        invoiceinfo: null,
        creditstatus: this.selectedCustomer?.creditstatus || "BLOQUEADO",
        limitcredit: this.selectedCustomer?.limitcredit || 0,
        
        // Payments y propina
        payments: this.buildPaymentsData(),
        pospayments: 0,
        propina: this.totalPropina,
        PropinaStatus: this.activarPropinas == 1,
      };

      // Agregar ServicioDeProPinas si hay propinas
      if (this.totalPropina > 0) {
        header.ServicioDeProPinas = {
          ID_Item: "SERVPROPINAS",
          ID_Branch: this.branch,
          ID_Business: this.business,
          ItemName: "Propina",
          ItemName2: "Propina"
        };
      }

      return header;
    },
    buildItemsData() {
      // Asegurarse de que todos los cálculos por item estén actualizados
      this.calculateInvoiceTotals();

      const items = [];

      this.productsToShow.forEach((el, index) => {
        // Normalizar campos
        if (el.discountFixed == undefined) el.discountFixed = 0;
        if (el.ItemPriceDiscountPercent == undefined) el.ItemPriceDiscountPercent = this.discountObject[index]?.percent || 0;
        if (isNaN(el.Suggested_price) || el.Suggested_price == undefined || el.Suggested_price == null) el.Suggested_price = el.ItemOriginalPrice;

        const perUnitDiscount = this.discountObject[index]?.amount || parseFloat(el.ItemPriceDiscountAmount || 0);
        const applyNetTaxFree = this.shouldUseNetTaxFreePrice(el);
        const taxFreeFactor = this.getTaxFreeConversionFactor(el);

        let total_price = 0;
        let totaliva = 0;
        let totalunitcost = 0;
        let totalgravada = 0;
        let totalnosuj = 0;
        let totalnogravada = 0;
        let totalexenta = 0;
        let totaldescu = 0;

        if (
          this.form.invoicetype == "CCF" ||
          this.form.invoicetype == "DND" ||
          this.form.invoicetype == "DNC"
        ) {
          const effectiveUnit = Math.max(0, parseFloat(el.ItemNewPrice) - perUnitDiscount);

          if (this.noaddivainpos) {
            total_price = parseFloat(((effectiveUnit).toFixed(8) * el.qty).toFixed(8));
          } else {
            if (this.addimpturismo && el.TurismoPorAlojamiento) {
              total_price = parseFloat((((effectiveUnit) / 1.18).toFixed(8) * el.qty).toFixed(8));
            } else {
              total_price = parseFloat((((effectiveUnit) / 1.13).toFixed(8) * el.qty).toFixed(8));
            }
          }

          if (el.nonsuj || el.nontaxable || el.nogravada) {
            totalunitcost = applyNetTaxFree
              ? parseFloat((el.ItemOriginalPrice / taxFreeFactor).toFixed(8))
              : parseFloat((el.ItemOriginalPrice).toFixed(8));
          } else {
            totalunitcost = this.noaddivainpos
              ? parseFloat((el.ItemOriginalPrice).toFixed(8))
              : (this.addimpturismo && el.TurismoPorAlojamiento
                  ? parseFloat((el.ItemOriginalPrice / 1.18).toFixed(8))
                  : parseFloat((el.ItemOriginalPrice / 1.13).toFixed(8)));
          }

          totalgravada = (el.nonsuj || el.nontaxable || el.nogravada) ? 0 : parseFloat(parseFloat(total_price).toFixed(8));

          totalnosuj = el.nonsuj
            ? parseFloat((applyNetTaxFree ? (el.ItemNewNewPrice / taxFreeFactor) : el.ItemNewNewPrice).toFixed(8))
            : 0;
          totalexenta = el.nontaxable
            ? parseFloat((applyNetTaxFree ? (el.ItemNewNewPrice / taxFreeFactor) : el.ItemNewNewPrice).toFixed(8))
            : 0;
          totalnogravada = el.nogravada
            ? parseFloat((applyNetTaxFree ? (el.ItemNewNewPrice / taxFreeFactor) : el.ItemNewNewPrice).toFixed(8))
            : 0;

          if (this.noaddivainpos) {
            totaldescu = parseFloat((perUnitDiscount * el.qty).toFixed(8));
          } else if (el.nonsuj || el.nontaxable || el.nogravada) {
            totaldescu = parseFloat(((perUnitDiscount * el.qty) / (applyNetTaxFree ? taxFreeFactor : 1)).toFixed(8));
          } else {
            if (this.addimpturismo && el.TurismoPorAlojamiento) {
              totaldescu = parseFloat(((perUnitDiscount / 1.18) * el.qty).toFixed(8));
            } else {
              totaldescu = parseFloat(((perUnitDiscount / 1.13) * el.qty).toFixed(8));
            }
          }

          if (this.noaddivainpos) {
            totaliva = (el.nonsuj || el.nontaxable || el.nogravada) ? 0 : Math.max(0, parseFloat((total_price * 0.13).toFixed(8)));
          } else {
            if (this.addimpturismo && el.TurismoPorAlojamiento) {
              totaliva = (el.nonsuj || el.nontaxable || el.nogravada) ? 0 : Math.max(0, parseFloat((total_price * 0.13).toFixed(8)));
            } else {
              totaliva = (el.nonsuj || el.nontaxable || el.nogravada) ? 0 : Math.max(0, parseFloat((el.ItemNewNewPrice - total_price).toFixed(8)));
            }
          }
        } else {
          total_price = parseFloat(parseFloat(el.ItemNewNewPrice).toFixed(8));
          totaliva = (el.nonsuj || el.nontaxable || el.nogravada) ? 0 : Math.max(0, parseFloat((total_price - total_price / 1.13).toFixed(8)));
          totalgravada = (el.nonsuj || el.nontaxable || el.nogravada) ? 0 : parseFloat(parseFloat(total_price).toFixed(8));

          totalnosuj = el.nonsuj
            ? parseFloat((applyNetTaxFree ? (total_price / taxFreeFactor) : total_price).toFixed(8))
            : 0;
          totalexenta = el.nontaxable
            ? parseFloat((applyNetTaxFree ? (total_price / taxFreeFactor) : total_price).toFixed(8))
            : 0;
          totalnogravada = el.nogravada
            ? parseFloat((applyNetTaxFree ? (total_price / taxFreeFactor) : total_price).toFixed(8))
            : 0;

          totaldescu = parseFloat(
            ((perUnitDiscount * el.qty) / ((el.nonsuj || el.nontaxable || el.nogravada) && applyNetTaxFree ? taxFreeFactor : 1)).toFixed(8)
          );

          if (el.nonsuj || el.nontaxable || el.nogravada) {
            totalunitcost = applyNetTaxFree
              ? parseFloat((el.ItemOriginalPrice / taxFreeFactor).toFixed(8))
              : parseFloat((el.ItemOriginalPrice).toFixed(8));
          } else {
            totalunitcost = parseFloat((el.ItemOriginalPrice).toFixed(8));
          }
        }

        items.push({
          idbranch: this.branch,
          idbusiness: el.ID_Business || this.business,
          iditem: el.ID_Item,
          itemtype: el.type,
          itemquantity: el.qty,
          itemmeasureunit: el.ItemMeasureUnit,
          itemdescription: el.ItemName,
          itemunitcost: parseFloat(parseFloat(totalunitcost || 0).toFixed(6)),
          itemdiscount: parseFloat(parseFloat(totaldescu || 0).toFixed(6)),
          itemdiscountpercent: parseFloat(el.ItemPriceDiscountPercent) || 0,
          itemnosuj: parseFloat(parseFloat(totalnosuj || 0).toFixed(6)),
          itemexenta: parseFloat(parseFloat(totalexenta || 0).toFixed(6)),
          itemnogravada: parseFloat(parseFloat(totalnogravada || 0).toFixed(6)),
          itemgravada: parseFloat(parseFloat(totalgravada || 0).toFixed(6)),
          itempsv: parseFloat(parseFloat(el.Suggested_price || 0).toFixed(6)),
          itemiva: parseFloat(parseFloat(totaliva || 0).toFixed(6)),
          itemcurrency: el.ItemCurrency || "$",
          warehouse: el.Warehouse,
          itembatch: el.ID_ItemBatch || "",
          ishidrocarburo: el.IsHidrocarburo || 0,
          principalbarcode: el.BarCode || "",
          turismoporalojamiento: el.TurismoPorAlojamiento || 0,
          itemcomments: el.ItemComments || ""
        });
      });

      // Propina enviada vía header.ServicioDeProPinas (Create.vue style) — no agregar ítem de propina aquí para evitar duplicados en MH
      // Si es necesario enviar un item de propina como ítem, habilitarlo explícitamente; por ahora confiamos en el objeto ServicioDeProPinas del header.

      return items;
    },
    calculateInvoiceTotals() {
      // Copia exacta de la lógica de cálculo de sendBill de Create.vue
      const safeParseFloat = (value) => {
        const parsed = parseFloat(value);
        return isNaN(parsed) ? 0 : parsed;
      };
      
      let obj = {
        invoicetotaldescu: 0,
        invoicesubtotalventas: 0,
        invoicesubtotal: 0,
        invoicemontototaloperacion: 0,
        invoicetotalexenta: 0,
        invoicetotalnosuj: 0,
        invoicetotalnogravada: 0,
        invoicetotalgravada: 0,
        invoicetotalpagar: 0,
        invoicetotaliva: 0,
        invoiceivarete1: 0,
        invoiceivaperce1: 0,
        invoicereterenta: 0,
        fovial: 0,
        cotrans: 0,
        turismoporalojamiento: 0,
        propina: 0
      };

      let restIvaPerce = 0;

      this.productsToShow.map((el, index) => {
        // Calcular ItemNewNewPrice (precio total con descuento)
        el.ItemNewNewPrice = parseFloat(
          safeParseFloat(el.qty) * (safeParseFloat(el.ItemOriginalPrice) - safeParseFloat(el.ItemPriceDiscountAmount || 0))
        ).toFixed(8);

        // Adaptar descuentos desde discountObject
        if (el.discountFixed == undefined) {
          el.discountFixed = 0;
        } else {
          el.discountFixed = parseFloat(el.discountFixed);
        }

        if (el.ItemPriceDiscountPercent == undefined) {
          el.ItemPriceDiscountPercent = this.discountObject[index]?.percent || 0;
        }

        if (
          isNaN(el.Suggested_price) ||
          el.Suggested_price == undefined ||
          el.Suggested_price == null
        ) {
          el.Suggested_price = el.ItemOriginalPrice;
        }

        let total_price;
        let totaliva;
        let totalgravada;
        let totalnosuj;
        let totalnogravada;
        let totalexenta;
        let totaldescu;
        let totalpropina;
        const applyNetTaxFree = this.shouldUseNetTaxFreePrice(el);
        const taxFreeFactor = this.getTaxFreeConversionFactor(el);

        if (
          this.form.invoicetype == "CCF" ||
          this.form.invoicetype == "DND" ||
          this.form.invoicetype == "DNC"
        ) {

          // Calcular precio unitario efectivo considerando descuento por unidad
          const perUnitDiscount = this.discountObject[index]?.amount || safeParseFloat(el.ItemPriceDiscountAmount || 0);
          const effectiveUnit = Math.max(0, safeParseFloat(el.ItemNewPrice) - perUnitDiscount);

          if (this.noaddivainpos) {
            total_price = parseFloat(
              parseFloat(
                (effectiveUnit.toFixed(8) * el.qty).toFixed(8)
              ).toFixed(8)
            );
          }
          else {
            if (this.addimpturismo && el.TurismoPorAlojamiento) {
              total_price = parseFloat(
                parseFloat(
                  ((effectiveUnit / 1.18).toFixed(8) * el.qty).toFixed(8)
                ).toFixed(8)
              );
            }
            else {
              total_price = parseFloat(
                parseFloat(
                  ((effectiveUnit / 1.13).toFixed(8) * el.qty).toFixed(8)
                ).toFixed(8)
              );
            }
          }
          
          if (this.activarPropinas && !this.hasBlockedTipItem(el)) {
            totalpropina = parseFloat( 
              parseFloat(
                total_price * (this.porcentajePropinas / 100) 
              ).toFixed(8)
            )
          }
          else {
            totalpropina = 0
          }
          
          if (this.noaddivainpos) {
            totaliva =
              el.nonsuj || el.nontaxable || el.nogravada
                ? 0
                : Math.max(0, parseFloat(
                    parseFloat(total_price * 0.13).toFixed(8)
                  ));
          }
          else {
            if (this.addimpturismo && el.TurismoPorAlojamiento) {
              totaliva =
                el.nonsuj || el.nontaxable || el.nogravada
                  ? 0
                  : Math.max(0, parseFloat(
                      parseFloat(total_price * 0.13).toFixed(8)
                    ));
            }
            else {
              totaliva =
                el.nonsuj || el.nontaxable || el.nogravada
                  ? 0
                  : Math.max(0, parseFloat(
                      parseFloat(safeParseFloat(el.ItemNewNewPrice) - total_price).toFixed(8)
                    ));
            }
          }
          
          
          totalgravada =
            el.nonsuj || el.nontaxable || el.nogravada
              ? 0
              : parseFloat(parseFloat(total_price).toFixed(8));

          totalnosuj = el.nonsuj
            ? parseFloat(parseFloat(applyNetTaxFree ? (safeParseFloat(el.ItemNewNewPrice) / taxFreeFactor) : safeParseFloat(el.ItemNewNewPrice)).toFixed(8))
            : 0;
          totalexenta = el.nontaxable
            ? parseFloat(parseFloat(applyNetTaxFree ? (safeParseFloat(el.ItemNewNewPrice) / taxFreeFactor) : safeParseFloat(el.ItemNewNewPrice)).toFixed(8))
            : 0;
          totalnogravada = el.nogravada
            ? parseFloat(parseFloat(applyNetTaxFree ? (safeParseFloat(el.ItemNewNewPrice) / taxFreeFactor) : safeParseFloat(el.ItemNewNewPrice)).toFixed(8))
            : 0;    
          
          if (this.noaddivainpos) {
            totaldescu = parseFloat(
              parseFloat(
                (this.discountObject[index]?.amount || 0) * el.qty
              ).toFixed(8)
            );
          }
          else if (el.nonsuj || el.nontaxable || el.nogravada) {
            totaldescu = parseFloat(
              parseFloat(
                ((this.discountObject[index]?.amount || 0) * el.qty) / (applyNetTaxFree ? taxFreeFactor : 1)
              ).toFixed(8)
            );
          }
          else {
            if (this.addimpturismo && el.TurismoPorAlojamiento) {
              totaldescu = parseFloat(
                parseFloat(
                  ((this.discountObject[index]?.amount || 0) / 1.18) * el.qty
                ).toFixed(8)
              );
            }
            else {
              totaldescu = parseFloat(
                parseFloat(
                  ((this.discountObject[index]?.amount || 0) / 1.13) * el.qty
                ).toFixed(8)
              );
            }
          }

          if (el.nontaxable2) el.nontaxable = el.nontaxable2;
          if (el.nonsuj2) el.nonsuj = el.nonsuj2;
          if (el.nogravada2) el.nogravada = el.nogravada2;

          obj.invoicesubtotalventas +=
            totalgravada + totalnosuj + totalexenta;

          obj.invoicetotaldescu += totaldescu;
          obj.invoicesubtotal += totalgravada + totalnosuj + totalexenta;
          obj.invoicetotalnosuj += totalnosuj;
          obj.invoicetotalexenta += totalexenta;
          obj.invoicetotalnogravada += totalnogravada + totalpropina;
          obj.invoicetotalgravada += totalgravada;

          if (this.noaddivainpos) {
            obj.invoicemontototaloperacion +=
              (totalgravada != 0 ? safeParseFloat(el.ItemNewNewPrice) + parseFloat(totaliva) : 0) +
              totalnosuj +
              totalexenta;
            obj.invoicetotalpagar +=
              (totalgravada != 0 ? safeParseFloat(el.ItemNewNewPrice) + parseFloat(totaliva) : 0) +
              totalnosuj +
              totalexenta +
              totalnogravada + 
              totalpropina;
          }
          else {
            obj.invoicemontototaloperacion +=
              (totalgravada != 0 ? safeParseFloat(el.ItemNewNewPrice) : 0) +
              totalnosuj +
              totalexenta;
            obj.invoicetotalpagar +=
              (totalgravada != 0 ? safeParseFloat(el.ItemNewNewPrice) : 0) +
              totalnosuj +
              totalexenta + 
              totalnogravada +
              totalpropina;
          }
          
          obj.invoicetotaliva += totaliva;

          if (this.form.legalreterenta) {
            if (el.type == "service") {
              let reterenta = parseFloat(
                parseFloat(parseFloat(total_price) * 0.1).toFixed(2)
              );
              obj.invoicereterenta += reterenta;
              obj.invoicetotalpagar = obj.invoicetotalpagar - reterenta;
            } else {
              let reterenta = 0;
              obj.invoicereterenta += reterenta;
            }
          }

          if (
            this.form.invoicetype == "CCF" &&
            el.type == "product" &&
            el.IsHidrocarburo
          ) {
            let fovial = parseFloat(
              parseFloat(parseFloat(el.qty) * 0.2).toFixed(2)
            );
            let cotrans = parseFloat(
              parseFloat(parseFloat(el.qty) * 0.1).toFixed(2)
            );

            obj.fovial += fovial;
            obj.cotrans += cotrans;
            obj.invoicemontototaloperacion =
              obj.invoicemontototaloperacion + fovial + cotrans;
            obj.invoicetotalpagar =
              obj.invoicetotalpagar + fovial + cotrans;
            restIvaPerce = restIvaPerce + totalgravada * 0.01;
          }

          if (
            el.TurismoPorAlojamiento
          ) {
            let turismoPorAlojamiento = 0
            if (this.noaddivainpos) {
              turismoPorAlojamiento = parseFloat(
                parseFloat( ( safeParseFloat(el.ItemNewNewPrice) ) * 0.05).toFixed(2)
              )
            }
            else {
              if (this.addimpturismo) {
                turismoPorAlojamiento = parseFloat(
                  parseFloat( ( safeParseFloat(el.ItemNewNewPrice) / 1.18 ) * 0.05).toFixed(2)
                )
              }
              else {
                turismoPorAlojamiento = parseFloat(
                  parseFloat( ( safeParseFloat(el.ItemNewNewPrice) / 1.13 ) * 0.05).toFixed(2)
                )
              }
            }
            
            obj.turismoporalojamiento += turismoPorAlojamiento;
            
            if (!this.addimpturismo) {
              obj.invoicemontototaloperacion = 
                obj.invoicemontototaloperacion + turismoPorAlojamiento;
              obj.invoicetotalpagar = 
                obj.invoicetotalpagar + turismoPorAlojamiento;
            }
          }

          obj.propina += totalpropina
        } else {
          total_price = parseFloat(
            parseFloat(safeParseFloat(el.ItemNewNewPrice)).toFixed(8)
          );
          totaliva =
            el.nonsuj || el.nontaxable || el.nogravada
              ? 0
              : Math.max(0, parseFloat(
                  parseFloat(total_price - total_price / 1.13).toFixed(8)
                ));

          totalgravada =
            el.nonsuj || el.nontaxable || el.nogravada
              ? 0
              : parseFloat(parseFloat(total_price).toFixed(8));
          
          if (this.activarPropinas && this.form.invoicetype == 'FCF' && !this.hasBlockedTipItem(el)) {
            totalpropina = parseFloat(
              parseFloat(
                (total_price / 1.13) * (this.porcentajePropinas / 100)
              ).toFixed(8)
            )
          }
          else {
            totalpropina = 0
          }

          totalnosuj = el.nonsuj
            ? parseFloat(parseFloat(applyNetTaxFree ? (total_price / taxFreeFactor) : total_price).toFixed(8))
            : 0;
          totalexenta = el.nontaxable
            ? parseFloat(parseFloat(applyNetTaxFree ? (total_price / taxFreeFactor) : total_price).toFixed(8))
            : 0;
          totalnogravada = el.nogravada
            ? parseFloat(parseFloat(applyNetTaxFree ? (total_price / taxFreeFactor) : total_price).toFixed(8))
            : 0;
          
          totaldescu = parseFloat(
            parseFloat(((this.discountObject[index]?.amount || 0) * el.qty) / ((el.nonsuj || el.nontaxable || el.nogravada) && applyNetTaxFree ? taxFreeFactor : 1)).toFixed(8)
          );

          if (el.nontaxable2) el.nontaxable = el.nontaxable2;
          if (el.nonsuj2) el.nonsuj = el.nonsuj2;
          if (el.nogravada2) el.nogravada = el.nogravada2;

          obj.invoicesubtotalventas +=
            totalgravada + totalnosuj + totalexenta;

          obj.invoicetotaldescu += totaldescu;
          obj.invoicesubtotal += totalgravada + totalnosuj + totalexenta;
          obj.invoicetotalnosuj += totalnosuj;
          obj.invoicetotalexenta += totalexenta;
          obj.invoicetotalgravada += totalgravada;
          obj.invoicetotalnogravada += totalnogravada + totalpropina;
          obj.invoicemontototaloperacion +=
            totalgravada + totalnosuj + totalexenta;
          obj.invoicetotalpagar += totalgravada + totalnosuj + totalexenta + totalnogravada + totalpropina;
          obj.invoicetotaliva += totaliva;

          if (this.form.invoicetype == "FNS") {
            if (el.type == "service") {
              let reterenta = parseFloat(
                parseFloat(parseFloat(total_price) * 0.1).toFixed(2)
              );
              obj.invoicereterenta += reterenta;
              obj.invoicetotalpagar = obj.invoicetotalpagar - reterenta;
            } else {
              let reterenta = 0;
              obj.invoicereterenta += reterenta;
            }
          }

          if (this.form.legalreterenta && this.form.invoicetype == "FCF") {
            if (el.type == "service") {
              let reterenta = parseFloat(
                parseFloat(parseFloat(total_price / 1.13) * 0.1).toFixed(2)
              );
              obj.invoicereterenta += reterenta;
              obj.invoicetotalpagar = obj.invoicetotalpagar - reterenta;
            } else {
              let reterenta = 0;
              obj.invoicereterenta += reterenta;
            }
          }

          if (
            this.form.invoicetype == "FCF" &&
            el.type == "product" &&
            el.IsHidrocarburo
          ) {
            let fovial = parseFloat(
              parseFloat(parseFloat(el.qty) * 0.2).toFixed(2)
            );
            let cotrans = parseFloat(
              parseFloat(parseFloat(el.qty) * 0.1).toFixed(2)
            );

            obj.fovial += fovial;
            obj.cotrans += cotrans;
            obj.invoicemontototaloperacion =
              obj.invoicemontototaloperacion + fovial + cotrans;
            obj.invoicetotalpagar =
              obj.invoicetotalpagar + fovial + cotrans;
          }

          if (
            el.TurismoPorAlojamiento
          ) {
            let turismoPorAlojamiento = parseFloat(
              parseFloat( ( parseFloat(total_price) / 1.13 ) * 0.05).toFixed(2)
            )

            obj.turismoporalojamiento += turismoPorAlojamiento;
            obj.invoicemontototaloperacion = 
              obj.invoicemontototaloperacion + turismoPorAlojamiento;
            obj.invoicetotalpagar = 
              obj.invoicetotalpagar + turismoPorAlojamiento;
          }

          obj.propina += totalpropina
        }
      });

      // Apply IVA Rete / IVA Perce (mirror Create.vue logic)
      // IVA Rete (retención 1%) when receiver is agent (form.legalagentretain) and BusinessLegalAgentRetain is false
      if (
        this.form.invoicetype == "FCF" ||
        this.form.invoicetype == "FNS" ||
        this.form.invoicetype == "CCF" ||
        this.form.invoicetype == "DND" ||
        this.form.invoicetype == "DNC"
      ) {
        if (!this.BusinessLegalAgentRetain) {
          if (this.form.legalagentretain) {
            if (this.form.invoicetype == "FCF") {
              let sumtmp = parseFloat(obj.invoicetotalexenta) + parseFloat(obj.invoicetotalnosuj) + parseFloat(obj.invoicetotalgravada - obj.invoicetotaliva);
              if (sumtmp >= 100) {
                obj.invoiceivarete1 = parseFloat(parseFloat((obj.invoicetotalgravada - obj.invoicetotaliva) * 0.01).toFixed(2));
                obj.invoicetotalpagar = parseFloat(parseFloat(obj.invoicetotalpagar - obj.invoiceivarete1).toFixed(2));
              }
            } else {
              let sumtmp = parseFloat(obj.invoicetotalgravada);
              if (sumtmp >= 100 && (this.form.invoicetype == 'CCF' || this.form.invoicetype == "FNS")) {
                obj.invoiceivarete1 = parseFloat(parseFloat(obj.invoicetotalgravada * 0.01).toFixed(2));
                obj.invoicetotalpagar = parseFloat(parseFloat(obj.invoicetotalpagar - obj.invoiceivarete1).toFixed(2));
              } else {
                if ((this.form.invoicetype == 'DNC' || this.form.invoicetype == 'DND') && (this.ndornc?.ApplyRete1 || sumtmp >= 100)) {
                  obj.invoiceivarete1 = parseFloat(parseFloat(obj.invoicetotalgravada * 0.01).toFixed(2));
                  obj.invoicetotalpagar = parseFloat(parseFloat(obj.invoicetotalpagar - obj.invoiceivarete1).toFixed(2));
                }
              }
            }
          }
        }

        // IVA Perce (percepción 1%) when the business is agent (BusinessLegalAgentRetain) and receiver is not
        if (this.form.invoicetype == "CCF" || this.form.invoicetype == "DND" || this.form.invoicetype == "DNC") {
          if (this.BusinessLegalAgentRetain) {
            if (!this.form.legalagentretain) {
              let sumtmp = parseFloat(obj.invoicetotalexenta) + parseFloat(obj.invoicetotalnosuj) + parseFloat(obj.invoicetotalgravada);
              if (sumtmp >= 100) {
                obj.invoiceivaperce1 = parseFloat(parseFloat(obj.invoicetotalgravada * 0.01 - restIvaPerce).toFixed(2));
                obj.invoicetotalpagar = parseFloat(parseFloat(obj.invoicetotalpagar + obj.invoiceivaperce1).toFixed(2));
              }
            }
          }
        }

      }

      // Round key totals to 2 decimals (MH requires multiples of 0.01)
      const round2 = (v) => parseFloat(parseFloat(v || 0).toFixed(2));
      obj.invoicetotaldescu = round2(obj.invoicetotaldescu);
      obj.invoicesubtotalventas = round2(obj.invoicesubtotalventas);
      obj.invoicesubtotal = round2(obj.invoicesubtotal);
      obj.invoicemontototaloperacion = round2(obj.invoicemontototaloperacion);
      obj.invoicetotalexenta = round2(obj.invoicetotalexenta);
      obj.invoicetotalnosuj = round2(obj.invoicetotalnosuj);
      obj.invoicetotalnogravada = round2(obj.invoicetotalnogravada);
      obj.invoicetotalgravada = round2(obj.invoicetotalgravada);
      obj.invoicetotaliva = round2(obj.invoicetotaliva);
      obj.invoicetotalpagar = round2(obj.invoicetotalpagar);
      obj.invoiceivarete1 = round2(obj.invoiceivarete1);
      obj.invoiceivaperce1 = round2(obj.invoiceivaperce1);
      obj.propina = round2(obj.propina);

      return obj;
    },
    buildPaymentsData() {
      try {
        const payments = [];
        const data = Array.isArray(this.paymentsData) ? this.paymentsData : [];
        for (const p of data) {
          const amt = parseFloat(p.totalPayment || p.TotalPayment || 0) || 0;
          if (amt > 0) {
            let code = p.typePayment || p.TypePayment || p.type || "01";
            // Si code es un nombre (ej: "Billetes y monedas"), convertir a código
            if (isNaN(code)) {
              const paymentTypeObj = this.paymentTypes.find((x) => x.Valores === code);
              code = paymentTypeObj?.Codigo || "01";
            }
            const desc =
              p.descriptionPayment || p.DescriptionTypePayment || p.description ||
              (this.paymentTypes.find((x) => x.Codigo == code)?.Valores || null) ||
              "Billetes y monedas";
            payments.push({
                typePayment: String(code).padStart(2, "0"),  // Asegurar que sea "01", "02", etc.
                descriptionPayment: desc,
                totalPayment: parseFloat(amt.toFixed(2)),
                reference: p.reference || p.Reference || null,
              });
            
          } else {
          const amt = parseFloat(parseFloat(this.invoiceTotal || 0).toFixed(2)) || 0;
          let code = this.form.invoicepaymenttype || "01";
          
          // Si code es un nombre (ej: "Billetes y monedas"), convertir a código
          if (isNaN(code)) {
            const paymentTypeObj = this.paymentTypes.find((x) => x.Valores === code);
            code = paymentTypeObj?.Codigo || "01";
          }
          
          const desc =
            this.paymentTypes.find((x) => x.Codigo == code)?.Valores ||
            "Billetes y monedas";
          
          payments.push({
            typePayment: String(code).padStart(2, "0"),  // Asegurar que sea "01", "02", etc.
            descriptionPayment: desc,
            totalPayment: parseFloat(amt.toFixed(2)),
            reference: this.form.invoicereference || null,
          });
          }
        }

        if (payments.length === 0) {
          payments.push({
            typePayment: "01",
            descriptionPayment: "Billetes y monedas",
            totalPayment: parseFloat(parseFloat(this.invoiceTotal || 0).toFixed(2)),
            reference: null,
          });
        }
        return payments;
      } catch (e) {
        return [
          {
            typePayment: "01",
            descriptionPayment: "Billetes y monedas",
            totalPayment: parseFloat(parseFloat(this.invoiceTotal || 0).toFixed(2)),
            reference: null,
          },
        ];
      }
    },
    async loadInvoiceFromStore() {
      // Cargar datos del store si existen (cuando se navega desde historial)
      const header = this.$store.state.posData?.header;
      const body = this.$store.state.posData?.body;
      const customer = this.$store.state.posData?.customer;

      if (header && typeof header === 'object') {
        // Cargar header - mapear propiedades correctamente con fallbacks
        
        // Guardar cliente completo si viene en store
        if (customer) {
          this.selectedCustomer = customer;
        }
        
        // Campos básicos de factura
        this.form.idinvoice = header?.ID_Invoice || header?.idinvoice || null;
        this.form.idcustomer = header.idcustomer || header.ID_Customer || (customer?.ID_Customer) || null;

        await this.$API.customers
          .getOneCustomer(this.form.idcustomer)
          .then((response) => {
            this.customerSelected(response, true);
        });

        this.form.idcustomernombre = header.ComercialName || header.invoicename || header.InvoiceName || header.LegalName || "";  // Cargar nombre del cliente (primero comercial)
        
        // Cargar datos detallados del cliente
        this.form.invoicename = header.invoicename || header.InvoiceName || header.LegalName || this.form.invoicename || "";
        this.form.invoiceaddress = header.invoiceaddress || header.InvoiceAddress || this.form.invoiceaddress || "";
        this.form.invoicenit = header.invoicenit || header.InvoiceNIT || this.form.invoicenits || "";
        this.form.invoicenrc = header.invoicenrc || header.InvoiceNRC || this.form.invoicenrc || "";
        //this.form.codactividad = header.codactividad || header.CodActividad || "";
        //this.form.descactividad = header.descactividad || header.DescActividad || "";
        this.form.dui = header.InvoiceDUI || this.form.dui || "";
        // Aplicar máscara al DUI cargado desde el header (parity Create.vue)
        this.form.dui && (this.form.dui = applyDUIMaskOutOfInput(this.form.dui));
        this.form.phonenumber = header.phonenumber || header.PhoneNumber || this.form.phonenumber || "";
        this.form.email = header.email || header.Email || this.form.email || "";
        // Aplicar máscaras a NIT/NRC si vienen en el header
        this.form.invoicenrc && (this.form.invoicenrc = applyDUIMaskOutOfInput(this.form.invoicenrc));
        this.form.invoicenit && (this.form.invoicenit = applyNitMaskHandlingHomologationOutOfInput(this.form.invoicenit));

        // Campos legales (paridad Create.vue) — cargar si vienen en header para que el diálogo y el header coincidan
        this.form.legalname = header.InvoiceName || header.invoicename || header.LegalName || this.form.legalname || "";
        this.form.legaladdress = header.invoiceaddress || header.InvoiceAddress || header.LegalAddress || this.form.legaladdress || "";
        this.form.legaladdress2 = header.invoiceaddress2 || header.InvoiceAddress2 || header.LegalAddress2 || this.form.legaladdress2 || "";
        this.form.legalnit = header.invoicenit || header.InvoiceNIT || header.LegalNIT || this.form.legalnit || "";
        this.form.legalnrc = header.invoicenrc || header.InvoiceNRC || header.LegalNRC || this.form.legalnrc || "";
        this.form.legalentity = header.invoiceentity || header.InvoiceEntity || header.LegalEntity || this.form.legalentity || "";
        // Tamaño contribuyente legal (legaltaxpayersize)
        this.form.legaltaxpayersize = header.legaltaxpayersize || header.LegalTaxPayerSize || header.LegalTaxpayersize || header.Legaltaxpayersize || this.form.legaltaxpayersize || null;
        this.form.businessemail = header.BusinessEmail || header.businessemail || this.form.businessemail || "";
        this.form.businesscontactname = header.BusinessContactName || header.businesscontactname || this.form.businesscontactname || "";
        this.form.businesscontactphone = header.BusinessContactPhone || header.businesscontactphone || this.form.businesscontactphone || "";
        this.form.businesscontactmobile = header.BusinessContactMobile || header.businesscontactmobile || this.form.businesscontactmobile || "";
        this.form.businesscontactemail = header.BusinessContactEmail || header.businesscontactemail || this.form.businesscontactemail || "";

        // Asegurar que selectedCustomer contiene los mismos campos para construir correctamente el header si se edita
        if (!this.selectedCustomer || (this.selectedCustomer && this.selectedCustomer.ID_Customer != (this.form.idcustomer))) {
          const custFromHeader = {
            ID_Customer: this.form.idcustomer,
            LegalName: this.form.legalname || this.form.invoicename || "",
            LegalAddress: this.form.legaladdress || "",
            LegalAddress2: this.form.legaladdress2 || "",
            LegalNIT: this.form.legalnit || "",
            LegalNRC: this.form.legalnrc || "",
            LegalEntity: this.form.legalentity || "",
            Legaltaxpayersize: this.form.legaltaxpayersize || null,
            DUI: this.form.dui || "",
            PhoneNumber: this.form.phonenumber || "",
            phonenumber: this.form.phonenumber || "",
            Email: this.form.email || "",
            email: this.form.email || "",
            BusinessPhone: this.form.businessphone || "",
            BusinessMobileNumber: this.form.businessmobilenumber || "",
            BusinessEmail: this.form.businessemail || "",
            BusinessContactName: this.form.businesscontactname || "",
            BusinessContactPhone: this.form.businesscontactphone || "",
            BusinessContactMobile: this.form.businesscontactmobile || "",
            BusinessContactEmail: this.form.businesscontactemail || "",
            BccEmailsCustomer: this.BccEmails.length ? this.BccEmails.join(', ') : null,
            codActividad: this.form.codactividad || null,
            descActividad: this.form.descactividad || null,
          };
          this.selectedCustomer = custFromHeader;
          // Guardar en store para que otros flujos (ej. editar) lo utilicen
          this.$store.commit("posData/setCustomer", custFromHeader);
        } else {
          // Si ya existe selectedCustomer, sincronizar los campos críticos
          Vue.set(this.selectedCustomer, 'LegalName', this.form.legalname || this.selectedCustomer?.LegalName);
          Vue.set(this.selectedCustomer, 'LegalAddress', this.form.legaladdress || this.selectedCustomer?.LegalAddress);
          Vue.set(this.selectedCustomer, 'LegalAddress2', this.form.legaladdress2 || this.selectedCustomer?.LegalAddress2);
          Vue.set(this.selectedCustomer, 'LegalNIT', this.form.legalnit || this.selectedCustomer?.LegalNIT);
          Vue.set(this.selectedCustomer, 'LegalNRC', this.form.legalnrc || this.selectedCustomer?.LegalNRC);
          Vue.set(this.selectedCustomer, 'LegalEntity', this.form.legalentity || this.selectedCustomer?.LegalEntity);
          Vue.set(this.selectedCustomer, 'DUI', this.form.dui || this.selectedCustomer?.DUI);
          Vue.set(this.selectedCustomer, 'BccEmailsCustomer', this.BccEmails.length ? this.BccEmails.join(', ') : this.selectedCustomer?.BccEmailsCustomer || null);
        }
        
        // Cargar y normalizar fecha
        let loadedDate = header.invoicedate || header.invoice_date || header.InvoiceDate;
        if (loadedDate) {
          // Si viene en formato ISO (YYYY-MM-DD), convertir a DD/MM/YYYY
          if (loadedDate.includes('-') && !loadedDate.includes('/')) {
            const [year, month, day] = loadedDate.split('-');
            this.form.invoicedate = `${day}/${month}/${year}`;
          } else {
            // Si ya está en otro formato, mantenerlo
            this.form.invoicedate = loadedDate;
          }
        } else {
          // Si no hay fecha, usar hoy en formato DD/MM/YYYY
          const today = new Date();
          const day = String(today.getDate()).padStart(2, '0');
          const month = String(today.getMonth() + 1).padStart(2, '0');
          const year = today.getFullYear();
          this.form.invoicedate = `${day}/${month}/${year}`;
        }
        this.form.invoicetype = header.InvoiceType || null;
        this.form.invoicepaymenttype = header.InvoicePaymentType || null;
        this.form.invoicestatusdescription = header.InvoiceStatusDescription || null;
        this.form.invoicereference = header.invoicereference || header.invoice_reference || header.InvoiceReference || "";
        this.form.invoicecreditday = (header.InvoiceCreditDay || null)?.replace('dias', 'días');
        this.form.invoiceinternalnote = header.invoiceinternalnote || header.invoice_internal_note || header.InvoiceInternalNote || "";
        this.form.isquote = header.isquote || header.is_quote || header.IsQuote || 0;
        this.form.creditstatus = header.creditstatus || header.credit_status || header.CreditStatus || null;
        
        // Campos de documento relacionado (para ND/NC)
        this.form.codasociado = header.codasociado || header.cod_asociado || header.CodAsociado || null;
        this.form.docasociado = header.docasociado || header.doc_asociado || header.DocAsociado || null;
        this.form.detalleasociado = header.detalleasociado || header.detalle_asociado || header.DetalleAsociado || null;
        
        // Campos de transporte (FEX)
        this.form.modotransp = header.modotransp || header.modo_transp || header.ModoTransp || null;
        this.form.numconductor = header.numconductor || header.num_conductor || header.NumConductor || null;
        this.form.nombreconductor = header.nombreconductor || header.nombre_conductor || header.NombreConductor || null;
        this.form.placatrans = header.placatrans || header.placa_trans || header.PlacaTrans || null;
        
        // Campos de costos adicionales
        this.form.seguro = parseFloat(header.seguro) || parseFloat(header.Seguro) || 0;
        this.form.flete = parseFloat(header.flete) || parseFloat(header.Flete) || 0;
        
        // Campos de puerto y envío
        this.form.portofdeparture = header.portofdeparture || header.puerto_salida || header.PortOfDeparture || null;
        this.form.shipmentno = header.shipmentno || header.shipment_no || header.ShipmentNo || null;
        this.form.containerno = header.containerno || header.container_no || header.ContainerNo || null;
        this.form.blno = header.blno || header.bl_no || header.BlNo || null;
        this.form.vesselvoyage = header.vesselvoyage || header.vessel_voyage || header.VesselVoyage || null;
        
        // Campos adicionales
        this.form.usadfa = header.usadfa || header.usa_dfa || header.UsaDFA || null;
        this.form.termsofpayment = header.termsofpayment || header.terms_of_payment || header.TermsOfPayment || null;
        this.form.codincoterms = header.codincoterms || header.cod_incoterms || header.CodIncoterms || null;
        this.form.bientitulo = header.bientitulo || header.bien_titulo || header.BienTitulo || null;
        this.form.nccodigorelacionado = header.nccodigorelacionado || header.nc_codigo_relacionado || header.NCCodigoRelacionado || null;
        this.form.ncfecharelacionado = header.ncfecharelacionado || header.nc_fecha_relacionado || header.NCFechaRelacionado || null;

        // Cargar propina desde InvoicePropinas (campo de la BD)
        const loadedPropina = parseFloat(header?.InvoicePropinas) || 0;
        // console.log(loadedPropina)
        // Detectar si es una factura nueva o editada
        const isNewInvoice = !header?.ID_Invoice || header?.ID_Invoice?.startsWith('AUT');
        
        if (isNewInvoice) {
          // Nueva factura: propinas siempre activas con 10% por defecto
          this.activarPropinas = this.propinasdefault;
          this.porcentajePropinas = 10;
        } else if (loadedPropina > 0) {
          // Factura editada con propina: activar propinas
          this.activarPropinas = 1;
          // El porcentaje se calculará después de que se carguen los items
          // Por ahora, inicializar con un valor por defecto
          this.porcentajePropinas = 10;
        } else {
          // Factura editada sin propina: desactivar checkbox y mostrar 0
          this.activarPropinas = 0;
          this.porcentajePropinas = 0;
        }
        
        // console.log("Header cargado completo:", this.form);
      }

      if (body && Array.isArray(body) && this.productsToShow.length === 0) {
        // Solo cargar items del store si la lista local está vacía (proteger cambios locales)
        // Los precios pueden venir en diferentes propiedades: ItemUnitPrice, ItemNewPrice, price, item_new_price        
        const hydratedBody = await this.hydrateBlockedTipFlags(body);
        this.productsToShow = hydratedBody
          .filter((item) => item.ID_Item != 'SERVPROPINAS') // No incluir servicios de propina al copiar
          .map((item, index) => {
          var price = parseFloat(item.ItemUnitPrice) || 
                       parseFloat(item.ItemNewPrice) || 
                       parseFloat(item.price) || 
                       parseFloat(item.item_new_price) || 
                       parseFloat(item.item_unit_price) || 
                       0;
          
          const qty = parseFloat(item.ItemQuantity) || 
                     parseFloat(item.qty) || 
                     parseFloat(item.quantity) || 
                     1;

          if (!this.noaddivainpos && ["CCF", "DNC", "DND"].includes(this.form.invoicetype)) {
              const ivaUnit = parseFloat(item.ItemIVA / qty);
              price = Math.ceil((price + ivaUnit) * 100) / 100;
          }
          
          const idItem = item.ID_Item || item.val || item.id_item || item.iditem;
          
          // Mapear descuentos: el backend envía itemdiscountpercent (porcentaje) e itemdiscount (monto total)
          // Cargar el porcentaje directamente - esto es lo importante para reproducir el descuento
          let discountPercent = parseFloat(item.itemdiscountpercent) || parseFloat(item.ItemDiscountPercent) || parseFloat(item.ItemPriceDiscountPercent) || 0;
          let discountAmount = 0;
          
          // Si el backend envió el porcentaje, calcular el monto sobre el precio original
          if (discountPercent > 0) {
            // El monto del descuento se calcula sobre el precio original
            discountAmount = parseFloat(((price * discountPercent) / 100).toFixed(2));
          } else {
            // Si no hay porcentaje, intentar usar el monto total y convertirlo a porcentaje
            const totalDiscountAmount = parseFloat(item.itemdiscount) || 0;
            if (totalDiscountAmount > 0 && qty > 0) {
              // Convertir el monto total a monto por unidad
              discountAmount = parseFloat((totalDiscountAmount / qty).toFixed(2));
              // Calcular el porcentaje equivalente
              if (price > 0) {
                discountPercent = parseFloat(((discountAmount / price) * 100).toFixed(2));
              }
            }
          }
          
          // Mapear exento/no sujeto - Usar la misma lógica que Create.vue
          // Si ItemExenta > 0, entonces el check de exento está marcado
          // Si ItemNoSuj > 0, entonces el check de no sujeto está marcado
          const itemexenta = parseFloat(item.itemexenta) || parseFloat(item.ItemExenta) || 0;
          const itemnosuj = parseFloat(item.itemnosuj) || parseFloat(item.ItemNoSuj) || 0;
          const itemnogravada = parseFloat(item.itemnogravada) || parseFloat(item.ItemNoGravada) || parseFloat(item.ItemNogravada) || 0;
          const nontaxable = itemexenta > 0;  // True si itemexenta > 0
          const nonsuj = itemnosuj > 0;       // True si itemnosuj > 0
          const nogravada = itemnogravada > 0;
                    
          return {
            uuid: item.uuid || `${Date.now()}-${Math.random()}-${index}`,
            ID_Item: idItem,
            ItemName: item.ItemDescription || item.ItemName || item.item_name,
            ItemNewPrice: price,
            ItemOriginalPrice: price,
            qty: qty,
            nontaxable: nontaxable,
            nonsuj: nonsuj,
            nogravada: nogravada,
            ItemComments: item.ItemComments || item.comments || item.itemcomments || "",
            type: item.type || item.ItemType || 'product',
            Warehouse: item.Warehouse || item.warehouse || "",
            IsExempt: item.IsExempt || item.is_exempt || itemexenta > 0 ? 1 : 0,
            BloquearPropinas: item.BloquearPropinas || item.bloquearpropinas || item.prod?.BloquearPropinas || item.prod?.bloquearpropinas || this.resolveCatalogItemForTipFlag(item)?.BloquearPropinas || this.resolveCatalogItemForTipFlag(item)?.bloquearpropinas || 0,
            ItemPriceDiscountPercent: discountPercent,
            ItemPriceDiscountAmount: discountAmount,
            TmpItemNewPrice: price,
            TmpCounter: 0,
            sourcePriceIncludesIva: false,
            prod: item.prod || item,
          };
        });
        
        // Asignar las mismas referencias a body (sin copiar) para que ediciones se sincronicen
        this.body = this.productsToShow;
        
        // Inicializar descuentos
        this.discountObject = this.productsToShow.map(() => ({}));
        
        // Calcular porcentaje inverso de propina si se cargó una factura con propina
        // REMOVIDO: No se hace cálculo inverso, se mantiene el porcentaje inicial
      }

      if (customer && typeof customer === 'object') {
        // Cargar cliente - el idcustomer ya debería estar en el header, pero lo confirmamos aquí
        const customerId = customer.ID_Customer || customer.idcustomer || customer.id_customer;
        if (customerId && !this.form.idcustomer) {
          this.form.idcustomer = customerId;
        }
        
        // Asignar el nombre del cliente (igual que en customerSelected())
        if (customer.Is_a_Table) {
          this.form.idcustomernombre = `${customer.FirstName || ""} ${customer.LastName || ""}`.trim() || "";
        } else if (customer.BusinessName) {
          this.form.idcustomernombre = customer.BusinessName;
        } else if (customer.LegalName) {
          this.form.idcustomernombre = customer.LegalName;
        } else if (customer.itemText) {
          this.form.idcustomernombre = customer.itemText;
        }
        
        // Agregar cliente a la lista si no existe
        if (customerId && !this.customersList.find(c => c.ID_Customer === customerId)) {
          // Usar el itemText del cliente o el nombre que ya cargamos del header
          if (!customer.itemText) {
            customer.itemText = this.form.idcustomernombre || customer.LegalName || customer.BusinessName || "Sin nombre";
          }
          this.customersList.push(customer);
        }        
      }
    },
    initializeBusinessAndBranch() {
      // Obtener los IDs de business y branch del localStorage (igual que Create.vue)
      const userData = JSON.parse(localStorage.getItem("user")) || {};
      // Asignar business desde user.businessid
      this.business = userData?.businessid;
      // Asignar branch desde user.branch
      this.branch = userData?.branch;
    },
    async getAllSellers() {
      try {
        const result = await this.$API.sellers.getAllSellers();
        // Guardar la lista de vendedores para disponibilidad en buildHeaderData()
        if (result && result.length > 0) {
          // Ya está disponible para uso en buildHeaderData() que lo obtiene de localStorage
        }
      } catch (error) {
        console.log("error en los sellers ", error);
      }
    },
    async getInfoBranch() {
      try {
        const search = { 
          branch: this.branch, 
          business: this.business 
        };
        // Load branch info to ensure all necessary data is available (same as Create.vue)
        await this.$API.branches.findSpecificBranch(search);
      } catch (error) {
        console.log("error en getInfoBranch", error);
      }
    },
    selectPayment(data) {
      this.paymentsData.forEach((payment) => {
        payment.totalPayment = 0;
      });
      data.data.totalPayment = this.invoiceTotal;
      this.showPaymentWithDecimal(data.data);
      this.handleRowChangedPayments();
      this.paymentTypeSelect = true;
    },
    onTextFieldFocus(event) {
      event.target.select();
    },
    addPaymentType() {
      const newPayment = {
        typePayment: "01",
        descriptionPayment: "Billetes y monedas",
        totalPayment: 0.0,
        reference: null,
      };
      this.paymentsData.push(newPayment);
      this.handleRowChangedPayments();
    },
    deletePayment(paymentToDelete) {
      const index = this.paymentsData.findIndex((payment) => payment === paymentToDelete);
      if (index > -1) {
        this.paymentsData.splice(index, 1);
      }
      this.handleRowChangedPayments();
    },
    handleRowChangedPayments() {
      // Recalcular totales de pagos cuando cambian
      // Este método es llamado cuando hay cambios en la tabla de pagos
      const totalToPay = parseFloat(this.invoiceTotal.toFixed(2));
      const sumPayments = this.paymentsData.reduce((sum, payment) => sum + parseFloat(payment.totalPayment || 0), 0);
      this.sumPayments = parseFloat(parseFloat(sumPayments).toFixed(2))
      this.paymentReadyToBill = this.sumPayments >= totalToPay;

      if (this.paymentReadyToBill) {
        this.exchangePayments = parseFloat(parseFloat(this.sumPayments - totalToPay).toFixed(2))
      }
      else {
        this.exchangePayments = 0
      }
    },
    showPaymentWithDecimal(data) {
      if (data.totalPayment !== undefined && data.totalPayment !== null) {
        data.totalPayment = parseFloat(parseFloat(data.totalPayment).toFixed(2));
      }
    },
    handleTypePaymentChange(data) {
      // Método para manejar cambios en tipo de pago
      const selectedTypePayment = data.data.typePaymentAlt;
        const obj = this.paymentTypes.find(
          (row) => row.Codigo_Alt == selectedTypePayment
        );

        data.data.descriptionPayment = obj.Valores;
        data.data.typePayment = obj.Codigo
    },
    resetSelected() {
      this.selectedPayment = '';
      this.paymentTypeSelect = false;
      this.paymentsData.forEach((payment) => {
        payment.totalPayment = 0;
      });
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    async handleAlertClose() {
      this.alert.show = false;
      
      // Si el diálogo fue de comanda exitosa, usar impresión remota o local según configuración
      if (this.alert.options === "updateFinishAndPrintInvoice") {
        // Validar que tenemos el ID de la comanda
        if (this.datatoprint.header && this.datatoprint.header.ID_Invoice) {
          try {
            // Marcar como imprimiendo para que use el componente correcto
            this.orderAndPrint = true;
            
            // Verificar si usar impresoras térmicas
            const user = JSON.parse(localStorage.getItem("user"));
            if (user?.useprinters === 1) {
              // Usar impresión remota
              await this.remotePrint(true);
            } else {
              // Usar impresión local
              await imprimirFactura(this.datatoprint.header.ID_Invoice, this);
            }
            
            // Limpiar formulario para siguiente comanda
            this.clearInvoice();
          } catch (error) {
            console.error("Error al imprimir la comanda:", error);
            this.showAlert(
              "danger",
              "Error al imprimir",
              "No se pudo imprimir la comanda. Por favor, intente de nuevo.",
              null
            );
          } finally {
            this.orderAndPrint = false;
          }
        } else {
          console.error("No se pueden imprimir los datos - ID_Invoice no disponible", {
            header: !!this.datatoprint.header,
            ID_Invoice: this.datatoprint.header?.ID_Invoice,
          });
          this.showAlert(
            "danger",
            "Error al imprimir",
            "No se pudo obtener el ID de la comanda para imprimir.",
            null
          );
        }
      } else if (this.alert.options === "clearInvoice") {
        this.clearInvoice()
      }
      
      // Limpiar opciones después de procesarlas
      this.alert.options = null;
    },
    
    async loadActiveCommands() {
      try {
        this.loadingCommands = true;
        // Obtener filter con branch y business
        const filter = {
          ID_Branch: this.branch,
          ID_Business: this.business,
        };
        
        const response = await this.$API.invoices.getInvoicesPOSHistoryNotBilled(filter);
        
        // Filtrar solo las que comienzan con "COM"
        this.activaCommands = response.filter(invoice => 
          invoice?.ID_Invoice?.startsWith('COM')
        );
        
        this.loadingCommands = false;
      } catch (error) {
        console.error("Error al cargar comandas activas:", error);
        this.loadingCommands = false;
      }
    },

    async loadReadyInvoices() {
      try {
        this.loadingReadyInvoices = true;
        // Obtener filter igual que en Bill.vue (LISTO PARA FACTURAR)
        const filter = {
          ID_Branch: this.branch,
          ID_Business: this.business,
          status: 0,
          istemplate: 0,
          isquote: 0,
          isfinance: 0,
        };
        
        const response = await this.$API.invoices.getInvoicesPOSHistoryNotBilled(filter);
        
        // Filtrar solo las que comienzan con "RTB"
        this.readyInvoices = response.filter(invoice => 
          invoice?.ID_Invoice?.startsWith('RTB')
        );
        
        this.loadingReadyInvoices = false;
      } catch (error) {
        console.error("Error al cargar facturas listas:", error);
        this.loadingReadyInvoices = false;
      }
    },

    async loadComanda(comandaId) {
      try {
        this.saving = true;  // Mostrar overlay de carga
        
        // Limpiar factura actual
        this.clearInvoice();
        
        // Cargar header de la comanda
        const invoiceHeader = await this.$API.invoices.getInvoice(comandaId);
        
        // Cargar items de la comanda
        const invoiceItems = await this.$API.invoices.getAllInvoiceItems(comandaId);
        
        // Crear objeto cliente igual que en createOrder
        const customerObj = {
          ID_Customer: invoiceHeader.idcustomer || invoiceHeader.ID_Customer,
          LegalName: invoiceHeader.invoicename || invoiceHeader.InvoiceName,
          BusinessName: invoiceHeader.invoicename || invoiceHeader.InvoiceName,
          Is_a_Business: true,
          itemText: invoiceHeader.invoicename || invoiceHeader.InvoiceName,
        };
        
        // Guardar en el store usando los commits correctos
        this.$store.commit("posData/setHeader", invoiceHeader);
        this.$store.commit("posData/setBody", invoiceItems);
        this.$store.commit("posData/setCustomer", customerObj);
        
        // Cargar desde el store
        await this.loadInvoiceFromStore();
        
        // Validar campos del header después de cargar
        this.validateHeader();
        
        // Cambiar a la pestaña de Factura para mostrar la comanda cargada
        this.summaryTab = 0;
        this.saving = false;  // Ocultar overlay de carga
      } catch (error) {
        this.saving = false;  // Ocultar overlay en caso de error
        this.showAlert("danger", "Error", `No se pudo cargar la comanda: ${error.message}`);
      }
    },
    async printActiveCommand(comandaId) {
      // Función para imprimir una comanda activa sin cargarla
      try {
        this.saving = true;  // Mostrar overlay de carga
        
        // Cargar header de la comanda
        const invoiceHeader = await this.$API.invoices.getInvoice(comandaId);
        
        // Cargar items de la comanda
        const invoiceItems = await this.$API.invoices.getAllInvoiceItems(comandaId);
        
        // Guardar en datatoprint para impresión
        this.datatoprint.header = invoiceHeader;
        this.datatoprint.body = invoiceItems;
        
        // Intentar cargar el dteJson
        try {
          this.datatoprint.dteJson = await this.$API.invoices.getDteJsonHeaderByInvoice(comandaId);
        } catch (dteError) {
          console.warn("No se pudo cargar dteJson", dteError);
          this.datatoprint.dteJson = null;
        }
        
        // Marcar como orden para imprimir
        this.orderAndPrint = true;
        
        // Verificar si usar impresoras térmicas
        const user = JSON.parse(localStorage.getItem("user"));
        console.log("useprinters:", user?.useprinters);
        console.log("Payload for printActiveCommand:", { comandaId, useThermal: user?.useprinters === 1, header: this.datatoprint.header, body: this.datatoprint.body });
        if (user?.useprinters === 1) {
          await this.remotePrint(true);
        } else {
          await imprimirFactura(comandaId, this);
        }
        
      } catch (error) {
        console.error("Error al imprimir la comanda:", error);
        this.showAlert(
          "danger",
          "Error al imprimir",
          `No se pudo imprimir la comanda: ${error.message}`,
          null
        );
      } finally {
        this.saving = false;  // Ocultar overlay de carga
        this.orderAndPrint = false;
      }
    },
    async preBill(comandaId) {
      // Función para imprimir una comanda activa sin cargarla
      try {
        await this.saveInvoice();
        // Mostrar overlay de carga
        this.saving = true;

        // Cargar header de la comanda
        const invoiceHeader = await this.$API.invoices.getInvoice(comandaId);
        
        // Cargar items de la comanda
        const invoiceItems = await this.$API.invoices.getAllInvoiceItems(comandaId);
        
        // Guardar en datatoprint para impresión
        this.datatoprint.header = invoiceHeader;
        this.datatoprint.body = invoiceItems;
        
        // Intentar cargar el dteJson
        try {
          this.datatoprint.dteJson = await this.$API.invoices.getDteJsonHeaderByInvoice(comandaId);
        } catch (dteError) {
          console.warn("No se pudo cargar dteJson", dteError);
          this.datatoprint.dteJson = null;
        }
        
        // Marcar como orden para imprimir
        this.orderAndPrint = true;
        
        await imprimirFactura(comandaId, this, { regularPrint: true });
        
        // Recargar lista de comandas activas
        await this.loadActiveCommands();
        
      } catch (error) {
        console.error("Error al imprimir la comanda:", error);
        this.showAlert(
          "danger",
          "Error al imprimir",
          `No se pudo imprimir la comanda: ${error.message}`,
          null
        );
      } finally {
        this.saving = false;  // Ocultar overlay de carga
        this.orderAndPrint = false;
      }
    },
    addBarCode() {
      if (this.selectedBarCode === null) return;
      if (this.selectedBarCode === "") return;
      
      this.getBarCode(this.selectedBarCode);
    },
    getBarCode(barcode) {
      this.loading = true;
      this.$API.inventoryitemsbarcodes
        .getBarCodeById(barcode, this.PriceListSelected, this.warehouseSelected)
        .then((data) => {
          this.barCodeToFind = data;
        })
        .catch((error) => console.log(error))
        .finally(() => {
          if (
            this.barCodeToFind &&
            this.barCodeToFind.ID_Item &&
            typeof this.barCodeToFind.ID_Item === "string"
          ) {
            if (this.barCodeToFind?.ID_Item?.startsWith("PRO")) {
              this.showProductBarCode(this.barCodeToFind);
            } else if (this.barCodeToFind?.ID_Item?.startsWith("SERV")) {
              this.showServiceBarCode(this.barCodeToFind);
            } else {
              this.showAlert(
                "danger",
                "Advertencia",
                "Código de barra / alterno o no válido."
              );
            }
          } else {
            this.showAlert(
              "danger",
              "Advertencia",
              "Código de barra / alterno no válido."
            );
          }
          this.selectedBarCode = "";
          this.loading = false;
        });
    },
    showProductBarCode(data) {
      // Solo filtrar y mostrar el producto en la grid, sin agregarlo automáticamente
      this.productsAndServices = [data];
    },
    showServiceBarCode(data) {
      // Solo filtrar y mostrar el servicio en la grid, sin agregarlo automáticamente
      this.productsAndServices = [data];
    },
    changueValueactivity() {
      this.form.descactividad = this.activities.find(
        (act) => act.Codigo == this.form.codactividad
      ).Valores;
    },
    async getDuiMask() {
      this.form.dui = await duiMask(this, this.form.dui);
    },
    async getNITMask(e) {
      if (e.which === 8) return false;
      this.form.invoicenit = await nitMaskHandlingHomologation(
        this,
        this.form.invoicenit
      );
    },
    async getNRCMask() {
      this.form.invoicenrc = await nrcMask(this, this.form.invoicenrc);
    },
    async remotePrint(useDataFromPrint = false) {
      try {
        // Construir ticket con IDs de segmentación
        const ticket = useDataFromPrint 
          ? { header: this.datatoprint.header, body: this.datatoprint.body }
          : {
              header: this.buildHeaderData(),
              body: this.buildItemsData()
            };

        // Obtener customer
        const customer = this.selectedCustomer || {};

        console.log("Payload enviado a backend:", { ticket, customer });

        // Llamar al endpoint de impresión remota
        const response = await this.$API.printers.printTicket({
          ticket,
          customer
        });

        if (response.success) {
          console.log("Datos de impresoras obtenidos:", response);

          // Procesar ping e impresión en print-server para cada impresora
          if (response.printers && Array.isArray(response.printers)) {
            console.log(`Validando conectividad de ${response.printers.length} impresora(s)...`);

            const printerErrorsPing = [];  // Errores en conexión con print-server (PING)
            const printerErrorsPrint = [];  // Errores en conexión con impresora térmica (PRINT)

            for (const printer of response.printers) {
              try {
                // Paso 1: Hacer ping a la impresora
                const pingUrl = `http://${printer.Host}:${printer.Port}/ping`;
                console.log(`Haciendo ping a: ${pingUrl}`);

                const pingResponse = await fetch(pingUrl, {
                  method: 'GET',
                  signal: AbortSignal.timeout(5000)  // Timeout de 5 segundos
                });

                if (!pingResponse.ok) {
                  throw new Error(`Ping retornó status ${pingResponse.status}`);
                }

                console.log(`✓ Ping exitoso en ${printer.Name}`);

                // Paso 2: Si ping es exitoso, proceder con impresión real
                const printUrl = `http://${printer.Host}:${printer.Port}/print`;
                console.log(`Intentando impresión en: ${printUrl}`);

                // Construir ticket con SOLO los items de esta impresora
                const printerSpecificTicket = {
                  header: ticket.header,
                  body: printer.items || []  // Usar los items agrupados por el backend
                };

                const printResponse = await fetch(printUrl, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    host: printer.Host,
                    port: printer.Port,
                    printerName: printer.Name,
                    ticket: printerSpecificTicket,
                    customer
                  }),
                  signal: AbortSignal.timeout(5000)
                });

                if (printResponse.ok) {
                  const printData = await printResponse.json();
                  console.log(`✓ Impresión exitosa en ${printer.Name}:`, printData);
                } else {
                  console.error(`✗ Error imprimiendo en ${printer.Name}: Status ${printResponse.status}`);
                  printerErrorsPrint.push(printer.Name);
                }
              } catch (printerError) {
                // Determinar si fue error de PING o de PRINT
                if (printerError.message.includes('Ping') || printerError.message.includes('Failed to fetch')) {
                  console.error(`✗ Error de PING con ${printer.Name}: ${printerError.message}`);
                  printerErrorsPing.push(printer.Name);
                } else {
                  console.error(`✗ Error de PRINT con ${printer.Name}: ${printerError.message}`);
                  printerErrorsPrint.push(printer.Name);
                }
              }
            }

            // Mostrar alerta con errores diferenciados
            if (printerErrorsPing.length > 0 || printerErrorsPrint.length > 0) {
              let errorMessage = '';

              if (printerErrorsPing.length > 0) {
                const pingList = printerErrorsPing.join(', ');
                errorMessage += `Fallo al establecer conexión con el servidor de impresión para: ${pingList}`;
              }

              if (printerErrorsPrint.length > 0) {
                const printList = printerErrorsPrint.join(', ');
                if (errorMessage) {
                  errorMessage += '\n\nFallo la conexión con estas impresoras: ' + printList;
                } else {
                  errorMessage = '\n\nFallo la conexión con estas impresoras: ' + printList;
                }
              }
              
              this.showAlert('danger', 'Error de Impresión', errorMessage);
            }
          }
        } else {
          throw new Error(response.message || "Error al obtener datos de impresoras");
        }
      } catch(err) {
        console.log(err)
      }
    },
    async printInvoiceProcessOrContingency(idInvoice = null) {
      if (idInvoice && (this.invoiceResult.estado === "PROCESADO" || this.invoice.estado === "CONTINGENCIA")) {
        const user = JSON.parse(localStorage.getItem("user"));
        console.log("Payload for printInvoiceProcessOrContingency:", { idInvoice, useThermal: user?.useprinters === 1 });
        // Para facturas, usar impresión local (DTE requiere formato específico)
        await imprimirFactura(idInvoice, this);
      }
    },
    isValidDate(dateString) {
      if (!dateString) return true;
      const [day, month, year] = dateString.split("/");
      if (!day || !month || !year) return false;
      const dayNum = parseInt(day, 10);
      const monthNum = parseInt(month, 10);
      const yearNum = parseInt(year, 10);
      if (isNaN(dayNum) || isNaN(monthNum) || isNaN(yearNum)) return false;
      if (monthNum < 1 || monthNum > 12) return false;
      if (dayNum < 1 || dayNum > 31) return false;
      const date = new Date(yearNum, monthNum - 1, dayNum);
      return date.getFullYear() === yearNum && date.getMonth() === monthNum - 1 && date.getDate() === dayNum;
    },
    validateHeader() {
      if (this.$refs.headerForm) {
        this.headerHasErrors = !this.$refs.headerForm.validate();
      }
    },

    // === Split Invoice Methods ===
    calculateSplitInvoiceTotals(items) {
      // Calcula totales completos para un array de items específico
      // Replica exactamente la lógica de calculateInvoiceTotals()
      
      if (!items || items.length === 0) {
        return {
          subtotal: 0,
          gravados: 0,
          exentos: 0,
          noSujetos: 0,
          iva: 0,
          propina: 0,
          total: 0
        };
      }

      let gravados = 0;         // Items gravados (ANTES de IVA)
      let exentos = 0;          // Items exentos
      let noSujetos = 0;        // Items no sujetos
      let propina = 0;
      let gravadosSinPropinaBloqueada = 0;

      items.forEach(item => {
        const qty = parseFloat(item.ItemQuantity || 0);
        const price = parseFloat(item.ItemUnitPrice || 0);
        const itemTotal = qty * price;

        // Para simplificar, asumir que todos son gravados
        // En una implementación completa, se verificaría flags de exento/no sujeto
        gravados += itemTotal;
        if (!this.hasBlockedTipItem(item)) {
          gravadosSinPropinaBloqueada += itemTotal;
        }
      });

      // IMPORTANTE: La propina se calcula sobre el base imponible (sin IVA)
      // Igual que en calculateInvoiceTotals(), línea 5985
      // Si mostrado es $55 (con IVA), el base = $55 / 1.13 = $48.67
      const baseImponible = gravados / 1.13;
      const baseImponibleSinPropinaBloqueada = gravadosSinPropinaBloqueada / 1.13;

      // Calcular propina si está activada (sobre el base imponible, como se hace afuera)
      if (this.activarPropinas && this.porcentajePropinas > 0) {
        propina = parseFloat((baseImponibleSinPropinaBloqueada * (this.porcentajePropinas / 100)).toFixed(2));
      }

      // Calcular IVA sobre el base imponible
      const iva = parseFloat((baseImponible * 0.13).toFixed(2));

      // Subtotal (base imponible) + IVA = lo que se ve como gravados
      const subtotal = parseFloat((baseImponible + iva).toFixed(2));

      // Total a pagar: gravados (con IVA) + propina
      const total = parseFloat((subtotal + propina).toFixed(2));

      return {
        subtotal: parseFloat(subtotal.toFixed(2)),
        gravados: parseFloat(subtotal.toFixed(2)),
        exentos: parseFloat(exentos.toFixed(2)),
        noSujetos: parseFloat(noSujetos.toFixed(2)),
        iva: parseFloat(iva.toFixed(2)),
        propina: parseFloat(propina.toFixed(2)),
        total: parseFloat(total.toFixed(2))
      };
    },

    calculateHeaderTotalsForItems(items) {
      // Calcula totales en formato de header (igual que buildHeaderData())
      // Para usar en split invoice, SIN incluir propina
      if (!items || items.length === 0) {
        return {
          invoicesubtotalventas: 0,
          invoicesubtotal: 0,
          invoicemontototaloperacion: 0,
          invoicetotalexenta: 0,
          invoicetotalnosuj: 0,
          invoicetotalnogravada: 0,
          invoicetotalgravada: 0,
          invoicetotaliva: 0,
          invoicetotalpagar: 0
        };
      }

      let gravados = 0;
      let exentos = 0;
      let noSujetos = 0;
      let nogravada = 0;

      items.forEach(item => {
        const qty = parseFloat(item.ItemQuantity || 0);
        const price = parseFloat(item.ItemUnitPrice || 0);
        const itemTotal = qty * price;

        // Para split, asumir que todos son gravados (no tenemos flags)
        gravados += itemTotal;
      });

      // Base imponible (sin IVA)
      const baseImponible = gravados / 1.13;

      // IVA sobre la base imponible
      const iva = parseFloat((baseImponible * 0.13).toFixed(2));

      // Subtotal = base + IVA
      const subtotal = parseFloat((baseImponible + iva).toFixed(2));

      // Total a pagar = subtotal (sin propina en split)
      const totalPagar = subtotal;

      return {
        invoicesubtotalventas: parseFloat(subtotal.toFixed(2)),
        invoicesubtotal: parseFloat(subtotal.toFixed(2)),
        invoicemontototaloperacion: parseFloat(subtotal.toFixed(2)),
        invoicetotalexenta: parseFloat(exentos.toFixed(2)),
        invoicetotalnosuj: parseFloat(noSujetos.toFixed(2)),
        invoicetotalnogravada: parseFloat(nogravada.toFixed(2)),
        invoicetotalgravada: parseFloat(gravados.toFixed(2)),
        invoicetotaliva: iva,
        invoicetotalpagar: totalPagar
      };
    },

    openSplitInvoiceDialog() {
      if (!this.form.idinvoice || !this.productsToShow || this.productsToShow.length === 0) {
        this.showAlert('warning', 'Advertencia', 'Cargue una comanda primero');
        return;
      }



      this.showSplitInvoiceDialog = true;
      this.splitInvoiceTab = 0;
      this.selectedItemsForTransfer = [];
      this.currentCommandaItemsForTransfer = [];
      this.selectedExistingCommandaId = null;

      // Prepare items for transfer
      this.currentCommandaItemsForTransfer = this.productsToShow.map((item, index) => ({
        index,
        ID_Item: item.ID_Item || item.iditem,
        ItemDescription: item.ItemName || item.itemdescription,
        ItemQuantity: item.qty || item.itemquantity,
        ItemUnitPrice: parseFloat(item.ItemNewPrice || item.itemunitcost || item.itemunitprice || 0),
        quantityToTransfer: 0,
        itemTotal: (item.qty || item.itemquantity) * (parseFloat(item.ItemNewPrice || item.itemunitcost || item.itemunitprice || 0)),
        BloquearPropinas: item.BloquearPropinas || item.bloquearpropinas || item.prod?.BloquearPropinas || item.prod?.bloquearpropinas || 0,
        prod: item.prod || item
      }));

      // Set new command data with current customer info
      this.newCommandaData.invoiceDate = this.form.invoicedate;
      this.newCommandaData.customerName = this.form.legalname || this.form.invoicename;

      // Load existing comandas for selection
      this.loadActiveCommands().then(() => {
        this.existingCommandasList = this.activaCommands.map(cmd => ({
          ID_Invoice: cmd.ID_Invoice,
          commandaDisplay: `${cmd.ID_Invoice} - ${cmd.InvoiceName}`
        }));
      });
    },

    closeSplitInvoiceDialog() {
      this.showSplitInvoiceDialog = false;
      this.selectedItemsForTransfer = [];
      this.currentCommandaItemsForTransfer = [];
      this.selectedExistingCommandaId = null;
      this.selectedExistingComandaData = {
        header: null,
        items: [],
        totals: { subtotal: 0, gravados: 0, exentos: 0, noSujetos: 0, iva: 0, propina: 0, total: 0 }
      };
      this.splitInvoiceTab = 0;
    },

    loadExistingCommandaItems() {
      if (!this.selectedExistingCommandaId) {
        return;
      }
      
      try {
        // Step 1: Load header
        this.$API.invoices.getInvoice(this.selectedExistingCommandaId).then(async (invoice) => {
          // Step 2: Load items
          const items = await this.$API.invoices.getAllInvoiceItems(this.selectedExistingCommandaId);
          const hydratedItems = await this.hydrateBlockedTipFlags(items || []);
          
          // Step 3: Save data
          this.selectedExistingComandaData.header = invoice;
          this.selectedExistingComandaData.items = hydratedItems;
          
          // Step 4: Load totals from header (no need to recalculate - use saved totals)
          this.selectedExistingComandaData.totals = {
            invoicesubtotal: parseFloat(invoice?.InvoiceSubtotal || invoice?.invoicesubtotal || 0),
            invoicesubtotalventas: parseFloat(invoice?.InvoiceSubtotalVentas || invoice?.invoicesubtotalventas || 0),
            invoicetotalexenta: parseFloat(invoice?.InvoiceTotalExenta || invoice?.invoicetotalexenta || 0),
            invoicetotalnosuj: parseFloat(invoice?.InvoiceTotalNoSuj || invoice?.invoicetotalnosuj || 0),
            invoicetotalnogravada: parseFloat(invoice?.InvoiceTotalNoGravada || invoice?.invoicetotalnogravada || 0),
            invoicetotalgravada: parseFloat(invoice?.InvoiceTotalGravada || invoice?.invoicetotalgravada || 0),
            invoicetotaliva: parseFloat(invoice?.InvoiceTotalIVA || invoice?.invoicetotaliva || 0),
            invoicetotalpagar: parseFloat(invoice?.InvoiceTotalPagar || invoice?.invoicetotalpagar || 0),
            invoiceivarete1: parseFloat(invoice?.InvoiceIVARete1 || invoice?.invoiceivarete1 || 0),
            invoiceivaperce1: parseFloat(invoice?.InvoiceIVAPerce1 || invoice?.invoiceivaperce1 || 0),
            propina: parseFloat(invoice?.InvoicePropinas || invoice?.propina || 0)
          };
          
        }).catch(err => {
          this.showAlert('danger', 'Error', 'No se pudo cargar la comanda existente: ' + err);
        });
      } catch (err) {
        this.showAlert('danger', 'Error', 'Error al cargar items de la comanda: ' + err.message);
      }
    },

    async executeInvoiceSplit() {
      try {
        // Validate selection
        if (this.selectedItemsForTransfer.length === 0) {
          this.showAlert('warning', 'Advertencia', 'Seleccione al menos un item para transferir');
          return;
        }

        // Validate quantity for each selected item
        for (const selectedItem of this.selectedItemsForTransfer) {
          const itemData = this.currentCommandaItemsForTransfer.find(i => i.ID_Item === selectedItem.ID_Item);
          if (!itemData || itemData.quantityToTransfer <= 0 || itemData.quantityToTransfer > itemData.ItemQuantity) {
            this.showAlert('danger', 'Error', `Cantidad inválida para ${itemData.ItemDescription}`);
            return;
          }
        }

        this.saving = true;
        this.showSplitInvoiceDialog = false;

        // === STEP 1: Get items to transfer and items that remain ===
        const itemsToTransfer = this.currentCommandaItemsForTransfer
          .filter(item => this.selectedItemsForTransfer.some(s => s.ID_Item === item.ID_Item))
          .map(item => ({
            ID_Item: item.ID_Item,
            ItemQuantity: item.quantityToTransfer,
            ItemUnitPrice: item.ItemUnitPrice
          }));

        const itemsRemaining = this.currentCommandaItemsForTransfer
          .filter(item => !this.selectedItemsForTransfer.some(s => s.ID_Item === item.ID_Item) || 
                          (item.quantityToTransfer < item.ItemQuantity))
          .map(item => {
            const transferQty = this.selectedItemsForTransfer.find(s => s.ID_Item === item.ID_Item)?.quantityToTransfer || 0;
            const remainingQty = item.ItemQuantity - transferQty;
            
            if (remainingQty <= 0) return null;
            
            return {
              ID_Item: item.ID_Item,
              ItemQuantity: remainingQty,
              ItemUnitPrice: item.ItemUnitPrice
            };
          })
          .filter(item => item !== null);

        // === STEP 2: Calculate totals for transferred items (destino) ===
        const transferredItemsForCalc = itemsToTransfer.map(item => ({
          ItemQuantity: item.ItemQuantity,
          ItemUnitPrice: item.ItemUnitPrice
        }));
        const destinationTotals = this.calculateHeaderTotalsForItems(transferredItemsForCalc);

        // === STEP 3: Calculate totals for remaining items (current) ===
        const remainingItemsForCalc = itemsRemaining.map(item => ({
          ItemQuantity: item.ItemQuantity,
          ItemUnitPrice: item.ItemUnitPrice
        }));
        const currentTotals = this.calculateHeaderTotalsForItems(remainingItemsForCalc);

        // === STEP 4: Build destination items with full details ===
        const destinationDetailedItems = this.currentCommandaItemsForTransfer
          .filter(item => this.selectedItemsForTransfer.some(s => s.ID_Item === item.ID_Item))
          .map(item => {
            const price = parseFloat(item.ItemUnitPrice || 0);
            const qty = item.quantityToTransfer || 0;
            const itemTotal = qty * price;
            return {
              ID_Item: item.ID_Item,
              ItemType: 'product',
              ItemQuantity: qty,
              ItemDescription: item.ItemDescription,
              ItemUnitPrice: price,
              ItemMeasureUnit: '',
              ItemDiscount: 0,
              ItemDiscountPercent: 0,
              ItemNoSuj: 0,
              ItemExenta: 0,
              ItemGravada: itemTotal,
              ItemPsv: 0,
              ItemNoGravada: 0,
              ItemIVA: itemTotal * 0.13,
              ItemCurrency: '$',
              Warehouse: '',
              IsGlobalBranch: 0
            };
          });

        // Build payload
        const payload = {
          currentInvoice: {
            invoiceId: this.form.idinvoice,
            items: itemsToTransfer,
            remainingItems: itemsRemaining,
            headerTotals: currentTotals  // Totals for remaining items
          },
          destinationInvoice: {
            type: this.splitInvoiceTab === 0 ? 'NEW' : 'EXISTING',
            invoiceId: this.selectedExistingCommandaId,
            header: this.splitInvoiceTab === 0 ? {
              invoicetype: 'FCF',
              invoicedate: this.form.invoicedate,
              idcustomer: this.form.idcustomer,
              invoicename: this.form.legalname || this.form.invoicename,
              invoiceaddress: this.form.legaladdress,
              invoicenit: this.form.legalnit,
              invoicenrc: this.form.legalnrc,
              invoicecreditday: this.form.invoicecreditday,
              posrestaurant: 1  // Nueva comanda destino es tipo COM (comanda)
            } : null,
            items: destinationDetailedItems,
            headerTotals: destinationTotals  // Totals for transferred items
          }
        };

        // Call API
        const result = await this.$API.invoices.splitInvoiceItems(payload);

        if (result.success) {
          this.showAlert(
            'success',
            'Éxito',
            `Ítems transferidos exitosamente.`
          );

          // Reload current comanda
          await this.loadComanda(this.form.idinvoice);
          
          // Close dialog
          this.closeSplitInvoiceDialog();
        } else {
          this.showAlert('danger', 'Error', result.message || 'No se pudo transferir los ítems');
        }
      } catch (error) {
        this.showAlert('danger', 'Error', error.message || 'Error al transferir ítems: ' + error);
      } finally {
        this.saving = false;
      }
    },

    decrementTransferQuantity(index) {
      if (index >= 0 && index < this.currentCommandaItemsForTransfer.length) {
        const current = this.currentCommandaItemsForTransfer[index].quantityToTransfer || 0;
        if (current > 0) {
          this.$set(this.currentCommandaItemsForTransfer[index], 'quantityToTransfer', current - 1);
        }
      }
    },

    incrementTransferQuantity(index) {
      if (index >= 0 && index < this.currentCommandaItemsForTransfer.length) {
        const item = this.currentCommandaItemsForTransfer[index];
        const current = item.quantityToTransfer || 0;
        const max = item.ItemQuantity || 0;
        if (current < max) {
          this.$set(this.currentCommandaItemsForTransfer[index], 'quantityToTransfer', current + 1);
        }
      }
    },

    updateTransferQuantity(index, event) {
      if (index >= 0 && index < this.currentCommandaItemsForTransfer.length) {
        const item = this.currentCommandaItemsForTransfer[index];
        let value = parseInt(event.target.value) || 0;
        const max = item.ItemQuantity || 0;
        
        // Ensure within bounds
        if (value < 0) value = 0;
        if (value > max) value = max;
        
        this.$set(this.currentCommandaItemsForTransfer[index], 'quantityToTransfer', value);
      }
    },
  },
  async mounted() {
    try {
      this.validateHeader(); // Validar inicialmente para mostrar errores si hay
      // Inicializar business y branch primero
      this.initializeBusinessAndBranch();
      
      // Cargar información de rama (como Create.vue hace)
      await this.getInfoBranch();
      
      // Cargar lista de vendedores (como Create.vue hace)
      await this.getAllSellers();
      
      // Cargar datos del cliente
      await this.getAllCustomers();
      await this.loadAllCustomers();
      await this.getPaymentTypesValues();
      
      // Cargar comandas activas para aplicar restricciones de mesas
      await this.loadActiveCommands();
      
      // Cargar familias paginadas al montar el componente
      await this.loadFamiliesPage(1, true);
      
      // Cargar almacenes y listas de precios
      await this.getWarehouse();
      await this.getAllPriceList();
      
      // Cargar factura si está disponible en el store
      this.loadInvoiceFromStore();

      if(this.isCoffeBike && !this.form.idcustomer && !this.selectedCustomer)
        this.searchSeveralCustomer();
      
      // Validar header después de cargar todo
      this.validateHeader();
    } catch (error) {
      console.error("Error en mounted:", error);
    }
  },
};
</script>

<style scoped>
.white {
  background-color: white !important;
}

.bg-primary-light {
  background-color: rgba(25, 118, 210, 0.08);
}

.gap-2 {
  gap: 8px;
}

.text-right-input >>> input {
  text-align: right !important;
}

.red-text {
  color: red;
}

.black-text {
  color: black;
}

::v-deep .v-card__title.text-danger {
  background-color: #E3191E !important;
  color: white !important;
}

::v-deep .v-card__title.text-success {
  background-color: #00C853 !important;
  color: white !important;
}

::v-deep .v-card__title.text-warning {
  background-color: #FB8C00 !important;
  color: white !important;
}

::v-deep .v-card__text {
  font-size: 1rem;
}
.customer-actions {
  gap: 8px;
}
.selector-actions{
  gap: 8px;
}

.invoice-item-price-flags {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 280px;
  min-width: 0;
}

.invoice-item-price {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 0 1 auto;
  min-width: 0;
}

.invoice-item-tax-flags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 8px;
  flex: 1 1 300px;
  min-width: 0;
}

.invoice-item-tax-flag {
  flex: 1 1 125px;
  min-width: 125px;
  margin: 0 !important;
  padding: 0 !important;
}

@media (max-width: 600px) {
  .pos-summary-card {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .pos-summary-breakdown {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .pos-summary-value {
    flex: 0 0 50% !important;
    max-width: 50% !important;
    width: 50% !important;
    padding: 6px 4px !important;
  }

  .pos-summary-value > div > div:first-child {
    font-size: 0.8em !important;
  }

  .pos-summary-value > div > div:last-child {
    font-size: 1.45em !important;
    white-space: nowrap;
  }

  .pos-summary-tip {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    width: 100% !important;
    padding: 6px 0 0 !important;
  }

  .pos-summary-tip .d-flex,
  .pos-summary-tip .v-input {
    justify-content: center;
  }

  .pos-summary-tip .v-text-field {
    max-width: 96px;
  }

  .pos-totals-row {
    flex-direction: column;
    gap: 6px !important;
  }

  .pos-total-item,
  .pos-grand-total {
    width: 100%;
    min-width: 0 !important;
    padding: 8px 12px !important;
  }

  .pos-total-item > div:last-child {
    font-size: 1.8em !important;
    white-space: nowrap;
  }

  .pos-grand-total > div:last-child {
    font-size: 2.2em !important;
    white-space: nowrap;
  }

  .pos-action-row {
    display: flex;
    flex-direction: column;
  }

  .pos-action-col {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    width: 100% !important;
  }

  .pos-action-btn {
    white-space: normal !important;
    min-height: 40px;
  }

  .customer-actions {
    justify-content: flex-start !important;
  }

  .customer-actions .v-btn {
    margin-left: 0 !important;
    margin-bottom: 4px;
  }

  .selector-actions {
    justify-content: flex-start !important;
  }

  .invoice-item-row {
    flex-wrap: wrap !important;
  }

  .invoice-item-main {
    width: 100%;
  }

  .invoice-item-actions {
    width: 100%;
    justify-content: flex-start !important;
  }

  .invoice-item-price-flags {
    align-items: flex-start;
    flex-direction: column;
    flex-basis: 100%;
    width: 100%;
  }

  .invoice-item-price {
    width: 100%;
  }

  .invoice-item-tax-flags {
    width: 100%;
    flex-basis: 100%;
  }

  .invoice-item-tax-flag {
    flex: 1 1 125px;
  }
}
</style>
